// 自动生成的翻译键类型定义
// 生成时间: 2026-04-23T07:39:25.937Z
// 不要手动编辑此文件，运行 generate-types.js 重新生成

// 命名空间类型
export type TranslationNamespace = 'common' | 'pages' | 'modules' | 'components' | 'errors' | 'validation';


// 命名空间: common
export type CommonKeys =
  | 'app.fullName'
  | 'app.name'
  | 'app.shortName'
  | 'app.version'
  | 'auth.checkingAuthStatus'
  | 'auth.loadingUserInfo'
  | 'back'
  | 'backToHome'
  | 'cancel'
  | 'close'
  | 'confirm'
  | 'delete'
  | 'edit'
  | 'error'
  | 'errors.adminRoleRequired'
  | 'errors.currentUserRole'
  | 'errors.insufficientPermissions'
  | 'errors.noPermissionDescription'
  | 'errors.requiredPermissions'
  | 'filter'
  | 'help.about'
  | 'help.aboutModal.address'
  | 'help.aboutModal.addressValue'
  | 'help.aboutModal.company'
  | 'help.aboutModal.companyLabel'
  | 'help.aboutModal.contact'
  | 'help.aboutModal.copyright'
  | 'help.aboutModal.productName'
  | 'help.aboutModal.title'
  | 'help.aboutModal.version'
  | 'help.feedback'
  | 'help.feedbackModal.content'
  | 'help.feedbackModal.contentPlaceholder'
  | 'help.feedbackModal.submitSuccess'
  | 'help.feedbackModal.title'
  | 'help.feedbackModal.type'
  | 'help.feedbackModal.type.bug'
  | 'help.feedbackModal.type.feature'
  | 'help.feedbackModal.type.other'
  | 'help.feedbackModal.type.ui'
  | 'help.feedbackModal.typePlaceholder'
  | 'language.current'
  | 'language.en-US'
  | 'language.pt-BR'
  | 'language.switch'
  | 'language.zh-CN'
  | 'loading'
  | 'loadingResources'
  | 'loadingSystem'
  | 'more'
  | 'next'
  | 'notification.clearAll'
  | 'notification.connector.deleted.body'
  | 'notification.connector.deleted.title'
  | 'notification.connector.error.body'
  | 'notification.connector.error.title'
  | 'notification.connector.saved.body'
  | 'notification.connector.saved.title'
  | 'notification.empty'
  | 'notification.level.error'
  | 'notification.level.info'
  | 'notification.level.success'
  | 'notification.level.warning'
  | 'notification.markAllRead'
  | 'notification.title'
  | 'pageNotFound'
  | 'refresh'
  | 'reset'
  | 'restoringSession'
  | 'role.admin'
  | 'role.company_admin'
  | 'role.guest'
  | 'role.regular_user'
  | 'role.super_admin'
  | 'role.unknown'
  | 'role.user'
  | 'save'
  | 'saved'
  | 'saving'
  | 'search'
  | 'submit'
  | 'success'
  | 'time.ago'
  | 'time.day'
  | 'time.hour'
  | 'time.justNow'
  | 'time.minute'
  | 'time.month'
  | 'time.second'
  | 'time.week'
  | 'time.year'
  | 'user.logout'
  | 'user.profile'
  | 'user.settings'
  | 'view';

// 命名空间: pages
export type PagesKeys =
  | 'login.accountDisabled'
  | 'login.copyright'
  | 'login.forgotPassword'
  | 'login.invalidCredentials'
  | 'login.loggingIn'
  | 'login.loginButton'
  | 'login.loginError'
  | 'login.loginFailed'
  | 'login.noAccount'
  | 'login.or'
  | 'login.password'
  | 'login.passwordMinLength'
  | 'login.passwordPlaceholder'
  | 'login.passwordRequired'
  | 'login.privacyLink'
  | 'login.registerButton'
  | 'login.subtitle'
  | 'login.support'
  | 'login.terms'
  | 'login.termsLink'
  | 'login.title'
  | 'login.tooManyAttempts'
  | 'login.username'
  | 'login.usernameMaxLength'
  | 'login.usernameMinLength'
  | 'login.usernamePlaceholder'
  | 'login.usernameRequired'
  | 'profile.buttons.cancel'
  | 'profile.buttons.changePassword'
  | 'profile.buttons.editProfile'
  | 'profile.buttons.saveChanges'
  | 'profile.fields.accountStatus'
  | 'profile.fields.companyDescription'
  | 'profile.fields.companyName'
  | 'profile.fields.confirmPassword'
  | 'profile.fields.creationTime'
  | 'profile.fields.currentPassword'
  | 'profile.fields.email'
  | 'profile.fields.emailNotSet'
  | 'profile.fields.newPassword'
  | 'profile.fields.noDescription'
  | 'profile.fields.notSet'
  | 'profile.fields.registrationTime'
  | 'profile.fields.role'
  | 'profile.fields.unknown'
  | 'profile.fields.userId'
  | 'profile.fields.username'
  | 'profile.messages.companyInfoNote'
  | 'profile.messages.passwordChangeFailed'
  | 'profile.messages.passwordChangeSuccess'
  | 'profile.messages.passwordSecurityAdvice'
  | 'profile.messages.updateFailed'
  | 'profile.messages.updateSuccess'
  | 'profile.placeholders.confirmPassword'
  | 'profile.placeholders.currentPassword'
  | 'profile.placeholders.email'
  | 'profile.placeholders.newPassword'
  | 'profile.placeholders.username'
  | 'profile.sections.changePassword'
  | 'profile.status.active'
  | 'profile.status.inactive'
  | 'profile.subtitle'
  | 'profile.tabs.company'
  | 'profile.tabs.profile'
  | 'profile.tabs.security'
  | 'profile.title'
  | 'profile.validation.currentPasswordRequired'
  | 'profile.validation.emailInvalid'
  | 'profile.validation.passwordMinLength'
  | 'profile.validation.passwordMismatch'
  | 'profile.validation.passwordRequired'
  | 'profile.validation.usernameMaxLength'
  | 'profile.validation.usernameMinLength'
  | 'profile.validation.usernameRequired'
  | 'register.accountInfo'
  | 'register.adminPermission1'
  | 'register.adminPermission2'
  | 'register.adminPermission3'
  | 'register.adminPermission4'
  | 'register.adminPermissions'
  | 'register.agreeTerms'
  | 'register.agreeTermsRequired'
  | 'register.alreadyHaveAccount'
  | 'register.alreadyHaveAccountText'
  | 'register.companyDescription'
  | 'register.companyDescriptionField'
  | 'register.companyDescriptionMaxLength'
  | 'register.companyDescriptionPlaceholder'
  | 'register.companyInfo'
  | 'register.companyName'
  | 'register.companyNameMaxLength'
  | 'register.companyNameMinLength'
  | 'register.companyNamePlaceholder'
  | 'register.companyNameRequired'
  | 'register.confirmPassword'
  | 'register.confirmPasswordMismatch'
  | 'register.confirmPasswordPlaceholder'
  | 'register.confirmPasswordRequired'
  | 'register.copyright'
  | 'register.email'
  | 'register.emailInvalid'
  | 'register.emailPlaceholder'
  | 'register.emailRequired'
  | 'register.loginButton'
  | 'register.password'
  | 'register.passwordPlaceholder'
  | 'register.passwordRequired'
  | 'register.passwordRequirement1'
  | 'register.passwordRequirement2'
  | 'register.passwordRequirement3'
  | 'register.passwordRequirement4'
  | 'register.passwordRequirements'
  | 'register.passwordStrengthEnough'
  | 'register.passwordStrengthMinLength'
  | 'register.passwordStrengthNumbers'
  | 'register.passwordStrengthSpecial'
  | 'register.passwordStrengthUpperLower'
  | 'register.privacyLink'
  | 'register.registerButton'
  | 'register.registerError'
  | 'register.registerFailed'
  | 'register.registerSuccess'
  | 'register.registering'
  | 'register.subtitle'
  | 'register.support'
  | 'register.terms'
  | 'register.termsLink'
  | 'register.title'
  | 'register.username'
  | 'register.usernameMaxLength'
  | 'register.usernameMinLength'
  | 'register.usernamePlaceholder'
  | 'register.usernameRequired'
  | 'register.usernameTaken'
  | 'userManagement.buttons.activate'
  | 'userManagement.buttons.deactivate'
  | 'userManagement.buttons.delete'
  | 'userManagement.buttons.edit'
  | 'userManagement.buttons.refresh'
  | 'userManagement.createSuccess'
  | 'userManagement.createUser'
  | 'userManagement.currentUser'
  | 'userManagement.deleteConfirm.cancelText'
  | 'userManagement.deleteConfirm.description'
  | 'userManagement.deleteConfirm.okText'
  | 'userManagement.deleteConfirm.title'
  | 'userManagement.fetchFailed'
  | 'userManagement.loading'
  | 'userManagement.messages.activateFailed'
  | 'userManagement.messages.activateSuccess'
  | 'userManagement.messages.deactivateFailed'
  | 'userManagement.messages.deactivateSuccess'
  | 'userManagement.messages.deleteFailed'
  | 'userManagement.messages.deleteSuccess'
  | 'userManagement.messages.editInfo'
  | 'userManagement.neverLoggedIn'
  | 'userManagement.noData'
  | 'userManagement.noPermission'
  | 'userManagement.pagination.showTotal'
  | 'userManagement.refresh'
  | 'userManagement.searchPlaceholder'
  | 'userManagement.status.active'
  | 'userManagement.status.inactive'
  | 'userManagement.table.columns.actions'
  | 'userManagement.table.columns.createdAt'
  | 'userManagement.table.columns.email'
  | 'userManagement.table.columns.lastLogin'
  | 'userManagement.table.columns.role'
  | 'userManagement.table.columns.status'
  | 'userManagement.table.columns.username'
  | 'userManagement.title';

// 命名空间: modules
export type ModulesKeys =
  | 'agentConfig.forbiddenWords.count'
  | 'agentConfig.forbiddenWords.placeholder'
  | 'agentConfig.forbiddenWords.saveFailed'
  | 'agentConfig.forbiddenWords.saveSuccess'
  | 'agentConfig.forbiddenWords.tip'
  | 'agentConfig.policies.add'
  | 'agentConfig.policies.content'
  | 'agentConfig.policies.contentHelp'
  | 'agentConfig.policies.contentPlaceholder'
  | 'agentConfig.policies.created'
  | 'agentConfig.policies.deleteConfirm'
  | 'agentConfig.policies.deleteSuccess'
  | 'agentConfig.policies.description'
  | 'agentConfig.policies.descriptionHelp'
  | 'agentConfig.policies.descriptionPlaceholder'
  | 'agentConfig.policies.edit'
  | 'agentConfig.policies.empty'
  | 'agentConfig.policies.emptyDescription'
  | 'agentConfig.policies.isActive'
  | 'agentConfig.policies.name'
  | 'agentConfig.policies.namePlaceholder'
  | 'agentConfig.policies.priority'
  | 'agentConfig.policies.saveSuccess'
  | 'agentConfig.policies.title'
  | 'agentConfig.policies.updated'
  | 'agentConfig.tabs.forbiddenWords'
  | 'agentConfig.tabs.policies'
  | 'agentConfig.tabs.style'
  | 'chatWindow.loadFailed'
  | 'chatWindow.loadingMessages'
  | 'chatWindow.noMessages'
  | 'chatWindow.role.assistant'
  | 'chatWindow.role.human'
  | 'chatWindow.role.system'
  | 'chatWindow.role.user'
  | 'chatWindow.selectConversation'
  | 'chatbot.alerts.connected'
  | 'chatbot.alerts.connecting'
  | 'chatbot.alerts.disconnected'
  | 'chatbot.alerts.error'
  | 'chatbot.alerts.ready'
  | 'chatbot.context.empty'
  | 'chatbot.context.error'
  | 'chatbot.context.refresh'
  | 'chatbot.context.title'
  | 'chatbot.empty.noMessages'
  | 'chatbot.input.ariaLabel'
  | 'chatbot.input.placeholder'
  | 'chatbot.input.send'
  | 'chatbot.input.sendAriaLabel'
  | 'chatbot.input.sending'
  | 'chatbot.messages.bot'
  | 'chatbot.messages.typing'
  | 'chatbot.messages.user'
  | 'chatbot.title'
  | 'chatbot.welcomeMessage'
  | 'common.cancel'
  | 'common.confirm'
  | 'common.edit'
  | 'common.save'
  | 'company.cancel'
  | 'company.createdAt'
  | 'company.descMaxLength'
  | 'company.descPlaceholder'
  | 'company.description'
  | 'company.editInfo'
  | 'company.fetchError'
  | 'company.id'
  | 'company.loading'
  | 'company.name'
  | 'company.nameMaxLength'
  | 'company.namePlaceholder'
  | 'company.nameRequired'
  | 'company.noDescription'
  | 'company.noInfo'
  | 'company.noPermission'
  | 'company.save'
  | 'company.title'
  | 'company.updateFailed'
  | 'company.updateSuccess'
  | 'company.updatedAt'
  | 'connectors.addConnector'
  | 'connectors.addFirst'
  | 'connectors.connectionFailed'
  | 'connectors.connectionHealthy'
  | 'connectors.deleteFailed'
  | 'connectors.deleted'
  | 'connectors.emptyDescription'
  | 'connectors.refresh'
  | 'connectors.testFailed'
  | 'connectors.title'
  | 'conversationList.empty'
  | 'conversationList.time.hours'
  | 'conversationList.time.minutes'
  | 'conversationList.time.seconds'
  | 'conversationList.title'
  | 'dashboard.platformDistribution'
  | 'dashboard.statistics.activeUsers'
  | 'dashboard.statistics.avgMessagesPerConv'
  | 'dashboard.statistics.avgResponseTime'
  | 'dashboard.statistics.customers'
  | 'dashboard.statistics.satisfactionRate'
  | 'dashboard.statistics.totalConversations'
  | 'dashboard.statistics.totalMessages'
  | 'dashboard.system.connectors'
  | 'dashboard.system.platformIntegrations'
  | 'dashboard.system.title'
  | 'dashboard.system.users'
  | 'dashboard.tables.columns.agent'
  | 'dashboard.tables.columns.customer'
  | 'dashboard.tables.columns.duration'
  | 'dashboard.tables.columns.messages'
  | 'dashboard.tables.columns.platform'
  | 'dashboard.tables.columns.satisfaction'
  | 'dashboard.tables.columns.status'
  | 'dashboard.tables.columns.time'
  | 'dashboard.tables.emptyText'
  | 'dashboard.tables.filterLowScore'
  | 'dashboard.tables.recentConversations'
  | 'dashboard.title'
  | 'dashboard.today.conversations'
  | 'dashboard.today.knowledgeChunks'
  | 'dashboard.today.knowledgeDocs'
  | 'dashboard.today.lowSatisfaction'
  | 'dashboard.today.messages'
  | 'dashboard.today.title'
  | 'dashboard.units.people'
  | 'dashboard.units.percentage'
  | 'dashboard.units.seconds'
  | 'dashboard.units.times'
  | 'history.agentTypes.AI'
  | 'history.agentTypes.Human'
  | 'history.agentTypes.all'
  | 'history.buttons.close'
  | 'history.buttons.export'
  | 'history.buttons.reset'
  | 'history.buttons.search'
  | 'history.buttons.view'
  | 'history.filters.agentType'
  | 'history.filters.allStatus'
  | 'history.filters.dateRange.endDate'
  | 'history.filters.dateRange.startDate'
  | 'history.filters.status'
  | 'history.messages.error'
  | 'history.modals.agent'
  | 'history.modals.agentDepartment'
  | 'history.modals.agentInfo'
  | 'history.modals.agentName'
  | 'history.modals.agentType'
  | 'history.modals.conversationContent'
  | 'history.modals.conversationSummary'
  | 'history.modals.customer'
  | 'history.modals.customerEmail'
  | 'history.modals.customerInfo'
  | 'history.modals.customerLocation'
  | 'history.modals.customerName'
  | 'history.modals.customerPhone'
  | 'history.modals.customerSegment'
  | 'history.modals.detailTitle'
  | 'history.modals.noContactInfo'
  | 'history.modals.noConversationContent'
  | 'history.modals.noEvaluation'
  | 'history.modals.regularUser'
  | 'history.modals.unknownLocation'
  | 'history.satisfaction.notEvaluated'
  | 'history.satisfaction.stars'
  | 'history.search.placeholder'
  | 'history.sort.bySatisfaction'
  | 'history.sort.byTime'
  | 'history.status.cancelled'
  | 'history.status.completed'
  | 'history.status.default'
  | 'history.status.ongoing'
  | 'history.table.columns.actions'
  | 'history.table.columns.agentType'
  | 'history.table.columns.customer'
  | 'history.table.columns.duration'
  | 'history.table.columns.satisfaction'
  | 'history.table.columns.status'
  | 'history.table.columns.tags'
  | 'history.table.columns.time'
  | 'history.table.emptyText'
  | 'history.table.loadingText'
  | 'history.title'
  | 'humanList.active.disabled'
  | 'humanList.active.enabled'
  | 'humanList.col.action'
  | 'humanList.col.displayName'
  | 'humanList.col.isActive'
  | 'humanList.col.load'
  | 'humanList.col.status'
  | 'humanList.col.username'
  | 'humanList.empty'
  | 'humanList.status.busy'
  | 'humanList.status.offline'
  | 'humanList.status.online'
  | 'humanList.toggleConfirm.disable'
  | 'humanList.toggleConfirm.enable'
  | 'humanList.toggleFailed'
  | 'humanList.toggleSuccess.disabled'
  | 'humanList.toggleSuccess.enabled'
  | 'humanLogin.companyId'
  | 'humanLogin.companyIdPlaceholder'
  | 'humanLogin.companyIdRequired'
  | 'humanLogin.loginFailed'
  | 'humanLogin.password'
  | 'humanLogin.passwordPlaceholder'
  | 'humanLogin.passwordRequired'
  | 'humanLogin.submit'
  | 'humanLogin.title'
  | 'humanLogin.username'
  | 'humanLogin.usernamePlaceholder'
  | 'humanLogin.usernameRequired'
  | 'humanWorkspace.customerName'
  | 'humanWorkspace.logout'
  | 'humanWorkspace.takingOver'
  | 'humanWorkspace.title'
  | 'humanWorkspace.waitingTakeover'
  | 'humanWorkspace.wsDisconnected'
  | 'knowledge.buttons.addKnowledge'
  | 'knowledge.buttons.deleteDocument'
  | 'knowledge.buttons.documentList'
  | 'knowledge.buttons.extractionTest'
  | 'knowledge.buttons.importFile'
  | 'knowledge.buttons.uploading'
  | 'knowledge.buttons.viewDetails'
  | 'knowledge.dateFormat.locale'
  | 'knowledge.extractionTest.chunk'
  | 'knowledge.extractionTest.collapse'
  | 'knowledge.extractionTest.expand'
  | 'knowledge.extractionTest.knowledgeDocuments'
  | 'knowledge.extractionTest.loading'
  | 'knowledge.extractionTest.matchedResults'
  | 'knowledge.extractionTest.metadata'
  | 'knowledge.extractionTest.noResults'
  | 'knowledge.extractionTest.noResultsDescription'
  | 'knowledge.extractionTest.queryPlaceholder'
  | 'knowledge.extractionTest.querySummary'
  | 'knowledge.extractionTest.resetQuery'
  | 'knowledge.extractionTest.results'
  | 'knowledge.extractionTest.searchParamK'
  | 'knowledge.extractionTest.similarityScore'
  | 'knowledge.extractionTest.source'
  | 'knowledge.extractionTest.startTest'
  | 'knowledge.extractionTest.testQuery'
  | 'knowledge.extractionTest.testQueryDescription'
  | 'knowledge.extractionTest.title'
  | 'knowledge.extractionTest.unknown'
  | 'knowledge.extractionTest.waitingInput'
  | 'knowledge.extractionTest.waitingInputDescription'
  | 'knowledge.fileTypes.unknown'
  | 'knowledge.messages.deleteConfirmContent'
  | 'knowledge.messages.deleteConfirmTitle'
  | 'knowledge.messages.deleteFailed'
  | 'knowledge.messages.fileSizeExceeded'
  | 'knowledge.messages.unsupportedFileType'
  | 'knowledge.messages.uploadFailed'
  | 'knowledge.messages.uploadInstructions'
  | 'knowledge.messages.uploadSuccess'
  | 'knowledge.search.placeholder'
  | 'knowledge.status.active'
  | 'knowledge.status.completed'
  | 'knowledge.status.embedding'
  | 'knowledge.status.failed'
  | 'knowledge.status.parsing'
  | 'knowledge.status.pending'
  | 'knowledge.status.persisting'
  | 'knowledge.status.semantic_processing'
  | 'knowledge.status.unknown'
  | 'knowledge.table.columns.actions'
  | 'knowledge.table.columns.chunks'
  | 'knowledge.table.columns.createdAt'
  | 'knowledge.table.columns.description'
  | 'knowledge.table.columns.fileName'
  | 'knowledge.table.columns.fileSize'
  | 'knowledge.table.columns.fileType'
  | 'knowledge.table.columns.status'
  | 'knowledge.table.emptyText'
  | 'knowledge.table.loadingText'
  | 'knowledge.title'
  | 'messageInput.closeBtn'
  | 'messageInput.closeConfirmCancel'
  | 'messageInput.closeConfirmDesc'
  | 'messageInput.closeConfirmOk'
  | 'messageInput.closeConfirmTitle'
  | 'messageInput.placeholder'
  | 'messageInput.sendBtn'
  | 'navigation.chatbot'
  | 'navigation.dashboard'
  | 'navigation.history'
  | 'navigation.knowledge'
  | 'navigation.pageTitles.agentConfig'
  | 'navigation.pageTitles.chatbot'
  | 'navigation.pageTitles.companies'
  | 'navigation.pageTitles.dashboard'
  | 'navigation.pageTitles.default'
  | 'navigation.pageTitles.help'
  | 'navigation.pageTitles.history'
  | 'navigation.pageTitles.knowledge'
  | 'navigation.pageTitles.notifications'
  | 'navigation.pageTitles.profile'
  | 'navigation.pageTitles.settings'
  | 'navigation.pageTitles.users'
  | 'navigation.settings'
  | 'navigation.user_management'
  | 'order.config.connection.apiKey'
  | 'order.config.connection.apiKeyRequired'
  | 'order.config.connection.apiUrl'
  | 'order.config.connection.apiUrlRequired'
  | 'order.config.connection.authType'
  | 'order.config.connection.authTypeRequired'
  | 'order.config.connection.database'
  | 'order.config.connection.databaseRequired'
  | 'order.config.connection.host'
  | 'order.config.connection.hostRequired'
  | 'order.config.connection.password'
  | 'order.config.connection.passwordRequired'
  | 'order.config.connection.port'
  | 'order.config.connection.portRequired'
  | 'order.config.connection.title'
  | 'order.config.connection.username'
  | 'order.config.connection.usernameRequired'
  | 'order.config.dataSource.title'
  | 'order.config.dataSource.type'
  | 'order.config.dataSource.typeRequired'
  | 'order.config.save.success'
  | 'order.config.saveConfig'
  | 'order.config.subtitle'
  | 'order.config.sync.daily'
  | 'order.config.sync.frequency'
  | 'order.config.sync.frequencyRequired'
  | 'order.config.sync.hourly'
  | 'order.config.sync.manual'
  | 'order.config.sync.realtime'
  | 'order.config.sync.retryCount'
  | 'order.config.sync.title'
  | 'order.config.test.success'
  | 'order.config.test.unhealthy'
  | 'order.config.testConnection'
  | 'order.config.title'
  | 'order.detail.createdAt'
  | 'order.detail.edit'
  | 'order.detail.editOrder'
  | 'order.detail.info.avgPrice'
  | 'order.detail.info.basicTitle'
  | 'order.detail.info.createdAt'
  | 'order.detail.info.currency'
  | 'order.detail.info.customerAddress'
  | 'order.detail.info.customerEmail'
  | 'order.detail.info.customerId'
  | 'order.detail.info.customerName'
  | 'order.detail.info.customerPhone'
  | 'order.detail.info.customerTitle'
  | 'order.detail.info.deliveredAt'
  | 'order.detail.info.deliveryTitle'
  | 'order.detail.info.estimatedDelivery'
  | 'order.detail.info.orderDate'
  | 'order.detail.info.orderId'
  | 'order.detail.info.orderValue'
  | 'order.detail.info.otherTitle'
  | 'order.detail.info.platform'
  | 'order.detail.info.shippedAt'
  | 'order.detail.info.shippingAddress'
  | 'order.detail.info.shippingCarrier'
  | 'order.detail.info.shippingCost'
  | 'order.detail.info.shippingMethod'
  | 'order.detail.info.shippingStatus'
  | 'order.detail.info.status'
  | 'order.detail.info.title'
  | 'order.detail.info.totalAmount'
  | 'order.detail.info.totalItems'
  | 'order.detail.info.totalQuantity'
  | 'order.detail.info.trackingNumber'
  | 'order.detail.info.updatedAt'
  | 'order.detail.items.actions'
  | 'order.detail.items.avgPrice'
  | 'order.detail.items.currency'
  | 'order.detail.items.edit'
  | 'order.detail.items.productId'
  | 'order.detail.items.productName'
  | 'order.detail.items.quantity'
  | 'order.detail.items.subtotal'
  | 'order.detail.items.summary'
  | 'order.detail.items.total'
  | 'order.detail.items.totalAmount'
  | 'order.detail.items.totalItems'
  | 'order.detail.items.totalQuantity'
  | 'order.detail.items.unitPrice'
  | 'order.detail.itemsTitle'
  | 'order.detail.loadError'
  | 'order.detail.notFound'
  | 'order.detail.notFoundDesc'
  | 'order.detail.notes'
  | 'order.detail.print'
  | 'order.detail.refresh'
  | 'order.detail.refreshSuccess'
  | 'order.detail.share'
  | 'order.detail.shareMessage'
  | 'order.detail.shipping.statusCancelled'
  | 'order.detail.shipping.statusDelivered'
  | 'order.detail.shipping.statusInTransit'
  | 'order.detail.shipping.statusPending'
  | 'order.detail.shipping.statusProcessing'
  | 'order.detail.shipping.statusReturned'
  | 'order.detail.shipping.statusShipped'
  | 'order.detail.shippingAddress'
  | 'order.detail.status.at'
  | 'order.detail.status.by'
  | 'order.detail.status.changed'
  | 'order.detail.status.created'
  | 'order.detail.status.current'
  | 'order.detail.status.firstChange'
  | 'order.detail.status.lastChange'
  | 'order.detail.status.latest'
  | 'order.detail.status.moreItems'
  | 'order.detail.status.noHistory'
  | 'order.detail.status.notes'
  | 'order.detail.status.title'
  | 'order.detail.status.totalChanges'
  | 'order.detail.title'
  | 'order.noCompanyError'
  | 'order.noCompanyErrorDesc'
  | 'order.permission.configAdminOnly'
  | 'order.permission.denied'
  | 'order.query.customer.displayPrefix'
  | 'order.query.customer.unknown'
  | 'order.query.export'
  | 'order.query.exportNoSelection'
  | 'order.query.exportSelected'
  | 'order.query.features.addNotes'
  | 'order.query.features.export'
  | 'order.query.features.filter'
  | 'order.query.features.search'
  | 'order.query.features.status'
  | 'order.query.features.title'
  | 'order.query.features.updateStatus'
  | 'order.query.filters.activeCount'
  | 'order.query.filters.activeFilters'
  | 'order.query.filters.cancelled'
  | 'order.query.filters.cancelledDesc'
  | 'order.query.filters.clearAll'
  | 'order.query.filters.companyId'
  | 'order.query.filters.customerEmail'
  | 'order.query.filters.customerId'
  | 'order.query.filters.customerName'
  | 'order.query.filters.customerPhone'
  | 'order.query.filters.delivered'
  | 'order.query.filters.deliveredDesc'
  | 'order.query.filters.endDate'
  | 'order.query.filters.filters'
  | 'order.query.filters.highValue'
  | 'order.query.filters.highValueDesc'
  | 'order.query.filters.limit'
  | 'order.query.filters.managePresets'
  | 'order.query.filters.maxAmount'
  | 'order.query.filters.minAmount'
  | 'order.query.filters.needAttention'
  | 'order.query.filters.needAttentionDesc'
  | 'order.query.filters.offset'
  | 'order.query.filters.orderId'
  | 'order.query.filters.pending'
  | 'order.query.filters.pendingDesc'
  | 'order.query.filters.platform'
  | 'order.query.filters.presetGroup'
  | 'order.query.filters.presets'
  | 'order.query.filters.processing'
  | 'order.query.filters.processingDesc'
  | 'order.query.filters.quickFilters'
  | 'order.query.filters.recent'
  | 'order.query.filters.recentDesc'
  | 'order.query.filters.savePreset'
  | 'order.query.filters.sortBy'
  | 'order.query.filters.sortOrder'
  | 'order.query.filters.startDate'
  | 'order.query.filters.status'
  | 'order.query.filters.statusCancelled'
  | 'order.query.filters.statusCompleted'
  | 'order.query.filters.statusDelivered'
  | 'order.query.filters.statusOnHold'
  | 'order.query.filters.statusPending'
  | 'order.query.filters.statusProcessing'
  | 'order.query.filters.statusRefunded'
  | 'order.query.filters.statusShipped'
  | 'order.query.filters.today'
  | 'order.query.filters.todayDesc'
  | 'order.query.list.actions.delete'
  | 'order.query.list.actions.deleteConfirm'
  | 'order.query.list.actions.edit'
  | 'order.query.list.actions.markCancelled'
  | 'order.query.list.actions.markDelivered'
  | 'order.query.list.actions.markProcessing'
  | 'order.query.list.actions.markShipped'
  | 'order.query.list.actions.more'
  | 'order.query.list.actions.updateStatus'
  | 'order.query.list.actions.view'
  | 'order.query.list.columns.actions'
  | 'order.query.list.columns.customer'
  | 'order.query.list.columns.estimatedDelivery'
  | 'order.query.list.columns.items'
  | 'order.query.list.columns.orderDate'
  | 'order.query.list.columns.orderId'
  | 'order.query.list.columns.platform'
  | 'order.query.list.columns.status'
  | 'order.query.list.columns.totalAmount'
  | 'order.query.list.deleteError'
  | 'order.query.list.deleteMessage'
  | 'order.query.list.deleteSuccess'
  | 'order.query.list.orders'
  | 'order.query.list.placeholder'
  | 'order.query.list.selected'
  | 'order.query.list.statusUpdateError'
  | 'order.query.list.statusUpdateMessage'
  | 'order.query.list.statusUpdateSuccess'
  | 'order.query.list.total'
  | 'order.query.loadError'
  | 'order.query.pagination.current'
  | 'order.query.pagination.items'
  | 'order.query.pagination.jumpTo'
  | 'order.query.pagination.page'
  | 'order.query.pagination.pageSize'
  | 'order.query.pagination.showTotal'
  | 'order.query.pagination.total'
  | 'order.query.platforms.email'
  | 'order.query.platforms.mobile'
  | 'order.query.platforms.phone'
  | 'order.query.platforms.store'
  | 'order.query.platforms.web'
  | 'order.query.platforms.wechat'
  | 'order.query.platforms.whatsapp'
  | 'order.query.presets.allOrders.description'
  | 'order.query.presets.allOrders.name'
  | 'order.query.presets.pendingOrders.description'
  | 'order.query.presets.pendingOrders.name'
  | 'order.query.presets.todayOrders.description'
  | 'order.query.presets.todayOrders.name'
  | 'order.query.readOnly'
  | 'order.query.refresh'
  | 'order.query.search.button'
  | 'order.query.search.customerEmail'
  | 'order.query.search.customerEmailPlaceholder'
  | 'order.query.search.customerId'
  | 'order.query.search.customerIdPlaceholder'
  | 'order.query.search.customerName'
  | 'order.query.search.customerNamePlaceholder'
  | 'order.query.search.customerPhone'
  | 'order.query.search.customerPhonePlaceholder'
  | 'order.query.search.dateRange'
  | 'order.query.search.maxAmount'
  | 'order.query.search.maxAmountPlaceholder'
  | 'order.query.search.minAmount'
  | 'order.query.search.minAmountPlaceholder'
  | 'order.query.search.orderId'
  | 'order.query.search.orderIdPlaceholder'
  | 'order.query.search.placeholder'
  | 'order.query.search.platform'
  | 'order.query.search.platformPlaceholder'
  | 'order.query.search.reset'
  | 'order.query.search.sortBy'
  | 'order.query.search.sortByAmount'
  | 'order.query.search.sortByOrderDate'
  | 'order.query.search.sortByOrderNumber'
  | 'order.query.search.sortByStatus'
  | 'order.query.search.sortOrder'
  | 'order.query.search.sortOrderAsc'
  | 'order.query.search.sortOrderDesc'
  | 'order.query.search.status'
  | 'order.query.search.statusPlaceholder'
  | 'order.query.search.success'
  | 'order.query.search.title'
  | 'order.query.search.toggleAdvanced'
  | 'order.query.stats.activeFilters'
  | 'order.query.stats.currentPage'
  | 'order.query.stats.title'
  | 'order.query.stats.total'
  | 'order.query.subtitle'
  | 'order.query.title'
  | 'order.query.units.item'
  | 'order.query.units.items'
  | 'order.tabs.config'
  | 'order.tabs.query'
  | 'sceneInfo.conversationId'
  | 'sceneInfo.emotion'
  | 'sceneInfo.emotionAngry'
  | 'sceneInfo.emotionCalm'
  | 'sceneInfo.emotionDispleased'
  | 'sceneInfo.emotionNeedHelp'
  | 'sceneInfo.reason'
  | 'settings.alerts.systemSettings'
  | 'settings.alerts.systemSettingsDescription'
  | 'settings.buttons.reset'
  | 'settings.buttons.saveSettings'
  | 'settings.channels.aliyun.comingSoon'
  | 'settings.channels.aliyun.desc'
  | 'settings.channels.aliyun.name'
  | 'settings.channels.configure'
  | 'settings.channels.configured'
  | 'settings.channels.inactive'
  | 'settings.channels.meta.accessToken'
  | 'settings.channels.meta.accessTokenPlaceholder'
  | 'settings.channels.meta.desc'
  | 'settings.channels.meta.name'
  | 'settings.channels.meta.phoneNumberId'
  | 'settings.channels.noRecord'
  | 'settings.channels.notConfigured'
  | 'settings.channels.title'
  | 'settings.channels.twilio.desc'
  | 'settings.channels.twilio.name'
  | 'settings.channels.whatsapp.accountSid'
  | 'settings.channels.whatsapp.active'
  | 'settings.channels.whatsapp.addChannel'
  | 'settings.channels.whatsapp.authToken'
  | 'settings.channels.whatsapp.authTokenPlaceholder'
  | 'settings.channels.whatsapp.connected'
  | 'settings.channels.whatsapp.deleteConfirm'
  | 'settings.channels.whatsapp.deleteError'
  | 'settings.channels.whatsapp.deleteSuccess'
  | 'settings.channels.whatsapp.editChannel'
  | 'settings.channels.whatsapp.empty'
  | 'settings.channels.whatsapp.fetchError'
  | 'settings.channels.whatsapp.inactive'
  | 'settings.channels.whatsapp.notConfigured'
  | 'settings.channels.whatsapp.providerType'
  | 'settings.channels.whatsapp.requiredFields'
  | 'settings.channels.whatsapp.saveError'
  | 'settings.channels.whatsapp.saveSuccess'
  | 'settings.channels.whatsapp.testConnection'
  | 'settings.channels.whatsapp.testError'
  | 'settings.channels.whatsapp.title'
  | 'settings.channels.whatsapp.whatsappNumber'
  | 'settings.descriptions.tenantLanguage'
  | 'settings.help.contextWindow'
  | 'settings.help.embeddingApiKey'
  | 'settings.help.embeddingEndpointUrl'
  | 'settings.help.embeddingModel.general'
  | 'settings.help.embeddingModel.hasDocuments'
  | 'settings.help.emojiPolicy'
  | 'settings.help.enthusiasmLevel'
  | 'settings.help.formalityLevel'
  | 'settings.help.maxResponseChars'
  | 'settings.help.persona'
  | 'settings.help.politenessLevel'
  | 'settings.help.responsePreferences'
  | 'settings.help.tenantLanguage'
  | 'settings.help.useEmphasis'
  | 'settings.help.useLineBreaks'
  | 'settings.labels.aiModel'
  | 'settings.labels.allowedOrigins'
  | 'settings.labels.apiKey'
  | 'settings.labels.apiRateLimit'
  | 'settings.labels.contextWindow'
  | 'settings.labels.emailRecipients'
  | 'settings.labels.embeddingApiKey'
  | 'settings.labels.embeddingEndpointUrl'
  | 'settings.labels.embeddingModel'
  | 'settings.labels.emojiPolicy'
  | 'settings.labels.enableContextWindow'
  | 'settings.labels.enableEmailNotifications'
  | 'settings.labels.enableErrorAlerts'
  | 'settings.labels.enableExternalApi'
  | 'settings.labels.enableSlackNotifications'
  | 'settings.labels.enableStreaming'
  | 'settings.labels.enableWebhook'
  | 'settings.labels.enthusiasmLevel'
  | 'settings.labels.formalityLevel'
  | 'settings.labels.lineBreaks'
  | 'settings.labels.maxResponseChars'
  | 'settings.labels.maxTokens'
  | 'settings.labels.persona'
  | 'settings.labels.politenessLevel'
  | 'settings.labels.slackWebhook'
  | 'settings.labels.systemLanguage'
  | 'settings.labels.temperature'
  | 'settings.labels.tenantUILanguage'
  | 'settings.labels.timezone'
  | 'settings.labels.useEmphasis'
  | 'settings.labels.webhookUrl'
  | 'settings.messages.apiKeyAdminDescription'
  | 'settings.messages.apiKeyNotSet'
  | 'settings.messages.apiKeyPlaceholder'
  | 'settings.messages.apiKeySet'
  | 'settings.messages.apiKeyUserDescription'
  | 'settings.messages.contactAdminToSet'
  | 'settings.messages.embeddingApiKeyRequired'
  | 'settings.messages.embeddingEndpointUrlInvalid'
  | 'settings.messages.embeddingEndpointUrlRequired'
  | 'settings.messages.enterFieldToEnable'
  | 'settings.messages.passwordAdminDescription'
  | 'settings.messages.passwordNotSet'
  | 'settings.messages.passwordPlaceholder'
  | 'settings.messages.passwordSet'
  | 'settings.messages.passwordUserDescription'
  | 'settings.messages.resetToDefaults'
  | 'settings.messages.saveFailed'
  | 'settings.messages.saveSuccess'
  | 'settings.messages.tenantLanguageUpdateFailed'
  | 'settings.messages.tenantLanguageUpdated'
  | 'settings.messages.urlAdminDescription'
  | 'settings.messages.urlNotSet'
  | 'settings.messages.urlPlaceholder'
  | 'settings.messages.urlSet'
  | 'settings.messages.urlUserDescription'
  | 'settings.messages.webhookAdminDescription'
  | 'settings.messages.webhookNotSet'
  | 'settings.messages.webhookPlaceholder'
  | 'settings.messages.webhookSet'
  | 'settings.messages.webhookUserDescription'
  | 'settings.options.embeddingModels.dashscope'
  | 'settings.options.embeddingModels.local'
  | 'settings.options.models.claude3'
  | 'settings.options.models.deepseekChat'
  | 'settings.options.models.deepseekReasoner'
  | 'settings.options.models.gpt35Turbo'
  | 'settings.options.models.gpt4'
  | 'settings.options.models.localModel'
  | 'settings.options.style.emojiPolicyFriendly'
  | 'settings.options.style.emojiPolicyMinimal'
  | 'settings.options.style.emojiPolicyModerate'
  | 'settings.options.style.emojiPolicyNone'
  | 'settings.options.style.enthusiasmLevel1'
  | 'settings.options.style.enthusiasmLevel2'
  | 'settings.options.style.enthusiasmLevel3'
  | 'settings.options.style.enthusiasmLevel4'
  | 'settings.options.style.enthusiasmLevel5'
  | 'settings.options.style.formalityLevel1'
  | 'settings.options.style.formalityLevel2'
  | 'settings.options.style.formalityLevel3'
  | 'settings.options.style.formalityLevel4'
  | 'settings.options.style.formalityLevel5'
  | 'settings.options.style.politenessLevel1'
  | 'settings.options.style.politenessLevel2'
  | 'settings.options.style.politenessLevel3'
  | 'settings.options.style.politenessLevel4'
  | 'settings.options.style.politenessLevel5'
  | 'settings.options.temperatureMarks.balanced'
  | 'settings.options.temperatureMarks.creative'
  | 'settings.options.temperatureMarks.precise'
  | 'settings.options.timezones.americaNewYork'
  | 'settings.options.timezones.asiaShanghai'
  | 'settings.options.timezones.europeLondon'
  | 'settings.placeholders.enterAllowedOrigins'
  | 'settings.placeholders.enterApiKey'
  | 'settings.placeholders.enterEmail'
  | 'settings.placeholders.enterEmbeddingApiKey'
  | 'settings.placeholders.enterEmbeddingEndpointUrl'
  | 'settings.placeholders.enterSlackWebhook'
  | 'settings.placeholders.enterWebhookUrl'
  | 'settings.placeholders.persona'
  | 'settings.sections.advancedConfiguration'
  | 'settings.sections.alertConfiguration'
  | 'settings.sections.apiConfiguration'
  | 'settings.sections.basicConfiguration'
  | 'settings.sections.brandPersona'
  | 'settings.sections.emailNotifications'
  | 'settings.sections.embeddingConfiguration'
  | 'settings.sections.modelConfiguration'
  | 'settings.sections.responsePreferences'
  | 'settings.sections.slackNotifications'
  | 'settings.sections.tenantLanguage'
  | 'settings.sections.toneLevels'
  | 'settings.sections.webhookConfiguration'
  | 'settings.tabs.ai'
  | 'settings.tabs.general'
  | 'settings.tabs.integrations'
  | 'settings.tabs.notifications'
  | 'settings.tabs.style'
  | 'settings.tabs.tenantExport'
  | 'settings.tenantExport.confirm'
  | 'settings.tenantExport.exportButton'
  | 'settings.tenantExport.exportFailed'
  | 'settings.tenantExport.exportSuccess'
  | 'settings.tenantExport.importButton'
  | 'settings.tenantExport.importFailed'
  | 'settings.tenantExport.importSuccess'
  | 'settings.tenantExport.importSummaryTitle'
  | 'settings.tenantExport.includeKb'
  | 'settings.tenantExport.noCompany'
  | 'settings.tenantExport.summary.company'
  | 'settings.tenantExport.summary.connectors'
  | 'settings.tenantExport.summary.created'
  | 'settings.tenantExport.summary.dataSources'
  | 'settings.tenantExport.summary.imported'
  | 'settings.tenantExport.summary.knowledgeBase'
  | 'settings.tenantExport.summary.platformIntegrations'
  | 'settings.tenantExport.summary.settings'
  | 'settings.tenantExport.summary.skipped'
  | 'settings.tenantExport.summary.updated'
  | 'settings.tenantExport.summary.users'
  | 'settings.tenantExport.title'
  | 'settings.title'
  | 'userManagement.create'
  | 'userManagement.createFailed'
  | 'userManagement.createModal.cancel'
  | 'userManagement.createModal.ok'
  | 'userManagement.createModal.title'
  | 'userManagement.createSuccess'
  | 'userManagement.fetchFailed'
  | 'userManagement.form.displayName'
  | 'userManagement.form.maxSessions'
  | 'userManagement.form.password'
  | 'userManagement.form.username'
  | 'userManagement.noPermission'
  | 'userManagement.refresh'
  | 'userManagement.title'
  | 'userManagement.usernameExists';

// 命名空间: components
export type ComponentsKeys =
  | 'navigation.agentConfig'
  | 'navigation.chatbot'
  | 'navigation.companies'
  | 'navigation.connectors'
  | 'navigation.dashboard'
  | 'navigation.history'
  | 'navigation.knowledge'
  | 'navigation.orders'
  | 'navigation.profile'
  | 'navigation.settings'
  | 'navigation.user_management'
  | 'sidebar.collapse'
  | 'sidebar.expand';

// 命名空间: errors
export type ErrorsKeys =
  | 'api.badRequest'
  | 'api.configError'
  | 'api.forbidden'
  | 'api.networkDisconnected'
  | 'api.networkError'
  | 'api.notFound'
  | 'api.requestFailed'
  | 'api.requestFailedWithStatus'
  | 'api.serverError'
  | 'api.serviceUnavailable'
  | 'api.unauthorized'
  | 'forbidden'
  | 'network'
  | 'notFound'
  | 'server'
  | 'timeout'
  | 'unauthorized'
  | 'unknown'
  | 'validation';

// 命名空间: validation (无键)
export type ValidationKeys = never;

// 翻译键映射类型
export type TranslationKeys = {
  common: CommonKeys;
  pages: PagesKeys;
  modules: ModulesKeys;
  components: ComponentsKeys;
  errors: ErrorsKeys;
  validation: ValidationKeys;
};

// 完整的翻译键类型（命名空间:键）
export type FullTranslationKey =
    `common:${CommonKeys}`
  | `pages:${PagesKeys}`
  | `modules:${ModulesKeys}`
  | `components:${ComponentsKeys}`
  | `errors:${ErrorsKeys}`
  | `validation:${ValidationKeys}`;

// 按命名空间获取翻译键类型
export type KeysForNamespace<NS extends TranslationNamespace> =
  NS extends 'common' ? CommonKeys :
  NS extends 'pages' ? PagesKeys :
  NS extends 'modules' ? ModulesKeys :
  NS extends 'components' ? ComponentsKeys :
  NS extends 'errors' ? ErrorsKeys :
  NS extends 'validation' ? ValidationKeys :
  never;

// 翻译函数类型
export interface TranslationFunctions {
  /**
   * 获取翻译文本
   * @param key 翻译键（自动补全支持）
   * @param options 翻译选项
   */
  t<NS extends TranslationNamespace>(
    key: KeysForNamespace<NS>,
    options?: {
      ns?: NS;
      defaultValue?: string;
      [key: string]: any;
    }
  ): string;

  /**
   * 获取翻译文本（带命名空间）
   * @param key 完整的翻译键（命名空间:键）
   * @param options 翻译选项
   */
  t(key: FullTranslationKey, options?: Record<string, any>): string;
}

// useI18n hook 类型
export interface UseI18nHook {
  <NS extends TranslationNamespace>(namespace: NS): {
    t: (key: KeysForNamespace<NS>, options?: Record<string, any>) => string;
    ready: boolean;
    currentLanguage: string;
    availableLanguages: readonly string[];
    changeLanguage: (lng?: string, callback?: any) => Promise<any>;
    formatNumber: (num: number, options?: Intl.NumberFormatOptions) => string;
  };
  (): TranslationFunctions & { ready: boolean };
}
export const TRANSLATION_KEYS = {
  common: {
    appFullName: 'app.fullName',
    appName: 'app.name',
    appShortName: 'app.shortName',
    appVersion: 'app.version',
    authCheckingAuthStatus: 'auth.checkingAuthStatus',
    authLoadingUserInfo: 'auth.loadingUserInfo',
    back: 'back',
    backToHome: 'backToHome',
    cancel: 'cancel',
    close: 'close',
    confirm: 'confirm',
    delete_: 'delete',
    edit: 'edit',
    error: 'error',
    errorsAdminRoleRequired: 'errors.adminRoleRequired',
    errorsCurrentUserRole: 'errors.currentUserRole',
    errorsInsufficientPermissions: 'errors.insufficientPermissions',
    errorsNoPermissionDescription: 'errors.noPermissionDescription',
    errorsRequiredPermissions: 'errors.requiredPermissions',
    filter: 'filter',
    helpAbout: 'help.about',
    helpAboutModalAddress: 'help.aboutModal.address',
    helpAboutModalAddressValue: 'help.aboutModal.addressValue',
    helpAboutModalCompany: 'help.aboutModal.company',
    helpAboutModalCompanyLabel: 'help.aboutModal.companyLabel',
    helpAboutModalContact: 'help.aboutModal.contact',
    helpAboutModalCopyright: 'help.aboutModal.copyright',
    helpAboutModalProductName: 'help.aboutModal.productName',
    helpAboutModalTitle: 'help.aboutModal.title',
    helpAboutModalVersion: 'help.aboutModal.version',
    helpFeedback: 'help.feedback',
    helpFeedbackModalContent: 'help.feedbackModal.content',
    helpFeedbackModalContentPlaceholder: 'help.feedbackModal.contentPlaceholder',
    helpFeedbackModalSubmitSuccess: 'help.feedbackModal.submitSuccess',
    helpFeedbackModalTitle: 'help.feedbackModal.title',
    helpFeedbackModalType: 'help.feedbackModal.type',
    helpFeedbackModalTypeBug: 'help.feedbackModal.type.bug',
    helpFeedbackModalTypeFeature: 'help.feedbackModal.type.feature',
    helpFeedbackModalTypeOther: 'help.feedbackModal.type.other',
    helpFeedbackModalTypeUi: 'help.feedbackModal.type.ui',
    helpFeedbackModalTypePlaceholder: 'help.feedbackModal.typePlaceholder',
    languageCurrent: 'language.current',
    languageEnUS: 'language.en-US',
    languagePtBR: 'language.pt-BR',
    languageSwitch: 'language.switch',
    languageZhCN: 'language.zh-CN',
    loading: 'loading',
    loadingResources: 'loadingResources',
    loadingSystem: 'loadingSystem',
    more: 'more',
    next: 'next',
    notificationClearAll: 'notification.clearAll',
    notificationConnectorDeletedBody: 'notification.connector.deleted.body',
    notificationConnectorDeletedTitle: 'notification.connector.deleted.title',
    notificationConnectorErrorBody: 'notification.connector.error.body',
    notificationConnectorErrorTitle: 'notification.connector.error.title',
    notificationConnectorSavedBody: 'notification.connector.saved.body',
    notificationConnectorSavedTitle: 'notification.connector.saved.title',
    notificationEmpty: 'notification.empty',
    notificationLevelError: 'notification.level.error',
    notificationLevelInfo: 'notification.level.info',
    notificationLevelSuccess: 'notification.level.success',
    notificationLevelWarning: 'notification.level.warning',
    notificationMarkAllRead: 'notification.markAllRead',
    notificationTitle: 'notification.title',
    pageNotFound: 'pageNotFound',
    refresh: 'refresh',
    reset: 'reset',
    restoringSession: 'restoringSession',
    roleAdmin: 'role.admin',
    roleCompanyadmin: 'role.company_admin',
    roleGuest: 'role.guest',
    roleRegularuser: 'role.regular_user',
    roleSuperadmin: 'role.super_admin',
    roleUnknown: 'role.unknown',
    roleUser: 'role.user',
    save: 'save',
    saved: 'saved',
    saving: 'saving',
    search: 'search',
    submit: 'submit',
    success: 'success',
    timeAgo: 'time.ago',
    timeDay: 'time.day',
    timeHour: 'time.hour',
    timeJustNow: 'time.justNow',
    timeMinute: 'time.minute',
    timeMonth: 'time.month',
    timeSecond: 'time.second',
    timeWeek: 'time.week',
    timeYear: 'time.year',
    userLogout: 'user.logout',
    userProfile: 'user.profile',
    userSettings: 'user.settings',
    view: 'view',
  },
  pages: {
    loginAccountDisabled: 'login.accountDisabled',
    loginCopyright: 'login.copyright',
    loginForgotPassword: 'login.forgotPassword',
    loginInvalidCredentials: 'login.invalidCredentials',
    loginLoggingIn: 'login.loggingIn',
    loginLoginButton: 'login.loginButton',
    loginLoginError: 'login.loginError',
    loginLoginFailed: 'login.loginFailed',
    loginNoAccount: 'login.noAccount',
    loginOr: 'login.or',
    loginPassword: 'login.password',
    loginPasswordMinLength: 'login.passwordMinLength',
    loginPasswordPlaceholder: 'login.passwordPlaceholder',
    loginPasswordRequired: 'login.passwordRequired',
    loginPrivacyLink: 'login.privacyLink',
    loginRegisterButton: 'login.registerButton',
    loginSubtitle: 'login.subtitle',
    loginSupport: 'login.support',
    loginTerms: 'login.terms',
    loginTermsLink: 'login.termsLink',
    loginTitle: 'login.title',
    loginTooManyAttempts: 'login.tooManyAttempts',
    loginUsername: 'login.username',
    loginUsernameMaxLength: 'login.usernameMaxLength',
    loginUsernameMinLength: 'login.usernameMinLength',
    loginUsernamePlaceholder: 'login.usernamePlaceholder',
    loginUsernameRequired: 'login.usernameRequired',
    profileButtonsCancel: 'profile.buttons.cancel',
    profileButtonsChangePassword: 'profile.buttons.changePassword',
    profileButtonsEditProfile: 'profile.buttons.editProfile',
    profileButtonsSaveChanges: 'profile.buttons.saveChanges',
    profileFieldsAccountStatus: 'profile.fields.accountStatus',
    profileFieldsCompanyDescription: 'profile.fields.companyDescription',
    profileFieldsCompanyName: 'profile.fields.companyName',
    profileFieldsConfirmPassword: 'profile.fields.confirmPassword',
    profileFieldsCreationTime: 'profile.fields.creationTime',
    profileFieldsCurrentPassword: 'profile.fields.currentPassword',
    profileFieldsEmail: 'profile.fields.email',
    profileFieldsEmailNotSet: 'profile.fields.emailNotSet',
    profileFieldsNewPassword: 'profile.fields.newPassword',
    profileFieldsNoDescription: 'profile.fields.noDescription',
    profileFieldsNotSet: 'profile.fields.notSet',
    profileFieldsRegistrationTime: 'profile.fields.registrationTime',
    profileFieldsRole: 'profile.fields.role',
    profileFieldsUnknown: 'profile.fields.unknown',
    profileFieldsUserId: 'profile.fields.userId',
    profileFieldsUsername: 'profile.fields.username',
    profileMessagesCompanyInfoNote: 'profile.messages.companyInfoNote',
    profileMessagesPasswordChangeFailed: 'profile.messages.passwordChangeFailed',
    profileMessagesPasswordChangeSuccess: 'profile.messages.passwordChangeSuccess',
    profileMessagesPasswordSecurityAdvice: 'profile.messages.passwordSecurityAdvice',
    profileMessagesUpdateFailed: 'profile.messages.updateFailed',
    profileMessagesUpdateSuccess: 'profile.messages.updateSuccess',
    profilePlaceholdersConfirmPassword: 'profile.placeholders.confirmPassword',
    profilePlaceholdersCurrentPassword: 'profile.placeholders.currentPassword',
    profilePlaceholdersEmail: 'profile.placeholders.email',
    profilePlaceholdersNewPassword: 'profile.placeholders.newPassword',
    profilePlaceholdersUsername: 'profile.placeholders.username',
    profileSectionsChangePassword: 'profile.sections.changePassword',
    profileStatusActive: 'profile.status.active',
    profileStatusInactive: 'profile.status.inactive',
    profileSubtitle: 'profile.subtitle',
    profileTabsCompany: 'profile.tabs.company',
    profileTabsProfile: 'profile.tabs.profile',
    profileTabsSecurity: 'profile.tabs.security',
    profileTitle: 'profile.title',
    profileValidationCurrentPasswordRequired: 'profile.validation.currentPasswordRequired',
    profileValidationEmailInvalid: 'profile.validation.emailInvalid',
    profileValidationPasswordMinLength: 'profile.validation.passwordMinLength',
    profileValidationPasswordMismatch: 'profile.validation.passwordMismatch',
    profileValidationPasswordRequired: 'profile.validation.passwordRequired',
    profileValidationUsernameMaxLength: 'profile.validation.usernameMaxLength',
    profileValidationUsernameMinLength: 'profile.validation.usernameMinLength',
    profileValidationUsernameRequired: 'profile.validation.usernameRequired',
    registerAccountInfo: 'register.accountInfo',
    registerAdminPermission1: 'register.adminPermission1',
    registerAdminPermission2: 'register.adminPermission2',
    registerAdminPermission3: 'register.adminPermission3',
    registerAdminPermission4: 'register.adminPermission4',
    registerAdminPermissions: 'register.adminPermissions',
    registerAgreeTerms: 'register.agreeTerms',
    registerAgreeTermsRequired: 'register.agreeTermsRequired',
    registerAlreadyHaveAccount: 'register.alreadyHaveAccount',
    registerAlreadyHaveAccountText: 'register.alreadyHaveAccountText',
    registerCompanyDescription: 'register.companyDescription',
    registerCompanyDescriptionField: 'register.companyDescriptionField',
    registerCompanyDescriptionMaxLength: 'register.companyDescriptionMaxLength',
    registerCompanyDescriptionPlaceholder: 'register.companyDescriptionPlaceholder',
    registerCompanyInfo: 'register.companyInfo',
    registerCompanyName: 'register.companyName',
    registerCompanyNameMaxLength: 'register.companyNameMaxLength',
    registerCompanyNameMinLength: 'register.companyNameMinLength',
    registerCompanyNamePlaceholder: 'register.companyNamePlaceholder',
    registerCompanyNameRequired: 'register.companyNameRequired',
    registerConfirmPassword: 'register.confirmPassword',
    registerConfirmPasswordMismatch: 'register.confirmPasswordMismatch',
    registerConfirmPasswordPlaceholder: 'register.confirmPasswordPlaceholder',
    registerConfirmPasswordRequired: 'register.confirmPasswordRequired',
    registerCopyright: 'register.copyright',
    registerEmail: 'register.email',
    registerEmailInvalid: 'register.emailInvalid',
    registerEmailPlaceholder: 'register.emailPlaceholder',
    registerEmailRequired: 'register.emailRequired',
    registerLoginButton: 'register.loginButton',
    registerPassword: 'register.password',
    registerPasswordPlaceholder: 'register.passwordPlaceholder',
    registerPasswordRequired: 'register.passwordRequired',
    registerPasswordRequirement1: 'register.passwordRequirement1',
    registerPasswordRequirement2: 'register.passwordRequirement2',
    registerPasswordRequirement3: 'register.passwordRequirement3',
    registerPasswordRequirement4: 'register.passwordRequirement4',
    registerPasswordRequirements: 'register.passwordRequirements',
    registerPasswordStrengthEnough: 'register.passwordStrengthEnough',
    registerPasswordStrengthMinLength: 'register.passwordStrengthMinLength',
    registerPasswordStrengthNumbers: 'register.passwordStrengthNumbers',
    registerPasswordStrengthSpecial: 'register.passwordStrengthSpecial',
    registerPasswordStrengthUpperLower: 'register.passwordStrengthUpperLower',
    registerPrivacyLink: 'register.privacyLink',
    registerRegisterButton: 'register.registerButton',
    registerRegisterError: 'register.registerError',
    registerRegisterFailed: 'register.registerFailed',
    registerRegisterSuccess: 'register.registerSuccess',
    registerRegistering: 'register.registering',
    registerSubtitle: 'register.subtitle',
    registerSupport: 'register.support',
    registerTerms: 'register.terms',
    registerTermsLink: 'register.termsLink',
    registerTitle: 'register.title',
    registerUsername: 'register.username',
    registerUsernameMaxLength: 'register.usernameMaxLength',
    registerUsernameMinLength: 'register.usernameMinLength',
    registerUsernamePlaceholder: 'register.usernamePlaceholder',
    registerUsernameRequired: 'register.usernameRequired',
    registerUsernameTaken: 'register.usernameTaken',
    userManagementButtonsActivate: 'userManagement.buttons.activate',
    userManagementButtonsDeactivate: 'userManagement.buttons.deactivate',
    userManagementButtonsDelete: 'userManagement.buttons.delete',
    userManagementButtonsEdit: 'userManagement.buttons.edit',
    userManagementButtonsRefresh: 'userManagement.buttons.refresh',
    userManagementCreateSuccess: 'userManagement.createSuccess',
    userManagementCreateUser: 'userManagement.createUser',
    userManagementCurrentUser: 'userManagement.currentUser',
    userManagementDeleteConfirmCancelText: 'userManagement.deleteConfirm.cancelText',
    userManagementDeleteConfirmDescription: 'userManagement.deleteConfirm.description',
    userManagementDeleteConfirmOkText: 'userManagement.deleteConfirm.okText',
    userManagementDeleteConfirmTitle: 'userManagement.deleteConfirm.title',
    userManagementFetchFailed: 'userManagement.fetchFailed',
    userManagementLoading: 'userManagement.loading',
    userManagementMessagesActivateFailed: 'userManagement.messages.activateFailed',
    userManagementMessagesActivateSuccess: 'userManagement.messages.activateSuccess',
    userManagementMessagesDeactivateFailed: 'userManagement.messages.deactivateFailed',
    userManagementMessagesDeactivateSuccess: 'userManagement.messages.deactivateSuccess',
    userManagementMessagesDeleteFailed: 'userManagement.messages.deleteFailed',
    userManagementMessagesDeleteSuccess: 'userManagement.messages.deleteSuccess',
    userManagementMessagesEditInfo: 'userManagement.messages.editInfo',
    userManagementNeverLoggedIn: 'userManagement.neverLoggedIn',
    userManagementNoData: 'userManagement.noData',
    userManagementNoPermission: 'userManagement.noPermission',
    userManagementPaginationShowTotal: 'userManagement.pagination.showTotal',
    userManagementRefresh: 'userManagement.refresh',
    userManagementSearchPlaceholder: 'userManagement.searchPlaceholder',
    userManagementStatusActive: 'userManagement.status.active',
    userManagementStatusInactive: 'userManagement.status.inactive',
    userManagementTableColumnsActions: 'userManagement.table.columns.actions',
    userManagementTableColumnsCreatedAt: 'userManagement.table.columns.createdAt',
    userManagementTableColumnsEmail: 'userManagement.table.columns.email',
    userManagementTableColumnsLastLogin: 'userManagement.table.columns.lastLogin',
    userManagementTableColumnsRole: 'userManagement.table.columns.role',
    userManagementTableColumnsStatus: 'userManagement.table.columns.status',
    userManagementTableColumnsUsername: 'userManagement.table.columns.username',
    userManagementTitle: 'userManagement.title',
  },
  modules: {
    agentConfigForbiddenWordsCount: 'agentConfig.forbiddenWords.count',
    agentConfigForbiddenWordsPlaceholder: 'agentConfig.forbiddenWords.placeholder',
    agentConfigForbiddenWordsSaveFailed: 'agentConfig.forbiddenWords.saveFailed',
    agentConfigForbiddenWordsSaveSuccess: 'agentConfig.forbiddenWords.saveSuccess',
    agentConfigForbiddenWordsTip: 'agentConfig.forbiddenWords.tip',
    agentConfigPoliciesAdd: 'agentConfig.policies.add',
    agentConfigPoliciesContent: 'agentConfig.policies.content',
    agentConfigPoliciesContentHelp: 'agentConfig.policies.contentHelp',
    agentConfigPoliciesContentPlaceholder: 'agentConfig.policies.contentPlaceholder',
    agentConfigPoliciesCreated: 'agentConfig.policies.created',
    agentConfigPoliciesDeleteConfirm: 'agentConfig.policies.deleteConfirm',
    agentConfigPoliciesDeleteSuccess: 'agentConfig.policies.deleteSuccess',
    agentConfigPoliciesDescription: 'agentConfig.policies.description',
    agentConfigPoliciesDescriptionHelp: 'agentConfig.policies.descriptionHelp',
    agentConfigPoliciesDescriptionPlaceholder: 'agentConfig.policies.descriptionPlaceholder',
    agentConfigPoliciesEdit: 'agentConfig.policies.edit',
    agentConfigPoliciesEmpty: 'agentConfig.policies.empty',
    agentConfigPoliciesEmptyDescription: 'agentConfig.policies.emptyDescription',
    agentConfigPoliciesIsActive: 'agentConfig.policies.isActive',
    agentConfigPoliciesName: 'agentConfig.policies.name',
    agentConfigPoliciesNamePlaceholder: 'agentConfig.policies.namePlaceholder',
    agentConfigPoliciesPriority: 'agentConfig.policies.priority',
    agentConfigPoliciesSaveSuccess: 'agentConfig.policies.saveSuccess',
    agentConfigPoliciesTitle: 'agentConfig.policies.title',
    agentConfigPoliciesUpdated: 'agentConfig.policies.updated',
    agentConfigTabsForbiddenWords: 'agentConfig.tabs.forbiddenWords',
    agentConfigTabsPolicies: 'agentConfig.tabs.policies',
    agentConfigTabsStyle: 'agentConfig.tabs.style',
    chatWindowLoadFailed: 'chatWindow.loadFailed',
    chatWindowLoadingMessages: 'chatWindow.loadingMessages',
    chatWindowNoMessages: 'chatWindow.noMessages',
    chatWindowRoleAssistant: 'chatWindow.role.assistant',
    chatWindowRoleHuman: 'chatWindow.role.human',
    chatWindowRoleSystem: 'chatWindow.role.system',
    chatWindowRoleUser: 'chatWindow.role.user',
    chatWindowSelectConversation: 'chatWindow.selectConversation',
    chatbotAlertsConnected: 'chatbot.alerts.connected',
    chatbotAlertsConnecting: 'chatbot.alerts.connecting',
    chatbotAlertsDisconnected: 'chatbot.alerts.disconnected',
    chatbotAlertsError: 'chatbot.alerts.error',
    chatbotAlertsReady: 'chatbot.alerts.ready',
    chatbotContextEmpty: 'chatbot.context.empty',
    chatbotContextError: 'chatbot.context.error',
    chatbotContextRefresh: 'chatbot.context.refresh',
    chatbotContextTitle: 'chatbot.context.title',
    chatbotEmptyNoMessages: 'chatbot.empty.noMessages',
    chatbotInputAriaLabel: 'chatbot.input.ariaLabel',
    chatbotInputPlaceholder: 'chatbot.input.placeholder',
    chatbotInputSend: 'chatbot.input.send',
    chatbotInputSendAriaLabel: 'chatbot.input.sendAriaLabel',
    chatbotInputSending: 'chatbot.input.sending',
    chatbotMessagesBot: 'chatbot.messages.bot',
    chatbotMessagesTyping: 'chatbot.messages.typing',
    chatbotMessagesUser: 'chatbot.messages.user',
    chatbotTitle: 'chatbot.title',
    chatbotWelcomeMessage: 'chatbot.welcomeMessage',
    commonCancel: 'common.cancel',
    commonConfirm: 'common.confirm',
    commonEdit: 'common.edit',
    commonSave: 'common.save',
    companyCancel: 'company.cancel',
    companyCreatedAt: 'company.createdAt',
    companyDescMaxLength: 'company.descMaxLength',
    companyDescPlaceholder: 'company.descPlaceholder',
    companyDescription: 'company.description',
    companyEditInfo: 'company.editInfo',
    companyFetchError: 'company.fetchError',
    companyId: 'company.id',
    companyLoading: 'company.loading',
    companyName: 'company.name',
    companyNameMaxLength: 'company.nameMaxLength',
    companyNamePlaceholder: 'company.namePlaceholder',
    companyNameRequired: 'company.nameRequired',
    companyNoDescription: 'company.noDescription',
    companyNoInfo: 'company.noInfo',
    companyNoPermission: 'company.noPermission',
    companySave: 'company.save',
    companyTitle: 'company.title',
    companyUpdateFailed: 'company.updateFailed',
    companyUpdateSuccess: 'company.updateSuccess',
    companyUpdatedAt: 'company.updatedAt',
    connectorsAddConnector: 'connectors.addConnector',
    connectorsAddFirst: 'connectors.addFirst',
    connectorsConnectionFailed: 'connectors.connectionFailed',
    connectorsConnectionHealthy: 'connectors.connectionHealthy',
    connectorsDeleteFailed: 'connectors.deleteFailed',
    connectorsDeleted: 'connectors.deleted',
    connectorsEmptyDescription: 'connectors.emptyDescription',
    connectorsRefresh: 'connectors.refresh',
    connectorsTestFailed: 'connectors.testFailed',
    connectorsTitle: 'connectors.title',
    conversationListEmpty: 'conversationList.empty',
    conversationListTimeHours: 'conversationList.time.hours',
    conversationListTimeMinutes: 'conversationList.time.minutes',
    conversationListTimeSeconds: 'conversationList.time.seconds',
    conversationListTitle: 'conversationList.title',
    dashboardPlatformDistribution: 'dashboard.platformDistribution',
    dashboardStatisticsActiveUsers: 'dashboard.statistics.activeUsers',
    dashboardStatisticsAvgMessagesPerConv: 'dashboard.statistics.avgMessagesPerConv',
    dashboardStatisticsAvgResponseTime: 'dashboard.statistics.avgResponseTime',
    dashboardStatisticsCustomers: 'dashboard.statistics.customers',
    dashboardStatisticsSatisfactionRate: 'dashboard.statistics.satisfactionRate',
    dashboardStatisticsTotalConversations: 'dashboard.statistics.totalConversations',
    dashboardStatisticsTotalMessages: 'dashboard.statistics.totalMessages',
    dashboardSystemConnectors: 'dashboard.system.connectors',
    dashboardSystemPlatformIntegrations: 'dashboard.system.platformIntegrations',
    dashboardSystemTitle: 'dashboard.system.title',
    dashboardSystemUsers: 'dashboard.system.users',
    dashboardTablesColumnsAgent: 'dashboard.tables.columns.agent',
    dashboardTablesColumnsCustomer: 'dashboard.tables.columns.customer',
    dashboardTablesColumnsDuration: 'dashboard.tables.columns.duration',
    dashboardTablesColumnsMessages: 'dashboard.tables.columns.messages',
    dashboardTablesColumnsPlatform: 'dashboard.tables.columns.platform',
    dashboardTablesColumnsSatisfaction: 'dashboard.tables.columns.satisfaction',
    dashboardTablesColumnsStatus: 'dashboard.tables.columns.status',
    dashboardTablesColumnsTime: 'dashboard.tables.columns.time',
    dashboardTablesEmptyText: 'dashboard.tables.emptyText',
    dashboardTablesFilterLowScore: 'dashboard.tables.filterLowScore',
    dashboardTablesRecentConversations: 'dashboard.tables.recentConversations',
    dashboardTitle: 'dashboard.title',
    dashboardTodayConversations: 'dashboard.today.conversations',
    dashboardTodayKnowledgeChunks: 'dashboard.today.knowledgeChunks',
    dashboardTodayKnowledgeDocs: 'dashboard.today.knowledgeDocs',
    dashboardTodayLowSatisfaction: 'dashboard.today.lowSatisfaction',
    dashboardTodayMessages: 'dashboard.today.messages',
    dashboardTodayTitle: 'dashboard.today.title',
    dashboardUnitsPeople: 'dashboard.units.people',
    dashboardUnitsPercentage: 'dashboard.units.percentage',
    dashboardUnitsSeconds: 'dashboard.units.seconds',
    dashboardUnitsTimes: 'dashboard.units.times',
    historyAgentTypesAI: 'history.agentTypes.AI',
    historyAgentTypesHuman: 'history.agentTypes.Human',
    historyAgentTypesAll: 'history.agentTypes.all',
    historyButtonsClose: 'history.buttons.close',
    historyButtonsExport: 'history.buttons.export',
    historyButtonsReset: 'history.buttons.reset',
    historyButtonsSearch: 'history.buttons.search',
    historyButtonsView: 'history.buttons.view',
    historyFiltersAgentType: 'history.filters.agentType',
    historyFiltersAllStatus: 'history.filters.allStatus',
    historyFiltersDateRangeEndDate: 'history.filters.dateRange.endDate',
    historyFiltersDateRangeStartDate: 'history.filters.dateRange.startDate',
    historyFiltersStatus: 'history.filters.status',
    historyMessagesError: 'history.messages.error',
    historyModalsAgent: 'history.modals.agent',
    historyModalsAgentDepartment: 'history.modals.agentDepartment',
    historyModalsAgentInfo: 'history.modals.agentInfo',
    historyModalsAgentName: 'history.modals.agentName',
    historyModalsAgentType: 'history.modals.agentType',
    historyModalsConversationContent: 'history.modals.conversationContent',
    historyModalsConversationSummary: 'history.modals.conversationSummary',
    historyModalsCustomer: 'history.modals.customer',
    historyModalsCustomerEmail: 'history.modals.customerEmail',
    historyModalsCustomerInfo: 'history.modals.customerInfo',
    historyModalsCustomerLocation: 'history.modals.customerLocation',
    historyModalsCustomerName: 'history.modals.customerName',
    historyModalsCustomerPhone: 'history.modals.customerPhone',
    historyModalsCustomerSegment: 'history.modals.customerSegment',
    historyModalsDetailTitle: 'history.modals.detailTitle',
    historyModalsNoContactInfo: 'history.modals.noContactInfo',
    historyModalsNoConversationContent: 'history.modals.noConversationContent',
    historyModalsNoEvaluation: 'history.modals.noEvaluation',
    historyModalsRegularUser: 'history.modals.regularUser',
    historyModalsUnknownLocation: 'history.modals.unknownLocation',
    historySatisfactionNotEvaluated: 'history.satisfaction.notEvaluated',
    historySatisfactionStars: 'history.satisfaction.stars',
    historySearchPlaceholder: 'history.search.placeholder',
    historySortBySatisfaction: 'history.sort.bySatisfaction',
    historySortByTime: 'history.sort.byTime',
    historyStatusCancelled: 'history.status.cancelled',
    historyStatusCompleted: 'history.status.completed',
    historyStatusDefault: 'history.status.default',
    historyStatusOngoing: 'history.status.ongoing',
    historyTableColumnsActions: 'history.table.columns.actions',
    historyTableColumnsAgentType: 'history.table.columns.agentType',
    historyTableColumnsCustomer: 'history.table.columns.customer',
    historyTableColumnsDuration: 'history.table.columns.duration',
    historyTableColumnsSatisfaction: 'history.table.columns.satisfaction',
    historyTableColumnsStatus: 'history.table.columns.status',
    historyTableColumnsTags: 'history.table.columns.tags',
    historyTableColumnsTime: 'history.table.columns.time',
    historyTableEmptyText: 'history.table.emptyText',
    historyTableLoadingText: 'history.table.loadingText',
    historyTitle: 'history.title',
    humanListActiveDisabled: 'humanList.active.disabled',
    humanListActiveEnabled: 'humanList.active.enabled',
    humanListColAction: 'humanList.col.action',
    humanListColDisplayName: 'humanList.col.displayName',
    humanListColIsActive: 'humanList.col.isActive',
    humanListColLoad: 'humanList.col.load',
    humanListColStatus: 'humanList.col.status',
    humanListColUsername: 'humanList.col.username',
    humanListEmpty: 'humanList.empty',
    humanListStatusBusy: 'humanList.status.busy',
    humanListStatusOffline: 'humanList.status.offline',
    humanListStatusOnline: 'humanList.status.online',
    humanListToggleConfirmDisable: 'humanList.toggleConfirm.disable',
    humanListToggleConfirmEnable: 'humanList.toggleConfirm.enable',
    humanListToggleFailed: 'humanList.toggleFailed',
    humanListToggleSuccessDisabled: 'humanList.toggleSuccess.disabled',
    humanListToggleSuccessEnabled: 'humanList.toggleSuccess.enabled',
    humanLoginCompanyId: 'humanLogin.companyId',
    humanLoginCompanyIdPlaceholder: 'humanLogin.companyIdPlaceholder',
    humanLoginCompanyIdRequired: 'humanLogin.companyIdRequired',
    humanLoginLoginFailed: 'humanLogin.loginFailed',
    humanLoginPassword: 'humanLogin.password',
    humanLoginPasswordPlaceholder: 'humanLogin.passwordPlaceholder',
    humanLoginPasswordRequired: 'humanLogin.passwordRequired',
    humanLoginSubmit: 'humanLogin.submit',
    humanLoginTitle: 'humanLogin.title',
    humanLoginUsername: 'humanLogin.username',
    humanLoginUsernamePlaceholder: 'humanLogin.usernamePlaceholder',
    humanLoginUsernameRequired: 'humanLogin.usernameRequired',
    humanWorkspaceCustomerName: 'humanWorkspace.customerName',
    humanWorkspaceLogout: 'humanWorkspace.logout',
    humanWorkspaceTakingOver: 'humanWorkspace.takingOver',
    humanWorkspaceTitle: 'humanWorkspace.title',
    humanWorkspaceWaitingTakeover: 'humanWorkspace.waitingTakeover',
    humanWorkspaceWsDisconnected: 'humanWorkspace.wsDisconnected',
    knowledgeButtonsAddKnowledge: 'knowledge.buttons.addKnowledge',
    knowledgeButtonsDeleteDocument: 'knowledge.buttons.deleteDocument',
    knowledgeButtonsDocumentList: 'knowledge.buttons.documentList',
    knowledgeButtonsExtractionTest: 'knowledge.buttons.extractionTest',
    knowledgeButtonsImportFile: 'knowledge.buttons.importFile',
    knowledgeButtonsUploading: 'knowledge.buttons.uploading',
    knowledgeButtonsViewDetails: 'knowledge.buttons.viewDetails',
    knowledgeDateFormatLocale: 'knowledge.dateFormat.locale',
    knowledgeExtractionTestChunk: 'knowledge.extractionTest.chunk',
    knowledgeExtractionTestCollapse: 'knowledge.extractionTest.collapse',
    knowledgeExtractionTestExpand: 'knowledge.extractionTest.expand',
    knowledgeExtractionTestKnowledgeDocuments: 'knowledge.extractionTest.knowledgeDocuments',
    knowledgeExtractionTestLoading: 'knowledge.extractionTest.loading',
    knowledgeExtractionTestMatchedResults: 'knowledge.extractionTest.matchedResults',
    knowledgeExtractionTestMetadata: 'knowledge.extractionTest.metadata',
    knowledgeExtractionTestNoResults: 'knowledge.extractionTest.noResults',
    knowledgeExtractionTestNoResultsDescription: 'knowledge.extractionTest.noResultsDescription',
    knowledgeExtractionTestQueryPlaceholder: 'knowledge.extractionTest.queryPlaceholder',
    knowledgeExtractionTestQuerySummary: 'knowledge.extractionTest.querySummary',
    knowledgeExtractionTestResetQuery: 'knowledge.extractionTest.resetQuery',
    knowledgeExtractionTestResults: 'knowledge.extractionTest.results',
    knowledgeExtractionTestSearchParamK: 'knowledge.extractionTest.searchParamK',
    knowledgeExtractionTestSimilarityScore: 'knowledge.extractionTest.similarityScore',
    knowledgeExtractionTestSource: 'knowledge.extractionTest.source',
    knowledgeExtractionTestStartTest: 'knowledge.extractionTest.startTest',
    knowledgeExtractionTestTestQuery: 'knowledge.extractionTest.testQuery',
    knowledgeExtractionTestTestQueryDescription: 'knowledge.extractionTest.testQueryDescription',
    knowledgeExtractionTestTitle: 'knowledge.extractionTest.title',
    knowledgeExtractionTestUnknown: 'knowledge.extractionTest.unknown',
    knowledgeExtractionTestWaitingInput: 'knowledge.extractionTest.waitingInput',
    knowledgeExtractionTestWaitingInputDescription: 'knowledge.extractionTest.waitingInputDescription',
    knowledgeFileTypesUnknown: 'knowledge.fileTypes.unknown',
    knowledgeMessagesDeleteConfirmContent: 'knowledge.messages.deleteConfirmContent',
    knowledgeMessagesDeleteConfirmTitle: 'knowledge.messages.deleteConfirmTitle',
    knowledgeMessagesDeleteFailed: 'knowledge.messages.deleteFailed',
    knowledgeMessagesFileSizeExceeded: 'knowledge.messages.fileSizeExceeded',
    knowledgeMessagesUnsupportedFileType: 'knowledge.messages.unsupportedFileType',
    knowledgeMessagesUploadFailed: 'knowledge.messages.uploadFailed',
    knowledgeMessagesUploadInstructions: 'knowledge.messages.uploadInstructions',
    knowledgeMessagesUploadSuccess: 'knowledge.messages.uploadSuccess',
    knowledgeSearchPlaceholder: 'knowledge.search.placeholder',
    knowledgeStatusActive: 'knowledge.status.active',
    knowledgeStatusCompleted: 'knowledge.status.completed',
    knowledgeStatusEmbedding: 'knowledge.status.embedding',
    knowledgeStatusFailed: 'knowledge.status.failed',
    knowledgeStatusParsing: 'knowledge.status.parsing',
    knowledgeStatusPending: 'knowledge.status.pending',
    knowledgeStatusPersisting: 'knowledge.status.persisting',
    knowledgeStatusSemanticprocessing: 'knowledge.status.semantic_processing',
    knowledgeStatusUnknown: 'knowledge.status.unknown',
    knowledgeTableColumnsActions: 'knowledge.table.columns.actions',
    knowledgeTableColumnsChunks: 'knowledge.table.columns.chunks',
    knowledgeTableColumnsCreatedAt: 'knowledge.table.columns.createdAt',
    knowledgeTableColumnsDescription: 'knowledge.table.columns.description',
    knowledgeTableColumnsFileName: 'knowledge.table.columns.fileName',
    knowledgeTableColumnsFileSize: 'knowledge.table.columns.fileSize',
    knowledgeTableColumnsFileType: 'knowledge.table.columns.fileType',
    knowledgeTableColumnsStatus: 'knowledge.table.columns.status',
    knowledgeTableEmptyText: 'knowledge.table.emptyText',
    knowledgeTableLoadingText: 'knowledge.table.loadingText',
    knowledgeTitle: 'knowledge.title',
    messageInputCloseBtn: 'messageInput.closeBtn',
    messageInputCloseConfirmCancel: 'messageInput.closeConfirmCancel',
    messageInputCloseConfirmDesc: 'messageInput.closeConfirmDesc',
    messageInputCloseConfirmOk: 'messageInput.closeConfirmOk',
    messageInputCloseConfirmTitle: 'messageInput.closeConfirmTitle',
    messageInputPlaceholder: 'messageInput.placeholder',
    messageInputSendBtn: 'messageInput.sendBtn',
    navigationChatbot: 'navigation.chatbot',
    navigationDashboard: 'navigation.dashboard',
    navigationHistory: 'navigation.history',
    navigationKnowledge: 'navigation.knowledge',
    navigationPageTitlesAgentConfig: 'navigation.pageTitles.agentConfig',
    navigationPageTitlesChatbot: 'navigation.pageTitles.chatbot',
    navigationPageTitlesCompanies: 'navigation.pageTitles.companies',
    navigationPageTitlesDashboard: 'navigation.pageTitles.dashboard',
    navigationPageTitlesDefault: 'navigation.pageTitles.default',
    navigationPageTitlesHelp: 'navigation.pageTitles.help',
    navigationPageTitlesHistory: 'navigation.pageTitles.history',
    navigationPageTitlesKnowledge: 'navigation.pageTitles.knowledge',
    navigationPageTitlesNotifications: 'navigation.pageTitles.notifications',
    navigationPageTitlesProfile: 'navigation.pageTitles.profile',
    navigationPageTitlesSettings: 'navigation.pageTitles.settings',
    navigationPageTitlesUsers: 'navigation.pageTitles.users',
    navigationSettings: 'navigation.settings',
    navigationUsermanagement: 'navigation.user_management',
    orderConfigConnectionApiKey: 'order.config.connection.apiKey',
    orderConfigConnectionApiKeyRequired: 'order.config.connection.apiKeyRequired',
    orderConfigConnectionApiUrl: 'order.config.connection.apiUrl',
    orderConfigConnectionApiUrlRequired: 'order.config.connection.apiUrlRequired',
    orderConfigConnectionAuthType: 'order.config.connection.authType',
    orderConfigConnectionAuthTypeRequired: 'order.config.connection.authTypeRequired',
    orderConfigConnectionDatabase: 'order.config.connection.database',
    orderConfigConnectionDatabaseRequired: 'order.config.connection.databaseRequired',
    orderConfigConnectionHost: 'order.config.connection.host',
    orderConfigConnectionHostRequired: 'order.config.connection.hostRequired',
    orderConfigConnectionPassword: 'order.config.connection.password',
    orderConfigConnectionPasswordRequired: 'order.config.connection.passwordRequired',
    orderConfigConnectionPort: 'order.config.connection.port',
    orderConfigConnectionPortRequired: 'order.config.connection.portRequired',
    orderConfigConnectionTitle: 'order.config.connection.title',
    orderConfigConnectionUsername: 'order.config.connection.username',
    orderConfigConnectionUsernameRequired: 'order.config.connection.usernameRequired',
    orderConfigDataSourceTitle: 'order.config.dataSource.title',
    orderConfigDataSourceType: 'order.config.dataSource.type',
    orderConfigDataSourceTypeRequired: 'order.config.dataSource.typeRequired',
    orderConfigSaveSuccess: 'order.config.save.success',
    orderConfigSaveConfig: 'order.config.saveConfig',
    orderConfigSubtitle: 'order.config.subtitle',
    orderConfigSyncDaily: 'order.config.sync.daily',
    orderConfigSyncFrequency: 'order.config.sync.frequency',
    orderConfigSyncFrequencyRequired: 'order.config.sync.frequencyRequired',
    orderConfigSyncHourly: 'order.config.sync.hourly',
    orderConfigSyncManual: 'order.config.sync.manual',
    orderConfigSyncRealtime: 'order.config.sync.realtime',
    orderConfigSyncRetryCount: 'order.config.sync.retryCount',
    orderConfigSyncTitle: 'order.config.sync.title',
    orderConfigTestSuccess: 'order.config.test.success',
    orderConfigTestUnhealthy: 'order.config.test.unhealthy',
    orderConfigTestConnection: 'order.config.testConnection',
    orderConfigTitle: 'order.config.title',
    orderDetailCreatedAt: 'order.detail.createdAt',
    orderDetailEdit: 'order.detail.edit',
    orderDetailEditOrder: 'order.detail.editOrder',
    orderDetailInfoAvgPrice: 'order.detail.info.avgPrice',
    orderDetailInfoBasicTitle: 'order.detail.info.basicTitle',
    orderDetailInfoCreatedAt: 'order.detail.info.createdAt',
    orderDetailInfoCurrency: 'order.detail.info.currency',
    orderDetailInfoCustomerAddress: 'order.detail.info.customerAddress',
    orderDetailInfoCustomerEmail: 'order.detail.info.customerEmail',
    orderDetailInfoCustomerId: 'order.detail.info.customerId',
    orderDetailInfoCustomerName: 'order.detail.info.customerName',
    orderDetailInfoCustomerPhone: 'order.detail.info.customerPhone',
    orderDetailInfoCustomerTitle: 'order.detail.info.customerTitle',
    orderDetailInfoDeliveredAt: 'order.detail.info.deliveredAt',
    orderDetailInfoDeliveryTitle: 'order.detail.info.deliveryTitle',
    orderDetailInfoEstimatedDelivery: 'order.detail.info.estimatedDelivery',
    orderDetailInfoOrderDate: 'order.detail.info.orderDate',
    orderDetailInfoOrderId: 'order.detail.info.orderId',
    orderDetailInfoOrderValue: 'order.detail.info.orderValue',
    orderDetailInfoOtherTitle: 'order.detail.info.otherTitle',
    orderDetailInfoPlatform: 'order.detail.info.platform',
    orderDetailInfoShippedAt: 'order.detail.info.shippedAt',
    orderDetailInfoShippingAddress: 'order.detail.info.shippingAddress',
    orderDetailInfoShippingCarrier: 'order.detail.info.shippingCarrier',
    orderDetailInfoShippingCost: 'order.detail.info.shippingCost',
    orderDetailInfoShippingMethod: 'order.detail.info.shippingMethod',
    orderDetailInfoShippingStatus: 'order.detail.info.shippingStatus',
    orderDetailInfoStatus: 'order.detail.info.status',
    orderDetailInfoTitle: 'order.detail.info.title',
    orderDetailInfoTotalAmount: 'order.detail.info.totalAmount',
    orderDetailInfoTotalItems: 'order.detail.info.totalItems',
    orderDetailInfoTotalQuantity: 'order.detail.info.totalQuantity',
    orderDetailInfoTrackingNumber: 'order.detail.info.trackingNumber',
    orderDetailInfoUpdatedAt: 'order.detail.info.updatedAt',
    orderDetailItemsActions: 'order.detail.items.actions',
    orderDetailItemsAvgPrice: 'order.detail.items.avgPrice',
    orderDetailItemsCurrency: 'order.detail.items.currency',
    orderDetailItemsEdit: 'order.detail.items.edit',
    orderDetailItemsProductId: 'order.detail.items.productId',
    orderDetailItemsProductName: 'order.detail.items.productName',
    orderDetailItemsQuantity: 'order.detail.items.quantity',
    orderDetailItemsSubtotal: 'order.detail.items.subtotal',
    orderDetailItemsSummary: 'order.detail.items.summary',
    orderDetailItemsTotal: 'order.detail.items.total',
    orderDetailItemsTotalAmount: 'order.detail.items.totalAmount',
    orderDetailItemsTotalItems: 'order.detail.items.totalItems',
    orderDetailItemsTotalQuantity: 'order.detail.items.totalQuantity',
    orderDetailItemsUnitPrice: 'order.detail.items.unitPrice',
    orderDetailItemsTitle: 'order.detail.itemsTitle',
    orderDetailLoadError: 'order.detail.loadError',
    orderDetailNotFound: 'order.detail.notFound',
    orderDetailNotFoundDesc: 'order.detail.notFoundDesc',
    orderDetailNotes: 'order.detail.notes',
    orderDetailPrint: 'order.detail.print',
    orderDetailRefresh: 'order.detail.refresh',
    orderDetailRefreshSuccess: 'order.detail.refreshSuccess',
    orderDetailShare: 'order.detail.share',
    orderDetailShareMessage: 'order.detail.shareMessage',
    orderDetailShippingStatusCancelled: 'order.detail.shipping.statusCancelled',
    orderDetailShippingStatusDelivered: 'order.detail.shipping.statusDelivered',
    orderDetailShippingStatusInTransit: 'order.detail.shipping.statusInTransit',
    orderDetailShippingStatusPending: 'order.detail.shipping.statusPending',
    orderDetailShippingStatusProcessing: 'order.detail.shipping.statusProcessing',
    orderDetailShippingStatusReturned: 'order.detail.shipping.statusReturned',
    orderDetailShippingStatusShipped: 'order.detail.shipping.statusShipped',
    orderDetailShippingAddress: 'order.detail.shippingAddress',
    orderDetailStatusAt: 'order.detail.status.at',
    orderDetailStatusBy: 'order.detail.status.by',
    orderDetailStatusChanged: 'order.detail.status.changed',
    orderDetailStatusCreated: 'order.detail.status.created',
    orderDetailStatusCurrent: 'order.detail.status.current',
    orderDetailStatusFirstChange: 'order.detail.status.firstChange',
    orderDetailStatusLastChange: 'order.detail.status.lastChange',
    orderDetailStatusLatest: 'order.detail.status.latest',
    orderDetailStatusMoreItems: 'order.detail.status.moreItems',
    orderDetailStatusNoHistory: 'order.detail.status.noHistory',
    orderDetailStatusNotes: 'order.detail.status.notes',
    orderDetailStatusTitle: 'order.detail.status.title',
    orderDetailStatusTotalChanges: 'order.detail.status.totalChanges',
    orderDetailTitle: 'order.detail.title',
    orderNoCompanyError: 'order.noCompanyError',
    orderNoCompanyErrorDesc: 'order.noCompanyErrorDesc',
    orderPermissionConfigAdminOnly: 'order.permission.configAdminOnly',
    orderPermissionDenied: 'order.permission.denied',
    orderQueryCustomerDisplayPrefix: 'order.query.customer.displayPrefix',
    orderQueryCustomerUnknown: 'order.query.customer.unknown',
    orderQueryExport: 'order.query.export',
    orderQueryExportNoSelection: 'order.query.exportNoSelection',
    orderQueryExportSelected: 'order.query.exportSelected',
    orderQueryFeaturesAddNotes: 'order.query.features.addNotes',
    orderQueryFeaturesExport: 'order.query.features.export',
    orderQueryFeaturesFilter: 'order.query.features.filter',
    orderQueryFeaturesSearch: 'order.query.features.search',
    orderQueryFeaturesStatus: 'order.query.features.status',
    orderQueryFeaturesTitle: 'order.query.features.title',
    orderQueryFeaturesUpdateStatus: 'order.query.features.updateStatus',
    orderQueryFiltersActiveCount: 'order.query.filters.activeCount',
    orderQueryFiltersActiveFilters: 'order.query.filters.activeFilters',
    orderQueryFiltersCancelled: 'order.query.filters.cancelled',
    orderQueryFiltersCancelledDesc: 'order.query.filters.cancelledDesc',
    orderQueryFiltersClearAll: 'order.query.filters.clearAll',
    orderQueryFiltersCompanyId: 'order.query.filters.companyId',
    orderQueryFiltersCustomerEmail: 'order.query.filters.customerEmail',
    orderQueryFiltersCustomerId: 'order.query.filters.customerId',
    orderQueryFiltersCustomerName: 'order.query.filters.customerName',
    orderQueryFiltersCustomerPhone: 'order.query.filters.customerPhone',
    orderQueryFiltersDelivered: 'order.query.filters.delivered',
    orderQueryFiltersDeliveredDesc: 'order.query.filters.deliveredDesc',
    orderQueryFiltersEndDate: 'order.query.filters.endDate',
    orderQueryFiltersFilters: 'order.query.filters.filters',
    orderQueryFiltersHighValue: 'order.query.filters.highValue',
    orderQueryFiltersHighValueDesc: 'order.query.filters.highValueDesc',
    orderQueryFiltersLimit: 'order.query.filters.limit',
    orderQueryFiltersManagePresets: 'order.query.filters.managePresets',
    orderQueryFiltersMaxAmount: 'order.query.filters.maxAmount',
    orderQueryFiltersMinAmount: 'order.query.filters.minAmount',
    orderQueryFiltersNeedAttention: 'order.query.filters.needAttention',
    orderQueryFiltersNeedAttentionDesc: 'order.query.filters.needAttentionDesc',
    orderQueryFiltersOffset: 'order.query.filters.offset',
    orderQueryFiltersOrderId: 'order.query.filters.orderId',
    orderQueryFiltersPending: 'order.query.filters.pending',
    orderQueryFiltersPendingDesc: 'order.query.filters.pendingDesc',
    orderQueryFiltersPlatform: 'order.query.filters.platform',
    orderQueryFiltersPresetGroup: 'order.query.filters.presetGroup',
    orderQueryFiltersPresets: 'order.query.filters.presets',
    orderQueryFiltersProcessing: 'order.query.filters.processing',
    orderQueryFiltersProcessingDesc: 'order.query.filters.processingDesc',
    orderQueryFiltersQuickFilters: 'order.query.filters.quickFilters',
    orderQueryFiltersRecent: 'order.query.filters.recent',
    orderQueryFiltersRecentDesc: 'order.query.filters.recentDesc',
    orderQueryFiltersSavePreset: 'order.query.filters.savePreset',
    orderQueryFiltersSortBy: 'order.query.filters.sortBy',
    orderQueryFiltersSortOrder: 'order.query.filters.sortOrder',
    orderQueryFiltersStartDate: 'order.query.filters.startDate',
    orderQueryFiltersStatus: 'order.query.filters.status',
    orderQueryFiltersStatusCancelled: 'order.query.filters.statusCancelled',
    orderQueryFiltersStatusCompleted: 'order.query.filters.statusCompleted',
    orderQueryFiltersStatusDelivered: 'order.query.filters.statusDelivered',
    orderQueryFiltersStatusOnHold: 'order.query.filters.statusOnHold',
    orderQueryFiltersStatusPending: 'order.query.filters.statusPending',
    orderQueryFiltersStatusProcessing: 'order.query.filters.statusProcessing',
    orderQueryFiltersStatusRefunded: 'order.query.filters.statusRefunded',
    orderQueryFiltersStatusShipped: 'order.query.filters.statusShipped',
    orderQueryFiltersToday: 'order.query.filters.today',
    orderQueryFiltersTodayDesc: 'order.query.filters.todayDesc',
    orderQueryListActionsDelete: 'order.query.list.actions.delete',
    orderQueryListActionsDeleteConfirm: 'order.query.list.actions.deleteConfirm',
    orderQueryListActionsEdit: 'order.query.list.actions.edit',
    orderQueryListActionsMarkCancelled: 'order.query.list.actions.markCancelled',
    orderQueryListActionsMarkDelivered: 'order.query.list.actions.markDelivered',
    orderQueryListActionsMarkProcessing: 'order.query.list.actions.markProcessing',
    orderQueryListActionsMarkShipped: 'order.query.list.actions.markShipped',
    orderQueryListActionsMore: 'order.query.list.actions.more',
    orderQueryListActionsUpdateStatus: 'order.query.list.actions.updateStatus',
    orderQueryListActionsView: 'order.query.list.actions.view',
    orderQueryListColumnsActions: 'order.query.list.columns.actions',
    orderQueryListColumnsCustomer: 'order.query.list.columns.customer',
    orderQueryListColumnsEstimatedDelivery: 'order.query.list.columns.estimatedDelivery',
    orderQueryListColumnsItems: 'order.query.list.columns.items',
    orderQueryListColumnsOrderDate: 'order.query.list.columns.orderDate',
    orderQueryListColumnsOrderId: 'order.query.list.columns.orderId',
    orderQueryListColumnsPlatform: 'order.query.list.columns.platform',
    orderQueryListColumnsStatus: 'order.query.list.columns.status',
    orderQueryListColumnsTotalAmount: 'order.query.list.columns.totalAmount',
    orderQueryListDeleteError: 'order.query.list.deleteError',
    orderQueryListDeleteMessage: 'order.query.list.deleteMessage',
    orderQueryListDeleteSuccess: 'order.query.list.deleteSuccess',
    orderQueryListOrders: 'order.query.list.orders',
    orderQueryListPlaceholder: 'order.query.list.placeholder',
    orderQueryListSelected: 'order.query.list.selected',
    orderQueryListStatusUpdateError: 'order.query.list.statusUpdateError',
    orderQueryListStatusUpdateMessage: 'order.query.list.statusUpdateMessage',
    orderQueryListStatusUpdateSuccess: 'order.query.list.statusUpdateSuccess',
    orderQueryListTotal: 'order.query.list.total',
    orderQueryLoadError: 'order.query.loadError',
    orderQueryPaginationCurrent: 'order.query.pagination.current',
    orderQueryPaginationItems: 'order.query.pagination.items',
    orderQueryPaginationJumpTo: 'order.query.pagination.jumpTo',
    orderQueryPaginationPage: 'order.query.pagination.page',
    orderQueryPaginationPageSize: 'order.query.pagination.pageSize',
    orderQueryPaginationShowTotal: 'order.query.pagination.showTotal',
    orderQueryPaginationTotal: 'order.query.pagination.total',
    orderQueryPlatformsEmail: 'order.query.platforms.email',
    orderQueryPlatformsMobile: 'order.query.platforms.mobile',
    orderQueryPlatformsPhone: 'order.query.platforms.phone',
    orderQueryPlatformsStore: 'order.query.platforms.store',
    orderQueryPlatformsWeb: 'order.query.platforms.web',
    orderQueryPlatformsWechat: 'order.query.platforms.wechat',
    orderQueryPlatformsWhatsapp: 'order.query.platforms.whatsapp',
    orderQueryPresetsAllOrdersDescription: 'order.query.presets.allOrders.description',
    orderQueryPresetsAllOrdersName: 'order.query.presets.allOrders.name',
    orderQueryPresetsPendingOrdersDescription: 'order.query.presets.pendingOrders.description',
    orderQueryPresetsPendingOrdersName: 'order.query.presets.pendingOrders.name',
    orderQueryPresetsTodayOrdersDescription: 'order.query.presets.todayOrders.description',
    orderQueryPresetsTodayOrdersName: 'order.query.presets.todayOrders.name',
    orderQueryReadOnly: 'order.query.readOnly',
    orderQueryRefresh: 'order.query.refresh',
    orderQuerySearchButton: 'order.query.search.button',
    orderQuerySearchCustomerEmail: 'order.query.search.customerEmail',
    orderQuerySearchCustomerEmailPlaceholder: 'order.query.search.customerEmailPlaceholder',
    orderQuerySearchCustomerId: 'order.query.search.customerId',
    orderQuerySearchCustomerIdPlaceholder: 'order.query.search.customerIdPlaceholder',
    orderQuerySearchCustomerName: 'order.query.search.customerName',
    orderQuerySearchCustomerNamePlaceholder: 'order.query.search.customerNamePlaceholder',
    orderQuerySearchCustomerPhone: 'order.query.search.customerPhone',
    orderQuerySearchCustomerPhonePlaceholder: 'order.query.search.customerPhonePlaceholder',
    orderQuerySearchDateRange: 'order.query.search.dateRange',
    orderQuerySearchMaxAmount: 'order.query.search.maxAmount',
    orderQuerySearchMaxAmountPlaceholder: 'order.query.search.maxAmountPlaceholder',
    orderQuerySearchMinAmount: 'order.query.search.minAmount',
    orderQuerySearchMinAmountPlaceholder: 'order.query.search.minAmountPlaceholder',
    orderQuerySearchOrderId: 'order.query.search.orderId',
    orderQuerySearchOrderIdPlaceholder: 'order.query.search.orderIdPlaceholder',
    orderQuerySearchPlaceholder: 'order.query.search.placeholder',
    orderQuerySearchPlatform: 'order.query.search.platform',
    orderQuerySearchPlatformPlaceholder: 'order.query.search.platformPlaceholder',
    orderQuerySearchReset: 'order.query.search.reset',
    orderQuerySearchSortBy: 'order.query.search.sortBy',
    orderQuerySearchSortByAmount: 'order.query.search.sortByAmount',
    orderQuerySearchSortByOrderDate: 'order.query.search.sortByOrderDate',
    orderQuerySearchSortByOrderNumber: 'order.query.search.sortByOrderNumber',
    orderQuerySearchSortByStatus: 'order.query.search.sortByStatus',
    orderQuerySearchSortOrder: 'order.query.search.sortOrder',
    orderQuerySearchSortOrderAsc: 'order.query.search.sortOrderAsc',
    orderQuerySearchSortOrderDesc: 'order.query.search.sortOrderDesc',
    orderQuerySearchStatus: 'order.query.search.status',
    orderQuerySearchStatusPlaceholder: 'order.query.search.statusPlaceholder',
    orderQuerySearchSuccess: 'order.query.search.success',
    orderQuerySearchTitle: 'order.query.search.title',
    orderQuerySearchToggleAdvanced: 'order.query.search.toggleAdvanced',
    orderQueryStatsActiveFilters: 'order.query.stats.activeFilters',
    orderQueryStatsCurrentPage: 'order.query.stats.currentPage',
    orderQueryStatsTitle: 'order.query.stats.title',
    orderQueryStatsTotal: 'order.query.stats.total',
    orderQuerySubtitle: 'order.query.subtitle',
    orderQueryTitle: 'order.query.title',
    orderQueryUnitsItem: 'order.query.units.item',
    orderQueryUnitsItems: 'order.query.units.items',
    orderTabsConfig: 'order.tabs.config',
    orderTabsQuery: 'order.tabs.query',
    sceneInfoConversationId: 'sceneInfo.conversationId',
    sceneInfoEmotion: 'sceneInfo.emotion',
    sceneInfoEmotionAngry: 'sceneInfo.emotionAngry',
    sceneInfoEmotionCalm: 'sceneInfo.emotionCalm',
    sceneInfoEmotionDispleased: 'sceneInfo.emotionDispleased',
    sceneInfoEmotionNeedHelp: 'sceneInfo.emotionNeedHelp',
    sceneInfoReason: 'sceneInfo.reason',
    settingsAlertsSystemSettings: 'settings.alerts.systemSettings',
    settingsAlertsSystemSettingsDescription: 'settings.alerts.systemSettingsDescription',
    settingsButtonsReset: 'settings.buttons.reset',
    settingsButtonsSaveSettings: 'settings.buttons.saveSettings',
    settingsChannelsAliyunComingSoon: 'settings.channels.aliyun.comingSoon',
    settingsChannelsAliyunDesc: 'settings.channels.aliyun.desc',
    settingsChannelsAliyunName: 'settings.channels.aliyun.name',
    settingsChannelsConfigure: 'settings.channels.configure',
    settingsChannelsConfigured: 'settings.channels.configured',
    settingsChannelsInactive: 'settings.channels.inactive',
    settingsChannelsMetaAccessToken: 'settings.channels.meta.accessToken',
    settingsChannelsMetaAccessTokenPlaceholder: 'settings.channels.meta.accessTokenPlaceholder',
    settingsChannelsMetaDesc: 'settings.channels.meta.desc',
    settingsChannelsMetaName: 'settings.channels.meta.name',
    settingsChannelsMetaPhoneNumberId: 'settings.channels.meta.phoneNumberId',
    settingsChannelsNoRecord: 'settings.channels.noRecord',
    settingsChannelsNotConfigured: 'settings.channels.notConfigured',
    settingsChannelsTitle: 'settings.channels.title',
    settingsChannelsTwilioDesc: 'settings.channels.twilio.desc',
    settingsChannelsTwilioName: 'settings.channels.twilio.name',
    settingsChannelsWhatsappAccountSid: 'settings.channels.whatsapp.accountSid',
    settingsChannelsWhatsappActive: 'settings.channels.whatsapp.active',
    settingsChannelsWhatsappAddChannel: 'settings.channels.whatsapp.addChannel',
    settingsChannelsWhatsappAuthToken: 'settings.channels.whatsapp.authToken',
    settingsChannelsWhatsappAuthTokenPlaceholder: 'settings.channels.whatsapp.authTokenPlaceholder',
    settingsChannelsWhatsappConnected: 'settings.channels.whatsapp.connected',
    settingsChannelsWhatsappDeleteConfirm: 'settings.channels.whatsapp.deleteConfirm',
    settingsChannelsWhatsappDeleteError: 'settings.channels.whatsapp.deleteError',
    settingsChannelsWhatsappDeleteSuccess: 'settings.channels.whatsapp.deleteSuccess',
    settingsChannelsWhatsappEditChannel: 'settings.channels.whatsapp.editChannel',
    settingsChannelsWhatsappEmpty: 'settings.channels.whatsapp.empty',
    settingsChannelsWhatsappFetchError: 'settings.channels.whatsapp.fetchError',
    settingsChannelsWhatsappInactive: 'settings.channels.whatsapp.inactive',
    settingsChannelsWhatsappNotConfigured: 'settings.channels.whatsapp.notConfigured',
    settingsChannelsWhatsappProviderType: 'settings.channels.whatsapp.providerType',
    settingsChannelsWhatsappRequiredFields: 'settings.channels.whatsapp.requiredFields',
    settingsChannelsWhatsappSaveError: 'settings.channels.whatsapp.saveError',
    settingsChannelsWhatsappSaveSuccess: 'settings.channels.whatsapp.saveSuccess',
    settingsChannelsWhatsappTestConnection: 'settings.channels.whatsapp.testConnection',
    settingsChannelsWhatsappTestError: 'settings.channels.whatsapp.testError',
    settingsChannelsWhatsappTitle: 'settings.channels.whatsapp.title',
    settingsChannelsWhatsappWhatsappNumber: 'settings.channels.whatsapp.whatsappNumber',
    settingsDescriptionsTenantLanguage: 'settings.descriptions.tenantLanguage',
    settingsHelpContextWindow: 'settings.help.contextWindow',
    settingsHelpEmbeddingApiKey: 'settings.help.embeddingApiKey',
    settingsHelpEmbeddingEndpointUrl: 'settings.help.embeddingEndpointUrl',
    settingsHelpEmbeddingModelGeneral: 'settings.help.embeddingModel.general',
    settingsHelpEmbeddingModelHasDocuments: 'settings.help.embeddingModel.hasDocuments',
    settingsHelpEmojiPolicy: 'settings.help.emojiPolicy',
    settingsHelpEnthusiasmLevel: 'settings.help.enthusiasmLevel',
    settingsHelpFormalityLevel: 'settings.help.formalityLevel',
    settingsHelpMaxResponseChars: 'settings.help.maxResponseChars',
    settingsHelpPersona: 'settings.help.persona',
    settingsHelpPolitenessLevel: 'settings.help.politenessLevel',
    settingsHelpResponsePreferences: 'settings.help.responsePreferences',
    settingsHelpTenantLanguage: 'settings.help.tenantLanguage',
    settingsHelpUseEmphasis: 'settings.help.useEmphasis',
    settingsHelpUseLineBreaks: 'settings.help.useLineBreaks',
    settingsLabelsAiModel: 'settings.labels.aiModel',
    settingsLabelsAllowedOrigins: 'settings.labels.allowedOrigins',
    settingsLabelsApiKey: 'settings.labels.apiKey',
    settingsLabelsApiRateLimit: 'settings.labels.apiRateLimit',
    settingsLabelsContextWindow: 'settings.labels.contextWindow',
    settingsLabelsEmailRecipients: 'settings.labels.emailRecipients',
    settingsLabelsEmbeddingApiKey: 'settings.labels.embeddingApiKey',
    settingsLabelsEmbeddingEndpointUrl: 'settings.labels.embeddingEndpointUrl',
    settingsLabelsEmbeddingModel: 'settings.labels.embeddingModel',
    settingsLabelsEmojiPolicy: 'settings.labels.emojiPolicy',
    settingsLabelsEnableContextWindow: 'settings.labels.enableContextWindow',
    settingsLabelsEnableEmailNotifications: 'settings.labels.enableEmailNotifications',
    settingsLabelsEnableErrorAlerts: 'settings.labels.enableErrorAlerts',
    settingsLabelsEnableExternalApi: 'settings.labels.enableExternalApi',
    settingsLabelsEnableSlackNotifications: 'settings.labels.enableSlackNotifications',
    settingsLabelsEnableStreaming: 'settings.labels.enableStreaming',
    settingsLabelsEnableWebhook: 'settings.labels.enableWebhook',
    settingsLabelsEnthusiasmLevel: 'settings.labels.enthusiasmLevel',
    settingsLabelsFormalityLevel: 'settings.labels.formalityLevel',
    settingsLabelsLineBreaks: 'settings.labels.lineBreaks',
    settingsLabelsMaxResponseChars: 'settings.labels.maxResponseChars',
    settingsLabelsMaxTokens: 'settings.labels.maxTokens',
    settingsLabelsPersona: 'settings.labels.persona',
    settingsLabelsPolitenessLevel: 'settings.labels.politenessLevel',
    settingsLabelsSlackWebhook: 'settings.labels.slackWebhook',
    settingsLabelsSystemLanguage: 'settings.labels.systemLanguage',
    settingsLabelsTemperature: 'settings.labels.temperature',
    settingsLabelsTenantUILanguage: 'settings.labels.tenantUILanguage',
    settingsLabelsTimezone: 'settings.labels.timezone',
    settingsLabelsUseEmphasis: 'settings.labels.useEmphasis',
    settingsLabelsWebhookUrl: 'settings.labels.webhookUrl',
    settingsMessagesApiKeyAdminDescription: 'settings.messages.apiKeyAdminDescription',
    settingsMessagesApiKeyNotSet: 'settings.messages.apiKeyNotSet',
    settingsMessagesApiKeyPlaceholder: 'settings.messages.apiKeyPlaceholder',
    settingsMessagesApiKeySet: 'settings.messages.apiKeySet',
    settingsMessagesApiKeyUserDescription: 'settings.messages.apiKeyUserDescription',
    settingsMessagesContactAdminToSet: 'settings.messages.contactAdminToSet',
    settingsMessagesEmbeddingApiKeyRequired: 'settings.messages.embeddingApiKeyRequired',
    settingsMessagesEmbeddingEndpointUrlInvalid: 'settings.messages.embeddingEndpointUrlInvalid',
    settingsMessagesEmbeddingEndpointUrlRequired: 'settings.messages.embeddingEndpointUrlRequired',
    settingsMessagesEnterFieldToEnable: 'settings.messages.enterFieldToEnable',
    settingsMessagesPasswordAdminDescription: 'settings.messages.passwordAdminDescription',
    settingsMessagesPasswordNotSet: 'settings.messages.passwordNotSet',
    settingsMessagesPasswordPlaceholder: 'settings.messages.passwordPlaceholder',
    settingsMessagesPasswordSet: 'settings.messages.passwordSet',
    settingsMessagesPasswordUserDescription: 'settings.messages.passwordUserDescription',
    settingsMessagesResetToDefaults: 'settings.messages.resetToDefaults',
    settingsMessagesSaveFailed: 'settings.messages.saveFailed',
    settingsMessagesSaveSuccess: 'settings.messages.saveSuccess',
    settingsMessagesTenantLanguageUpdateFailed: 'settings.messages.tenantLanguageUpdateFailed',
    settingsMessagesTenantLanguageUpdated: 'settings.messages.tenantLanguageUpdated',
    settingsMessagesUrlAdminDescription: 'settings.messages.urlAdminDescription',
    settingsMessagesUrlNotSet: 'settings.messages.urlNotSet',
    settingsMessagesUrlPlaceholder: 'settings.messages.urlPlaceholder',
    settingsMessagesUrlSet: 'settings.messages.urlSet',
    settingsMessagesUrlUserDescription: 'settings.messages.urlUserDescription',
    settingsMessagesWebhookAdminDescription: 'settings.messages.webhookAdminDescription',
    settingsMessagesWebhookNotSet: 'settings.messages.webhookNotSet',
    settingsMessagesWebhookPlaceholder: 'settings.messages.webhookPlaceholder',
    settingsMessagesWebhookSet: 'settings.messages.webhookSet',
    settingsMessagesWebhookUserDescription: 'settings.messages.webhookUserDescription',
    settingsOptionsEmbeddingModelsDashscope: 'settings.options.embeddingModels.dashscope',
    settingsOptionsEmbeddingModelsLocal: 'settings.options.embeddingModels.local',
    settingsOptionsModelsClaude3: 'settings.options.models.claude3',
    settingsOptionsModelsDeepseekChat: 'settings.options.models.deepseekChat',
    settingsOptionsModelsDeepseekReasoner: 'settings.options.models.deepseekReasoner',
    settingsOptionsModelsGpt35Turbo: 'settings.options.models.gpt35Turbo',
    settingsOptionsModelsGpt4: 'settings.options.models.gpt4',
    settingsOptionsModelsLocalModel: 'settings.options.models.localModel',
    settingsOptionsStyleEmojiPolicyFriendly: 'settings.options.style.emojiPolicyFriendly',
    settingsOptionsStyleEmojiPolicyMinimal: 'settings.options.style.emojiPolicyMinimal',
    settingsOptionsStyleEmojiPolicyModerate: 'settings.options.style.emojiPolicyModerate',
    settingsOptionsStyleEmojiPolicyNone: 'settings.options.style.emojiPolicyNone',
    settingsOptionsStyleEnthusiasmLevel1: 'settings.options.style.enthusiasmLevel1',
    settingsOptionsStyleEnthusiasmLevel2: 'settings.options.style.enthusiasmLevel2',
    settingsOptionsStyleEnthusiasmLevel3: 'settings.options.style.enthusiasmLevel3',
    settingsOptionsStyleEnthusiasmLevel4: 'settings.options.style.enthusiasmLevel4',
    settingsOptionsStyleEnthusiasmLevel5: 'settings.options.style.enthusiasmLevel5',
    settingsOptionsStyleFormalityLevel1: 'settings.options.style.formalityLevel1',
    settingsOptionsStyleFormalityLevel2: 'settings.options.style.formalityLevel2',
    settingsOptionsStyleFormalityLevel3: 'settings.options.style.formalityLevel3',
    settingsOptionsStyleFormalityLevel4: 'settings.options.style.formalityLevel4',
    settingsOptionsStyleFormalityLevel5: 'settings.options.style.formalityLevel5',
    settingsOptionsStylePolitenessLevel1: 'settings.options.style.politenessLevel1',
    settingsOptionsStylePolitenessLevel2: 'settings.options.style.politenessLevel2',
    settingsOptionsStylePolitenessLevel3: 'settings.options.style.politenessLevel3',
    settingsOptionsStylePolitenessLevel4: 'settings.options.style.politenessLevel4',
    settingsOptionsStylePolitenessLevel5: 'settings.options.style.politenessLevel5',
    settingsOptionsTemperatureMarksBalanced: 'settings.options.temperatureMarks.balanced',
    settingsOptionsTemperatureMarksCreative: 'settings.options.temperatureMarks.creative',
    settingsOptionsTemperatureMarksPrecise: 'settings.options.temperatureMarks.precise',
    settingsOptionsTimezonesAmericaNewYork: 'settings.options.timezones.americaNewYork',
    settingsOptionsTimezonesAsiaShanghai: 'settings.options.timezones.asiaShanghai',
    settingsOptionsTimezonesEuropeLondon: 'settings.options.timezones.europeLondon',
    settingsPlaceholdersEnterAllowedOrigins: 'settings.placeholders.enterAllowedOrigins',
    settingsPlaceholdersEnterApiKey: 'settings.placeholders.enterApiKey',
    settingsPlaceholdersEnterEmail: 'settings.placeholders.enterEmail',
    settingsPlaceholdersEnterEmbeddingApiKey: 'settings.placeholders.enterEmbeddingApiKey',
    settingsPlaceholdersEnterEmbeddingEndpointUrl: 'settings.placeholders.enterEmbeddingEndpointUrl',
    settingsPlaceholdersEnterSlackWebhook: 'settings.placeholders.enterSlackWebhook',
    settingsPlaceholdersEnterWebhookUrl: 'settings.placeholders.enterWebhookUrl',
    settingsPlaceholdersPersona: 'settings.placeholders.persona',
    settingsSectionsAdvancedConfiguration: 'settings.sections.advancedConfiguration',
    settingsSectionsAlertConfiguration: 'settings.sections.alertConfiguration',
    settingsSectionsApiConfiguration: 'settings.sections.apiConfiguration',
    settingsSectionsBasicConfiguration: 'settings.sections.basicConfiguration',
    settingsSectionsBrandPersona: 'settings.sections.brandPersona',
    settingsSectionsEmailNotifications: 'settings.sections.emailNotifications',
    settingsSectionsEmbeddingConfiguration: 'settings.sections.embeddingConfiguration',
    settingsSectionsModelConfiguration: 'settings.sections.modelConfiguration',
    settingsSectionsResponsePreferences: 'settings.sections.responsePreferences',
    settingsSectionsSlackNotifications: 'settings.sections.slackNotifications',
    settingsSectionsTenantLanguage: 'settings.sections.tenantLanguage',
    settingsSectionsToneLevels: 'settings.sections.toneLevels',
    settingsSectionsWebhookConfiguration: 'settings.sections.webhookConfiguration',
    settingsTabsAi: 'settings.tabs.ai',
    settingsTabsGeneral: 'settings.tabs.general',
    settingsTabsIntegrations: 'settings.tabs.integrations',
    settingsTabsNotifications: 'settings.tabs.notifications',
    settingsTabsStyle: 'settings.tabs.style',
    settingsTabsTenantExport: 'settings.tabs.tenantExport',
    settingsTenantExportConfirm: 'settings.tenantExport.confirm',
    settingsTenantExportExportButton: 'settings.tenantExport.exportButton',
    settingsTenantExportExportFailed: 'settings.tenantExport.exportFailed',
    settingsTenantExportExportSuccess: 'settings.tenantExport.exportSuccess',
    settingsTenantExportImportButton: 'settings.tenantExport.importButton',
    settingsTenantExportImportFailed: 'settings.tenantExport.importFailed',
    settingsTenantExportImportSuccess: 'settings.tenantExport.importSuccess',
    settingsTenantExportImportSummaryTitle: 'settings.tenantExport.importSummaryTitle',
    settingsTenantExportIncludeKb: 'settings.tenantExport.includeKb',
    settingsTenantExportNoCompany: 'settings.tenantExport.noCompany',
    settingsTenantExportSummaryCompany: 'settings.tenantExport.summary.company',
    settingsTenantExportSummaryConnectors: 'settings.tenantExport.summary.connectors',
    settingsTenantExportSummaryCreated: 'settings.tenantExport.summary.created',
    settingsTenantExportSummaryDataSources: 'settings.tenantExport.summary.dataSources',
    settingsTenantExportSummaryImported: 'settings.tenantExport.summary.imported',
    settingsTenantExportSummaryKnowledgeBase: 'settings.tenantExport.summary.knowledgeBase',
    settingsTenantExportSummaryPlatformIntegrations: 'settings.tenantExport.summary.platformIntegrations',
    settingsTenantExportSummarySettings: 'settings.tenantExport.summary.settings',
    settingsTenantExportSummarySkipped: 'settings.tenantExport.summary.skipped',
    settingsTenantExportSummaryUpdated: 'settings.tenantExport.summary.updated',
    settingsTenantExportSummaryUsers: 'settings.tenantExport.summary.users',
    settingsTenantExportTitle: 'settings.tenantExport.title',
    settingsTitle: 'settings.title',
    userManagementCreate: 'userManagement.create',
    userManagementCreateFailed: 'userManagement.createFailed',
    userManagementCreateModalCancel: 'userManagement.createModal.cancel',
    userManagementCreateModalOk: 'userManagement.createModal.ok',
    userManagementCreateModalTitle: 'userManagement.createModal.title',
    userManagementCreateSuccess: 'userManagement.createSuccess',
    userManagementFetchFailed: 'userManagement.fetchFailed',
    userManagementFormDisplayName: 'userManagement.form.displayName',
    userManagementFormMaxSessions: 'userManagement.form.maxSessions',
    userManagementFormPassword: 'userManagement.form.password',
    userManagementFormUsername: 'userManagement.form.username',
    userManagementNoPermission: 'userManagement.noPermission',
    userManagementRefresh: 'userManagement.refresh',
    userManagementTitle: 'userManagement.title',
    userManagementUsernameExists: 'userManagement.usernameExists',
  },
  components: {
    navigationAgentConfig: 'navigation.agentConfig',
    navigationChatbot: 'navigation.chatbot',
    navigationCompanies: 'navigation.companies',
    navigationConnectors: 'navigation.connectors',
    navigationDashboard: 'navigation.dashboard',
    navigationHistory: 'navigation.history',
    navigationKnowledge: 'navigation.knowledge',
    navigationOrders: 'navigation.orders',
    navigationProfile: 'navigation.profile',
    navigationSettings: 'navigation.settings',
    navigationUsermanagement: 'navigation.user_management',
    sidebarCollapse: 'sidebar.collapse',
    sidebarExpand: 'sidebar.expand',
  },
  errors: {
    apiBadRequest: 'api.badRequest',
    apiConfigError: 'api.configError',
    apiForbidden: 'api.forbidden',
    apiNetworkDisconnected: 'api.networkDisconnected',
    apiNetworkError: 'api.networkError',
    apiNotFound: 'api.notFound',
    apiRequestFailed: 'api.requestFailed',
    apiRequestFailedWithStatus: 'api.requestFailedWithStatus',
    apiServerError: 'api.serverError',
    apiServiceUnavailable: 'api.serviceUnavailable',
    apiUnauthorized: 'api.unauthorized',
    forbidden: 'forbidden',
    network: 'network',
    notFound: 'notFound',
    server: 'server',
    timeout: 'timeout',
    unauthorized: 'unauthorized',
    unknown: 'unknown',
    validation: 'validation',
  },
  validation: {},
} as const;
// 类型安全的翻译键访问器
export namespace I18nKeys {
  export namespace Common {
    export const appFullName = 'common:app.fullName' as const;
    export const appName = 'common:app.name' as const;
    export const appShortName = 'common:app.shortName' as const;
    export const appVersion = 'common:app.version' as const;
    export const authCheckingAuthStatus = 'common:auth.checkingAuthStatus' as const;
    export const authLoadingUserInfo = 'common:auth.loadingUserInfo' as const;
    export const back = 'common:back' as const;
    export const backToHome = 'common:backToHome' as const;
    export const cancel = 'common:cancel' as const;
    export const close = 'common:close' as const;
    export const confirm = 'common:confirm' as const;
    export const delete_ = 'common:delete' as const;
    export const edit = 'common:edit' as const;
    export const error = 'common:error' as const;
    export const errorsAdminRoleRequired = 'common:errors.adminRoleRequired' as const;
    export const errorsCurrentUserRole = 'common:errors.currentUserRole' as const;
    export const errorsInsufficientPermissions = 'common:errors.insufficientPermissions' as const;
    export const errorsNoPermissionDescription = 'common:errors.noPermissionDescription' as const;
    export const errorsRequiredPermissions = 'common:errors.requiredPermissions' as const;
    export const filter = 'common:filter' as const;
    export const helpAbout = 'common:help.about' as const;
    export const helpAboutModalAddress = 'common:help.aboutModal.address' as const;
    export const helpAboutModalAddressValue = 'common:help.aboutModal.addressValue' as const;
    export const helpAboutModalCompany = 'common:help.aboutModal.company' as const;
    export const helpAboutModalCompanyLabel = 'common:help.aboutModal.companyLabel' as const;
    export const helpAboutModalContact = 'common:help.aboutModal.contact' as const;
    export const helpAboutModalCopyright = 'common:help.aboutModal.copyright' as const;
    export const helpAboutModalProductName = 'common:help.aboutModal.productName' as const;
    export const helpAboutModalTitle = 'common:help.aboutModal.title' as const;
    export const helpAboutModalVersion = 'common:help.aboutModal.version' as const;
    export const helpFeedback = 'common:help.feedback' as const;
    export const helpFeedbackModalContent = 'common:help.feedbackModal.content' as const;
    export const helpFeedbackModalContentPlaceholder = 'common:help.feedbackModal.contentPlaceholder' as const;
    export const helpFeedbackModalSubmitSuccess = 'common:help.feedbackModal.submitSuccess' as const;
    export const helpFeedbackModalTitle = 'common:help.feedbackModal.title' as const;
    export const helpFeedbackModalType = 'common:help.feedbackModal.type' as const;
    export const helpFeedbackModalTypeBug = 'common:help.feedbackModal.type.bug' as const;
    export const helpFeedbackModalTypeFeature = 'common:help.feedbackModal.type.feature' as const;
    export const helpFeedbackModalTypeOther = 'common:help.feedbackModal.type.other' as const;
    export const helpFeedbackModalTypeUi = 'common:help.feedbackModal.type.ui' as const;
    export const helpFeedbackModalTypePlaceholder = 'common:help.feedbackModal.typePlaceholder' as const;
    export const languageCurrent = 'common:language.current' as const;
    export const languageEnUS = 'common:language.en-US' as const;
    export const languagePtBR = 'common:language.pt-BR' as const;
    export const languageSwitch = 'common:language.switch' as const;
    export const languageZhCN = 'common:language.zh-CN' as const;
    export const loading = 'common:loading' as const;
    export const loadingResources = 'common:loadingResources' as const;
    export const loadingSystem = 'common:loadingSystem' as const;
    export const more = 'common:more' as const;
    export const next = 'common:next' as const;
    export const notificationClearAll = 'common:notification.clearAll' as const;
    export const notificationConnectorDeletedBody = 'common:notification.connector.deleted.body' as const;
    export const notificationConnectorDeletedTitle = 'common:notification.connector.deleted.title' as const;
    export const notificationConnectorErrorBody = 'common:notification.connector.error.body' as const;
    export const notificationConnectorErrorTitle = 'common:notification.connector.error.title' as const;
    export const notificationConnectorSavedBody = 'common:notification.connector.saved.body' as const;
    export const notificationConnectorSavedTitle = 'common:notification.connector.saved.title' as const;
    export const notificationEmpty = 'common:notification.empty' as const;
    export const notificationLevelError = 'common:notification.level.error' as const;
    export const notificationLevelInfo = 'common:notification.level.info' as const;
    export const notificationLevelSuccess = 'common:notification.level.success' as const;
    export const notificationLevelWarning = 'common:notification.level.warning' as const;
    export const notificationMarkAllRead = 'common:notification.markAllRead' as const;
    export const notificationTitle = 'common:notification.title' as const;
    export const pageNotFound = 'common:pageNotFound' as const;
    export const refresh = 'common:refresh' as const;
    export const reset = 'common:reset' as const;
    export const restoringSession = 'common:restoringSession' as const;
    export const roleAdmin = 'common:role.admin' as const;
    export const roleCompanyadmin = 'common:role.company_admin' as const;
    export const roleGuest = 'common:role.guest' as const;
    export const roleRegularuser = 'common:role.regular_user' as const;
    export const roleSuperadmin = 'common:role.super_admin' as const;
    export const roleUnknown = 'common:role.unknown' as const;
    export const roleUser = 'common:role.user' as const;
    export const save = 'common:save' as const;
    export const saved = 'common:saved' as const;
    export const saving = 'common:saving' as const;
    export const search = 'common:search' as const;
    export const submit = 'common:submit' as const;
    export const success = 'common:success' as const;
    export const timeAgo = 'common:time.ago' as const;
    export const timeDay = 'common:time.day' as const;
    export const timeHour = 'common:time.hour' as const;
    export const timeJustNow = 'common:time.justNow' as const;
    export const timeMinute = 'common:time.minute' as const;
    export const timeMonth = 'common:time.month' as const;
    export const timeSecond = 'common:time.second' as const;
    export const timeWeek = 'common:time.week' as const;
    export const timeYear = 'common:time.year' as const;
    export const userLogout = 'common:user.logout' as const;
    export const userProfile = 'common:user.profile' as const;
    export const userSettings = 'common:user.settings' as const;
    export const view = 'common:view' as const;
  }

  export namespace Pages {
    export const loginAccountDisabled = 'pages:login.accountDisabled' as const;
    export const loginCopyright = 'pages:login.copyright' as const;
    export const loginForgotPassword = 'pages:login.forgotPassword' as const;
    export const loginInvalidCredentials = 'pages:login.invalidCredentials' as const;
    export const loginLoggingIn = 'pages:login.loggingIn' as const;
    export const loginLoginButton = 'pages:login.loginButton' as const;
    export const loginLoginError = 'pages:login.loginError' as const;
    export const loginLoginFailed = 'pages:login.loginFailed' as const;
    export const loginNoAccount = 'pages:login.noAccount' as const;
    export const loginOr = 'pages:login.or' as const;
    export const loginPassword = 'pages:login.password' as const;
    export const loginPasswordMinLength = 'pages:login.passwordMinLength' as const;
    export const loginPasswordPlaceholder = 'pages:login.passwordPlaceholder' as const;
    export const loginPasswordRequired = 'pages:login.passwordRequired' as const;
    export const loginPrivacyLink = 'pages:login.privacyLink' as const;
    export const loginRegisterButton = 'pages:login.registerButton' as const;
    export const loginSubtitle = 'pages:login.subtitle' as const;
    export const loginSupport = 'pages:login.support' as const;
    export const loginTerms = 'pages:login.terms' as const;
    export const loginTermsLink = 'pages:login.termsLink' as const;
    export const loginTitle = 'pages:login.title' as const;
    export const loginTooManyAttempts = 'pages:login.tooManyAttempts' as const;
    export const loginUsername = 'pages:login.username' as const;
    export const loginUsernameMaxLength = 'pages:login.usernameMaxLength' as const;
    export const loginUsernameMinLength = 'pages:login.usernameMinLength' as const;
    export const loginUsernamePlaceholder = 'pages:login.usernamePlaceholder' as const;
    export const loginUsernameRequired = 'pages:login.usernameRequired' as const;
    export const profileButtonsCancel = 'pages:profile.buttons.cancel' as const;
    export const profileButtonsChangePassword = 'pages:profile.buttons.changePassword' as const;
    export const profileButtonsEditProfile = 'pages:profile.buttons.editProfile' as const;
    export const profileButtonsSaveChanges = 'pages:profile.buttons.saveChanges' as const;
    export const profileFieldsAccountStatus = 'pages:profile.fields.accountStatus' as const;
    export const profileFieldsCompanyDescription = 'pages:profile.fields.companyDescription' as const;
    export const profileFieldsCompanyName = 'pages:profile.fields.companyName' as const;
    export const profileFieldsConfirmPassword = 'pages:profile.fields.confirmPassword' as const;
    export const profileFieldsCreationTime = 'pages:profile.fields.creationTime' as const;
    export const profileFieldsCurrentPassword = 'pages:profile.fields.currentPassword' as const;
    export const profileFieldsEmail = 'pages:profile.fields.email' as const;
    export const profileFieldsEmailNotSet = 'pages:profile.fields.emailNotSet' as const;
    export const profileFieldsNewPassword = 'pages:profile.fields.newPassword' as const;
    export const profileFieldsNoDescription = 'pages:profile.fields.noDescription' as const;
    export const profileFieldsNotSet = 'pages:profile.fields.notSet' as const;
    export const profileFieldsRegistrationTime = 'pages:profile.fields.registrationTime' as const;
    export const profileFieldsRole = 'pages:profile.fields.role' as const;
    export const profileFieldsUnknown = 'pages:profile.fields.unknown' as const;
    export const profileFieldsUserId = 'pages:profile.fields.userId' as const;
    export const profileFieldsUsername = 'pages:profile.fields.username' as const;
    export const profileMessagesCompanyInfoNote = 'pages:profile.messages.companyInfoNote' as const;
    export const profileMessagesPasswordChangeFailed = 'pages:profile.messages.passwordChangeFailed' as const;
    export const profileMessagesPasswordChangeSuccess = 'pages:profile.messages.passwordChangeSuccess' as const;
    export const profileMessagesPasswordSecurityAdvice = 'pages:profile.messages.passwordSecurityAdvice' as const;
    export const profileMessagesUpdateFailed = 'pages:profile.messages.updateFailed' as const;
    export const profileMessagesUpdateSuccess = 'pages:profile.messages.updateSuccess' as const;
    export const profilePlaceholdersConfirmPassword = 'pages:profile.placeholders.confirmPassword' as const;
    export const profilePlaceholdersCurrentPassword = 'pages:profile.placeholders.currentPassword' as const;
    export const profilePlaceholdersEmail = 'pages:profile.placeholders.email' as const;
    export const profilePlaceholdersNewPassword = 'pages:profile.placeholders.newPassword' as const;
    export const profilePlaceholdersUsername = 'pages:profile.placeholders.username' as const;
    export const profileSectionsChangePassword = 'pages:profile.sections.changePassword' as const;
    export const profileStatusActive = 'pages:profile.status.active' as const;
    export const profileStatusInactive = 'pages:profile.status.inactive' as const;
    export const profileSubtitle = 'pages:profile.subtitle' as const;
    export const profileTabsCompany = 'pages:profile.tabs.company' as const;
    export const profileTabsProfile = 'pages:profile.tabs.profile' as const;
    export const profileTabsSecurity = 'pages:profile.tabs.security' as const;
    export const profileTitle = 'pages:profile.title' as const;
    export const profileValidationCurrentPasswordRequired = 'pages:profile.validation.currentPasswordRequired' as const;
    export const profileValidationEmailInvalid = 'pages:profile.validation.emailInvalid' as const;
    export const profileValidationPasswordMinLength = 'pages:profile.validation.passwordMinLength' as const;
    export const profileValidationPasswordMismatch = 'pages:profile.validation.passwordMismatch' as const;
    export const profileValidationPasswordRequired = 'pages:profile.validation.passwordRequired' as const;
    export const profileValidationUsernameMaxLength = 'pages:profile.validation.usernameMaxLength' as const;
    export const profileValidationUsernameMinLength = 'pages:profile.validation.usernameMinLength' as const;
    export const profileValidationUsernameRequired = 'pages:profile.validation.usernameRequired' as const;
    export const registerAccountInfo = 'pages:register.accountInfo' as const;
    export const registerAdminPermission1 = 'pages:register.adminPermission1' as const;
    export const registerAdminPermission2 = 'pages:register.adminPermission2' as const;
    export const registerAdminPermission3 = 'pages:register.adminPermission3' as const;
    export const registerAdminPermission4 = 'pages:register.adminPermission4' as const;
    export const registerAdminPermissions = 'pages:register.adminPermissions' as const;
    export const registerAgreeTerms = 'pages:register.agreeTerms' as const;
    export const registerAgreeTermsRequired = 'pages:register.agreeTermsRequired' as const;
    export const registerAlreadyHaveAccount = 'pages:register.alreadyHaveAccount' as const;
    export const registerAlreadyHaveAccountText = 'pages:register.alreadyHaveAccountText' as const;
    export const registerCompanyDescription = 'pages:register.companyDescription' as const;
    export const registerCompanyDescriptionField = 'pages:register.companyDescriptionField' as const;
    export const registerCompanyDescriptionMaxLength = 'pages:register.companyDescriptionMaxLength' as const;
    export const registerCompanyDescriptionPlaceholder = 'pages:register.companyDescriptionPlaceholder' as const;
    export const registerCompanyInfo = 'pages:register.companyInfo' as const;
    export const registerCompanyName = 'pages:register.companyName' as const;
    export const registerCompanyNameMaxLength = 'pages:register.companyNameMaxLength' as const;
    export const registerCompanyNameMinLength = 'pages:register.companyNameMinLength' as const;
    export const registerCompanyNamePlaceholder = 'pages:register.companyNamePlaceholder' as const;
    export const registerCompanyNameRequired = 'pages:register.companyNameRequired' as const;
    export const registerConfirmPassword = 'pages:register.confirmPassword' as const;
    export const registerConfirmPasswordMismatch = 'pages:register.confirmPasswordMismatch' as const;
    export const registerConfirmPasswordPlaceholder = 'pages:register.confirmPasswordPlaceholder' as const;
    export const registerConfirmPasswordRequired = 'pages:register.confirmPasswordRequired' as const;
    export const registerCopyright = 'pages:register.copyright' as const;
    export const registerEmail = 'pages:register.email' as const;
    export const registerEmailInvalid = 'pages:register.emailInvalid' as const;
    export const registerEmailPlaceholder = 'pages:register.emailPlaceholder' as const;
    export const registerEmailRequired = 'pages:register.emailRequired' as const;
    export const registerLoginButton = 'pages:register.loginButton' as const;
    export const registerPassword = 'pages:register.password' as const;
    export const registerPasswordPlaceholder = 'pages:register.passwordPlaceholder' as const;
    export const registerPasswordRequired = 'pages:register.passwordRequired' as const;
    export const registerPasswordRequirement1 = 'pages:register.passwordRequirement1' as const;
    export const registerPasswordRequirement2 = 'pages:register.passwordRequirement2' as const;
    export const registerPasswordRequirement3 = 'pages:register.passwordRequirement3' as const;
    export const registerPasswordRequirement4 = 'pages:register.passwordRequirement4' as const;
    export const registerPasswordRequirements = 'pages:register.passwordRequirements' as const;
    export const registerPasswordStrengthEnough = 'pages:register.passwordStrengthEnough' as const;
    export const registerPasswordStrengthMinLength = 'pages:register.passwordStrengthMinLength' as const;
    export const registerPasswordStrengthNumbers = 'pages:register.passwordStrengthNumbers' as const;
    export const registerPasswordStrengthSpecial = 'pages:register.passwordStrengthSpecial' as const;
    export const registerPasswordStrengthUpperLower = 'pages:register.passwordStrengthUpperLower' as const;
    export const registerPrivacyLink = 'pages:register.privacyLink' as const;
    export const registerRegisterButton = 'pages:register.registerButton' as const;
    export const registerRegisterError = 'pages:register.registerError' as const;
    export const registerRegisterFailed = 'pages:register.registerFailed' as const;
    export const registerRegisterSuccess = 'pages:register.registerSuccess' as const;
    export const registerRegistering = 'pages:register.registering' as const;
    export const registerSubtitle = 'pages:register.subtitle' as const;
    export const registerSupport = 'pages:register.support' as const;
    export const registerTerms = 'pages:register.terms' as const;
    export const registerTermsLink = 'pages:register.termsLink' as const;
    export const registerTitle = 'pages:register.title' as const;
    export const registerUsername = 'pages:register.username' as const;
    export const registerUsernameMaxLength = 'pages:register.usernameMaxLength' as const;
    export const registerUsernameMinLength = 'pages:register.usernameMinLength' as const;
    export const registerUsernamePlaceholder = 'pages:register.usernamePlaceholder' as const;
    export const registerUsernameRequired = 'pages:register.usernameRequired' as const;
    export const registerUsernameTaken = 'pages:register.usernameTaken' as const;
    export const userManagementButtonsActivate = 'pages:userManagement.buttons.activate' as const;
    export const userManagementButtonsDeactivate = 'pages:userManagement.buttons.deactivate' as const;
    export const userManagementButtonsDelete = 'pages:userManagement.buttons.delete' as const;
    export const userManagementButtonsEdit = 'pages:userManagement.buttons.edit' as const;
    export const userManagementButtonsRefresh = 'pages:userManagement.buttons.refresh' as const;
    export const userManagementCreateSuccess = 'pages:userManagement.createSuccess' as const;
    export const userManagementCreateUser = 'pages:userManagement.createUser' as const;
    export const userManagementCurrentUser = 'pages:userManagement.currentUser' as const;
    export const userManagementDeleteConfirmCancelText = 'pages:userManagement.deleteConfirm.cancelText' as const;
    export const userManagementDeleteConfirmDescription = 'pages:userManagement.deleteConfirm.description' as const;
    export const userManagementDeleteConfirmOkText = 'pages:userManagement.deleteConfirm.okText' as const;
    export const userManagementDeleteConfirmTitle = 'pages:userManagement.deleteConfirm.title' as const;
    export const userManagementFetchFailed = 'pages:userManagement.fetchFailed' as const;
    export const userManagementLoading = 'pages:userManagement.loading' as const;
    export const userManagementMessagesActivateFailed = 'pages:userManagement.messages.activateFailed' as const;
    export const userManagementMessagesActivateSuccess = 'pages:userManagement.messages.activateSuccess' as const;
    export const userManagementMessagesDeactivateFailed = 'pages:userManagement.messages.deactivateFailed' as const;
    export const userManagementMessagesDeactivateSuccess = 'pages:userManagement.messages.deactivateSuccess' as const;
    export const userManagementMessagesDeleteFailed = 'pages:userManagement.messages.deleteFailed' as const;
    export const userManagementMessagesDeleteSuccess = 'pages:userManagement.messages.deleteSuccess' as const;
    export const userManagementMessagesEditInfo = 'pages:userManagement.messages.editInfo' as const;
    export const userManagementNeverLoggedIn = 'pages:userManagement.neverLoggedIn' as const;
    export const userManagementNoData = 'pages:userManagement.noData' as const;
    export const userManagementNoPermission = 'pages:userManagement.noPermission' as const;
    export const userManagementPaginationShowTotal = 'pages:userManagement.pagination.showTotal' as const;
    export const userManagementRefresh = 'pages:userManagement.refresh' as const;
    export const userManagementSearchPlaceholder = 'pages:userManagement.searchPlaceholder' as const;
    export const userManagementStatusActive = 'pages:userManagement.status.active' as const;
    export const userManagementStatusInactive = 'pages:userManagement.status.inactive' as const;
    export const userManagementTableColumnsActions = 'pages:userManagement.table.columns.actions' as const;
    export const userManagementTableColumnsCreatedAt = 'pages:userManagement.table.columns.createdAt' as const;
    export const userManagementTableColumnsEmail = 'pages:userManagement.table.columns.email' as const;
    export const userManagementTableColumnsLastLogin = 'pages:userManagement.table.columns.lastLogin' as const;
    export const userManagementTableColumnsRole = 'pages:userManagement.table.columns.role' as const;
    export const userManagementTableColumnsStatus = 'pages:userManagement.table.columns.status' as const;
    export const userManagementTableColumnsUsername = 'pages:userManagement.table.columns.username' as const;
    export const userManagementTitle = 'pages:userManagement.title' as const;
  }

  export namespace Modules {
    export const agentConfigForbiddenWordsCount = 'modules:agentConfig.forbiddenWords.count' as const;
    export const agentConfigForbiddenWordsPlaceholder = 'modules:agentConfig.forbiddenWords.placeholder' as const;
    export const agentConfigForbiddenWordsSaveFailed = 'modules:agentConfig.forbiddenWords.saveFailed' as const;
    export const agentConfigForbiddenWordsSaveSuccess = 'modules:agentConfig.forbiddenWords.saveSuccess' as const;
    export const agentConfigForbiddenWordsTip = 'modules:agentConfig.forbiddenWords.tip' as const;
    export const agentConfigPoliciesAdd = 'modules:agentConfig.policies.add' as const;
    export const agentConfigPoliciesContent = 'modules:agentConfig.policies.content' as const;
    export const agentConfigPoliciesContentHelp = 'modules:agentConfig.policies.contentHelp' as const;
    export const agentConfigPoliciesContentPlaceholder = 'modules:agentConfig.policies.contentPlaceholder' as const;
    export const agentConfigPoliciesCreated = 'modules:agentConfig.policies.created' as const;
    export const agentConfigPoliciesDeleteConfirm = 'modules:agentConfig.policies.deleteConfirm' as const;
    export const agentConfigPoliciesDeleteSuccess = 'modules:agentConfig.policies.deleteSuccess' as const;
    export const agentConfigPoliciesDescription = 'modules:agentConfig.policies.description' as const;
    export const agentConfigPoliciesDescriptionHelp = 'modules:agentConfig.policies.descriptionHelp' as const;
    export const agentConfigPoliciesDescriptionPlaceholder = 'modules:agentConfig.policies.descriptionPlaceholder' as const;
    export const agentConfigPoliciesEdit = 'modules:agentConfig.policies.edit' as const;
    export const agentConfigPoliciesEmpty = 'modules:agentConfig.policies.empty' as const;
    export const agentConfigPoliciesEmptyDescription = 'modules:agentConfig.policies.emptyDescription' as const;
    export const agentConfigPoliciesIsActive = 'modules:agentConfig.policies.isActive' as const;
    export const agentConfigPoliciesName = 'modules:agentConfig.policies.name' as const;
    export const agentConfigPoliciesNamePlaceholder = 'modules:agentConfig.policies.namePlaceholder' as const;
    export const agentConfigPoliciesPriority = 'modules:agentConfig.policies.priority' as const;
    export const agentConfigPoliciesSaveSuccess = 'modules:agentConfig.policies.saveSuccess' as const;
    export const agentConfigPoliciesTitle = 'modules:agentConfig.policies.title' as const;
    export const agentConfigPoliciesUpdated = 'modules:agentConfig.policies.updated' as const;
    export const agentConfigTabsForbiddenWords = 'modules:agentConfig.tabs.forbiddenWords' as const;
    export const agentConfigTabsPolicies = 'modules:agentConfig.tabs.policies' as const;
    export const agentConfigTabsStyle = 'modules:agentConfig.tabs.style' as const;
    export const chatWindowLoadFailed = 'modules:chatWindow.loadFailed' as const;
    export const chatWindowLoadingMessages = 'modules:chatWindow.loadingMessages' as const;
    export const chatWindowNoMessages = 'modules:chatWindow.noMessages' as const;
    export const chatWindowRoleAssistant = 'modules:chatWindow.role.assistant' as const;
    export const chatWindowRoleHuman = 'modules:chatWindow.role.human' as const;
    export const chatWindowRoleSystem = 'modules:chatWindow.role.system' as const;
    export const chatWindowRoleUser = 'modules:chatWindow.role.user' as const;
    export const chatWindowSelectConversation = 'modules:chatWindow.selectConversation' as const;
    export const chatbotAlertsConnected = 'modules:chatbot.alerts.connected' as const;
    export const chatbotAlertsConnecting = 'modules:chatbot.alerts.connecting' as const;
    export const chatbotAlertsDisconnected = 'modules:chatbot.alerts.disconnected' as const;
    export const chatbotAlertsError = 'modules:chatbot.alerts.error' as const;
    export const chatbotAlertsReady = 'modules:chatbot.alerts.ready' as const;
    export const chatbotContextEmpty = 'modules:chatbot.context.empty' as const;
    export const chatbotContextError = 'modules:chatbot.context.error' as const;
    export const chatbotContextRefresh = 'modules:chatbot.context.refresh' as const;
    export const chatbotContextTitle = 'modules:chatbot.context.title' as const;
    export const chatbotEmptyNoMessages = 'modules:chatbot.empty.noMessages' as const;
    export const chatbotInputAriaLabel = 'modules:chatbot.input.ariaLabel' as const;
    export const chatbotInputPlaceholder = 'modules:chatbot.input.placeholder' as const;
    export const chatbotInputSend = 'modules:chatbot.input.send' as const;
    export const chatbotInputSendAriaLabel = 'modules:chatbot.input.sendAriaLabel' as const;
    export const chatbotInputSending = 'modules:chatbot.input.sending' as const;
    export const chatbotMessagesBot = 'modules:chatbot.messages.bot' as const;
    export const chatbotMessagesTyping = 'modules:chatbot.messages.typing' as const;
    export const chatbotMessagesUser = 'modules:chatbot.messages.user' as const;
    export const chatbotTitle = 'modules:chatbot.title' as const;
    export const chatbotWelcomeMessage = 'modules:chatbot.welcomeMessage' as const;
    export const commonCancel = 'modules:common.cancel' as const;
    export const commonConfirm = 'modules:common.confirm' as const;
    export const commonEdit = 'modules:common.edit' as const;
    export const commonSave = 'modules:common.save' as const;
    export const companyCancel = 'modules:company.cancel' as const;
    export const companyCreatedAt = 'modules:company.createdAt' as const;
    export const companyDescMaxLength = 'modules:company.descMaxLength' as const;
    export const companyDescPlaceholder = 'modules:company.descPlaceholder' as const;
    export const companyDescription = 'modules:company.description' as const;
    export const companyEditInfo = 'modules:company.editInfo' as const;
    export const companyFetchError = 'modules:company.fetchError' as const;
    export const companyId = 'modules:company.id' as const;
    export const companyLoading = 'modules:company.loading' as const;
    export const companyName = 'modules:company.name' as const;
    export const companyNameMaxLength = 'modules:company.nameMaxLength' as const;
    export const companyNamePlaceholder = 'modules:company.namePlaceholder' as const;
    export const companyNameRequired = 'modules:company.nameRequired' as const;
    export const companyNoDescription = 'modules:company.noDescription' as const;
    export const companyNoInfo = 'modules:company.noInfo' as const;
    export const companyNoPermission = 'modules:company.noPermission' as const;
    export const companySave = 'modules:company.save' as const;
    export const companyTitle = 'modules:company.title' as const;
    export const companyUpdateFailed = 'modules:company.updateFailed' as const;
    export const companyUpdateSuccess = 'modules:company.updateSuccess' as const;
    export const companyUpdatedAt = 'modules:company.updatedAt' as const;
    export const connectorsAddConnector = 'modules:connectors.addConnector' as const;
    export const connectorsAddFirst = 'modules:connectors.addFirst' as const;
    export const connectorsConnectionFailed = 'modules:connectors.connectionFailed' as const;
    export const connectorsConnectionHealthy = 'modules:connectors.connectionHealthy' as const;
    export const connectorsDeleteFailed = 'modules:connectors.deleteFailed' as const;
    export const connectorsDeleted = 'modules:connectors.deleted' as const;
    export const connectorsEmptyDescription = 'modules:connectors.emptyDescription' as const;
    export const connectorsRefresh = 'modules:connectors.refresh' as const;
    export const connectorsTestFailed = 'modules:connectors.testFailed' as const;
    export const connectorsTitle = 'modules:connectors.title' as const;
    export const conversationListEmpty = 'modules:conversationList.empty' as const;
    export const conversationListTimeHours = 'modules:conversationList.time.hours' as const;
    export const conversationListTimeMinutes = 'modules:conversationList.time.minutes' as const;
    export const conversationListTimeSeconds = 'modules:conversationList.time.seconds' as const;
    export const conversationListTitle = 'modules:conversationList.title' as const;
    export const dashboardPlatformDistribution = 'modules:dashboard.platformDistribution' as const;
    export const dashboardStatisticsActiveUsers = 'modules:dashboard.statistics.activeUsers' as const;
    export const dashboardStatisticsAvgMessagesPerConv = 'modules:dashboard.statistics.avgMessagesPerConv' as const;
    export const dashboardStatisticsAvgResponseTime = 'modules:dashboard.statistics.avgResponseTime' as const;
    export const dashboardStatisticsCustomers = 'modules:dashboard.statistics.customers' as const;
    export const dashboardStatisticsSatisfactionRate = 'modules:dashboard.statistics.satisfactionRate' as const;
    export const dashboardStatisticsTotalConversations = 'modules:dashboard.statistics.totalConversations' as const;
    export const dashboardStatisticsTotalMessages = 'modules:dashboard.statistics.totalMessages' as const;
    export const dashboardSystemConnectors = 'modules:dashboard.system.connectors' as const;
    export const dashboardSystemPlatformIntegrations = 'modules:dashboard.system.platformIntegrations' as const;
    export const dashboardSystemTitle = 'modules:dashboard.system.title' as const;
    export const dashboardSystemUsers = 'modules:dashboard.system.users' as const;
    export const dashboardTablesColumnsAgent = 'modules:dashboard.tables.columns.agent' as const;
    export const dashboardTablesColumnsCustomer = 'modules:dashboard.tables.columns.customer' as const;
    export const dashboardTablesColumnsDuration = 'modules:dashboard.tables.columns.duration' as const;
    export const dashboardTablesColumnsMessages = 'modules:dashboard.tables.columns.messages' as const;
    export const dashboardTablesColumnsPlatform = 'modules:dashboard.tables.columns.platform' as const;
    export const dashboardTablesColumnsSatisfaction = 'modules:dashboard.tables.columns.satisfaction' as const;
    export const dashboardTablesColumnsStatus = 'modules:dashboard.tables.columns.status' as const;
    export const dashboardTablesColumnsTime = 'modules:dashboard.tables.columns.time' as const;
    export const dashboardTablesEmptyText = 'modules:dashboard.tables.emptyText' as const;
    export const dashboardTablesFilterLowScore = 'modules:dashboard.tables.filterLowScore' as const;
    export const dashboardTablesRecentConversations = 'modules:dashboard.tables.recentConversations' as const;
    export const dashboardTitle = 'modules:dashboard.title' as const;
    export const dashboardTodayConversations = 'modules:dashboard.today.conversations' as const;
    export const dashboardTodayKnowledgeChunks = 'modules:dashboard.today.knowledgeChunks' as const;
    export const dashboardTodayKnowledgeDocs = 'modules:dashboard.today.knowledgeDocs' as const;
    export const dashboardTodayLowSatisfaction = 'modules:dashboard.today.lowSatisfaction' as const;
    export const dashboardTodayMessages = 'modules:dashboard.today.messages' as const;
    export const dashboardTodayTitle = 'modules:dashboard.today.title' as const;
    export const dashboardUnitsPeople = 'modules:dashboard.units.people' as const;
    export const dashboardUnitsPercentage = 'modules:dashboard.units.percentage' as const;
    export const dashboardUnitsSeconds = 'modules:dashboard.units.seconds' as const;
    export const dashboardUnitsTimes = 'modules:dashboard.units.times' as const;
    export const historyAgentTypesAI = 'modules:history.agentTypes.AI' as const;
    export const historyAgentTypesHuman = 'modules:history.agentTypes.Human' as const;
    export const historyAgentTypesAll = 'modules:history.agentTypes.all' as const;
    export const historyButtonsClose = 'modules:history.buttons.close' as const;
    export const historyButtonsExport = 'modules:history.buttons.export' as const;
    export const historyButtonsReset = 'modules:history.buttons.reset' as const;
    export const historyButtonsSearch = 'modules:history.buttons.search' as const;
    export const historyButtonsView = 'modules:history.buttons.view' as const;
    export const historyFiltersAgentType = 'modules:history.filters.agentType' as const;
    export const historyFiltersAllStatus = 'modules:history.filters.allStatus' as const;
    export const historyFiltersDateRangeEndDate = 'modules:history.filters.dateRange.endDate' as const;
    export const historyFiltersDateRangeStartDate = 'modules:history.filters.dateRange.startDate' as const;
    export const historyFiltersStatus = 'modules:history.filters.status' as const;
    export const historyMessagesError = 'modules:history.messages.error' as const;
    export const historyModalsAgent = 'modules:history.modals.agent' as const;
    export const historyModalsAgentDepartment = 'modules:history.modals.agentDepartment' as const;
    export const historyModalsAgentInfo = 'modules:history.modals.agentInfo' as const;
    export const historyModalsAgentName = 'modules:history.modals.agentName' as const;
    export const historyModalsAgentType = 'modules:history.modals.agentType' as const;
    export const historyModalsConversationContent = 'modules:history.modals.conversationContent' as const;
    export const historyModalsConversationSummary = 'modules:history.modals.conversationSummary' as const;
    export const historyModalsCustomer = 'modules:history.modals.customer' as const;
    export const historyModalsCustomerEmail = 'modules:history.modals.customerEmail' as const;
    export const historyModalsCustomerInfo = 'modules:history.modals.customerInfo' as const;
    export const historyModalsCustomerLocation = 'modules:history.modals.customerLocation' as const;
    export const historyModalsCustomerName = 'modules:history.modals.customerName' as const;
    export const historyModalsCustomerPhone = 'modules:history.modals.customerPhone' as const;
    export const historyModalsCustomerSegment = 'modules:history.modals.customerSegment' as const;
    export const historyModalsDetailTitle = 'modules:history.modals.detailTitle' as const;
    export const historyModalsNoContactInfo = 'modules:history.modals.noContactInfo' as const;
    export const historyModalsNoConversationContent = 'modules:history.modals.noConversationContent' as const;
    export const historyModalsNoEvaluation = 'modules:history.modals.noEvaluation' as const;
    export const historyModalsRegularUser = 'modules:history.modals.regularUser' as const;
    export const historyModalsUnknownLocation = 'modules:history.modals.unknownLocation' as const;
    export const historySatisfactionNotEvaluated = 'modules:history.satisfaction.notEvaluated' as const;
    export const historySatisfactionStars = 'modules:history.satisfaction.stars' as const;
    export const historySearchPlaceholder = 'modules:history.search.placeholder' as const;
    export const historySortBySatisfaction = 'modules:history.sort.bySatisfaction' as const;
    export const historySortByTime = 'modules:history.sort.byTime' as const;
    export const historyStatusCancelled = 'modules:history.status.cancelled' as const;
    export const historyStatusCompleted = 'modules:history.status.completed' as const;
    export const historyStatusDefault = 'modules:history.status.default' as const;
    export const historyStatusOngoing = 'modules:history.status.ongoing' as const;
    export const historyTableColumnsActions = 'modules:history.table.columns.actions' as const;
    export const historyTableColumnsAgentType = 'modules:history.table.columns.agentType' as const;
    export const historyTableColumnsCustomer = 'modules:history.table.columns.customer' as const;
    export const historyTableColumnsDuration = 'modules:history.table.columns.duration' as const;
    export const historyTableColumnsSatisfaction = 'modules:history.table.columns.satisfaction' as const;
    export const historyTableColumnsStatus = 'modules:history.table.columns.status' as const;
    export const historyTableColumnsTags = 'modules:history.table.columns.tags' as const;
    export const historyTableColumnsTime = 'modules:history.table.columns.time' as const;
    export const historyTableEmptyText = 'modules:history.table.emptyText' as const;
    export const historyTableLoadingText = 'modules:history.table.loadingText' as const;
    export const historyTitle = 'modules:history.title' as const;
    export const humanListActiveDisabled = 'modules:humanList.active.disabled' as const;
    export const humanListActiveEnabled = 'modules:humanList.active.enabled' as const;
    export const humanListColAction = 'modules:humanList.col.action' as const;
    export const humanListColDisplayName = 'modules:humanList.col.displayName' as const;
    export const humanListColIsActive = 'modules:humanList.col.isActive' as const;
    export const humanListColLoad = 'modules:humanList.col.load' as const;
    export const humanListColStatus = 'modules:humanList.col.status' as const;
    export const humanListColUsername = 'modules:humanList.col.username' as const;
    export const humanListEmpty = 'modules:humanList.empty' as const;
    export const humanListStatusBusy = 'modules:humanList.status.busy' as const;
    export const humanListStatusOffline = 'modules:humanList.status.offline' as const;
    export const humanListStatusOnline = 'modules:humanList.status.online' as const;
    export const humanListToggleConfirmDisable = 'modules:humanList.toggleConfirm.disable' as const;
    export const humanListToggleConfirmEnable = 'modules:humanList.toggleConfirm.enable' as const;
    export const humanListToggleFailed = 'modules:humanList.toggleFailed' as const;
    export const humanListToggleSuccessDisabled = 'modules:humanList.toggleSuccess.disabled' as const;
    export const humanListToggleSuccessEnabled = 'modules:humanList.toggleSuccess.enabled' as const;
    export const humanLoginCompanyId = 'modules:humanLogin.companyId' as const;
    export const humanLoginCompanyIdPlaceholder = 'modules:humanLogin.companyIdPlaceholder' as const;
    export const humanLoginCompanyIdRequired = 'modules:humanLogin.companyIdRequired' as const;
    export const humanLoginLoginFailed = 'modules:humanLogin.loginFailed' as const;
    export const humanLoginPassword = 'modules:humanLogin.password' as const;
    export const humanLoginPasswordPlaceholder = 'modules:humanLogin.passwordPlaceholder' as const;
    export const humanLoginPasswordRequired = 'modules:humanLogin.passwordRequired' as const;
    export const humanLoginSubmit = 'modules:humanLogin.submit' as const;
    export const humanLoginTitle = 'modules:humanLogin.title' as const;
    export const humanLoginUsername = 'modules:humanLogin.username' as const;
    export const humanLoginUsernamePlaceholder = 'modules:humanLogin.usernamePlaceholder' as const;
    export const humanLoginUsernameRequired = 'modules:humanLogin.usernameRequired' as const;
    export const humanWorkspaceCustomerName = 'modules:humanWorkspace.customerName' as const;
    export const humanWorkspaceLogout = 'modules:humanWorkspace.logout' as const;
    export const humanWorkspaceTakingOver = 'modules:humanWorkspace.takingOver' as const;
    export const humanWorkspaceTitle = 'modules:humanWorkspace.title' as const;
    export const humanWorkspaceWaitingTakeover = 'modules:humanWorkspace.waitingTakeover' as const;
    export const humanWorkspaceWsDisconnected = 'modules:humanWorkspace.wsDisconnected' as const;
    export const knowledgeButtonsAddKnowledge = 'modules:knowledge.buttons.addKnowledge' as const;
    export const knowledgeButtonsDeleteDocument = 'modules:knowledge.buttons.deleteDocument' as const;
    export const knowledgeButtonsDocumentList = 'modules:knowledge.buttons.documentList' as const;
    export const knowledgeButtonsExtractionTest = 'modules:knowledge.buttons.extractionTest' as const;
    export const knowledgeButtonsImportFile = 'modules:knowledge.buttons.importFile' as const;
    export const knowledgeButtonsUploading = 'modules:knowledge.buttons.uploading' as const;
    export const knowledgeButtonsViewDetails = 'modules:knowledge.buttons.viewDetails' as const;
    export const knowledgeDateFormatLocale = 'modules:knowledge.dateFormat.locale' as const;
    export const knowledgeExtractionTestChunk = 'modules:knowledge.extractionTest.chunk' as const;
    export const knowledgeExtractionTestCollapse = 'modules:knowledge.extractionTest.collapse' as const;
    export const knowledgeExtractionTestExpand = 'modules:knowledge.extractionTest.expand' as const;
    export const knowledgeExtractionTestKnowledgeDocuments = 'modules:knowledge.extractionTest.knowledgeDocuments' as const;
    export const knowledgeExtractionTestLoading = 'modules:knowledge.extractionTest.loading' as const;
    export const knowledgeExtractionTestMatchedResults = 'modules:knowledge.extractionTest.matchedResults' as const;
    export const knowledgeExtractionTestMetadata = 'modules:knowledge.extractionTest.metadata' as const;
    export const knowledgeExtractionTestNoResults = 'modules:knowledge.extractionTest.noResults' as const;
    export const knowledgeExtractionTestNoResultsDescription = 'modules:knowledge.extractionTest.noResultsDescription' as const;
    export const knowledgeExtractionTestQueryPlaceholder = 'modules:knowledge.extractionTest.queryPlaceholder' as const;
    export const knowledgeExtractionTestQuerySummary = 'modules:knowledge.extractionTest.querySummary' as const;
    export const knowledgeExtractionTestResetQuery = 'modules:knowledge.extractionTest.resetQuery' as const;
    export const knowledgeExtractionTestResults = 'modules:knowledge.extractionTest.results' as const;
    export const knowledgeExtractionTestSearchParamK = 'modules:knowledge.extractionTest.searchParamK' as const;
    export const knowledgeExtractionTestSimilarityScore = 'modules:knowledge.extractionTest.similarityScore' as const;
    export const knowledgeExtractionTestSource = 'modules:knowledge.extractionTest.source' as const;
    export const knowledgeExtractionTestStartTest = 'modules:knowledge.extractionTest.startTest' as const;
    export const knowledgeExtractionTestTestQuery = 'modules:knowledge.extractionTest.testQuery' as const;
    export const knowledgeExtractionTestTestQueryDescription = 'modules:knowledge.extractionTest.testQueryDescription' as const;
    export const knowledgeExtractionTestTitle = 'modules:knowledge.extractionTest.title' as const;
    export const knowledgeExtractionTestUnknown = 'modules:knowledge.extractionTest.unknown' as const;
    export const knowledgeExtractionTestWaitingInput = 'modules:knowledge.extractionTest.waitingInput' as const;
    export const knowledgeExtractionTestWaitingInputDescription = 'modules:knowledge.extractionTest.waitingInputDescription' as const;
    export const knowledgeFileTypesUnknown = 'modules:knowledge.fileTypes.unknown' as const;
    export const knowledgeMessagesDeleteConfirmContent = 'modules:knowledge.messages.deleteConfirmContent' as const;
    export const knowledgeMessagesDeleteConfirmTitle = 'modules:knowledge.messages.deleteConfirmTitle' as const;
    export const knowledgeMessagesDeleteFailed = 'modules:knowledge.messages.deleteFailed' as const;
    export const knowledgeMessagesFileSizeExceeded = 'modules:knowledge.messages.fileSizeExceeded' as const;
    export const knowledgeMessagesUnsupportedFileType = 'modules:knowledge.messages.unsupportedFileType' as const;
    export const knowledgeMessagesUploadFailed = 'modules:knowledge.messages.uploadFailed' as const;
    export const knowledgeMessagesUploadInstructions = 'modules:knowledge.messages.uploadInstructions' as const;
    export const knowledgeMessagesUploadSuccess = 'modules:knowledge.messages.uploadSuccess' as const;
    export const knowledgeSearchPlaceholder = 'modules:knowledge.search.placeholder' as const;
    export const knowledgeStatusActive = 'modules:knowledge.status.active' as const;
    export const knowledgeStatusCompleted = 'modules:knowledge.status.completed' as const;
    export const knowledgeStatusEmbedding = 'modules:knowledge.status.embedding' as const;
    export const knowledgeStatusFailed = 'modules:knowledge.status.failed' as const;
    export const knowledgeStatusParsing = 'modules:knowledge.status.parsing' as const;
    export const knowledgeStatusPending = 'modules:knowledge.status.pending' as const;
    export const knowledgeStatusPersisting = 'modules:knowledge.status.persisting' as const;
    export const knowledgeStatusSemanticprocessing = 'modules:knowledge.status.semantic_processing' as const;
    export const knowledgeStatusUnknown = 'modules:knowledge.status.unknown' as const;
    export const knowledgeTableColumnsActions = 'modules:knowledge.table.columns.actions' as const;
    export const knowledgeTableColumnsChunks = 'modules:knowledge.table.columns.chunks' as const;
    export const knowledgeTableColumnsCreatedAt = 'modules:knowledge.table.columns.createdAt' as const;
    export const knowledgeTableColumnsDescription = 'modules:knowledge.table.columns.description' as const;
    export const knowledgeTableColumnsFileName = 'modules:knowledge.table.columns.fileName' as const;
    export const knowledgeTableColumnsFileSize = 'modules:knowledge.table.columns.fileSize' as const;
    export const knowledgeTableColumnsFileType = 'modules:knowledge.table.columns.fileType' as const;
    export const knowledgeTableColumnsStatus = 'modules:knowledge.table.columns.status' as const;
    export const knowledgeTableEmptyText = 'modules:knowledge.table.emptyText' as const;
    export const knowledgeTableLoadingText = 'modules:knowledge.table.loadingText' as const;
    export const knowledgeTitle = 'modules:knowledge.title' as const;
    export const messageInputCloseBtn = 'modules:messageInput.closeBtn' as const;
    export const messageInputCloseConfirmCancel = 'modules:messageInput.closeConfirmCancel' as const;
    export const messageInputCloseConfirmDesc = 'modules:messageInput.closeConfirmDesc' as const;
    export const messageInputCloseConfirmOk = 'modules:messageInput.closeConfirmOk' as const;
    export const messageInputCloseConfirmTitle = 'modules:messageInput.closeConfirmTitle' as const;
    export const messageInputPlaceholder = 'modules:messageInput.placeholder' as const;
    export const messageInputSendBtn = 'modules:messageInput.sendBtn' as const;
    export const navigationChatbot = 'modules:navigation.chatbot' as const;
    export const navigationDashboard = 'modules:navigation.dashboard' as const;
    export const navigationHistory = 'modules:navigation.history' as const;
    export const navigationKnowledge = 'modules:navigation.knowledge' as const;
    export const navigationPageTitlesAgentConfig = 'modules:navigation.pageTitles.agentConfig' as const;
    export const navigationPageTitlesChatbot = 'modules:navigation.pageTitles.chatbot' as const;
    export const navigationPageTitlesCompanies = 'modules:navigation.pageTitles.companies' as const;
    export const navigationPageTitlesDashboard = 'modules:navigation.pageTitles.dashboard' as const;
    export const navigationPageTitlesDefault = 'modules:navigation.pageTitles.default' as const;
    export const navigationPageTitlesHelp = 'modules:navigation.pageTitles.help' as const;
    export const navigationPageTitlesHistory = 'modules:navigation.pageTitles.history' as const;
    export const navigationPageTitlesKnowledge = 'modules:navigation.pageTitles.knowledge' as const;
    export const navigationPageTitlesNotifications = 'modules:navigation.pageTitles.notifications' as const;
    export const navigationPageTitlesProfile = 'modules:navigation.pageTitles.profile' as const;
    export const navigationPageTitlesSettings = 'modules:navigation.pageTitles.settings' as const;
    export const navigationPageTitlesUsers = 'modules:navigation.pageTitles.users' as const;
    export const navigationSettings = 'modules:navigation.settings' as const;
    export const navigationUsermanagement = 'modules:navigation.user_management' as const;
    export const orderConfigConnectionApiKey = 'modules:order.config.connection.apiKey' as const;
    export const orderConfigConnectionApiKeyRequired = 'modules:order.config.connection.apiKeyRequired' as const;
    export const orderConfigConnectionApiUrl = 'modules:order.config.connection.apiUrl' as const;
    export const orderConfigConnectionApiUrlRequired = 'modules:order.config.connection.apiUrlRequired' as const;
    export const orderConfigConnectionAuthType = 'modules:order.config.connection.authType' as const;
    export const orderConfigConnectionAuthTypeRequired = 'modules:order.config.connection.authTypeRequired' as const;
    export const orderConfigConnectionDatabase = 'modules:order.config.connection.database' as const;
    export const orderConfigConnectionDatabaseRequired = 'modules:order.config.connection.databaseRequired' as const;
    export const orderConfigConnectionHost = 'modules:order.config.connection.host' as const;
    export const orderConfigConnectionHostRequired = 'modules:order.config.connection.hostRequired' as const;
    export const orderConfigConnectionPassword = 'modules:order.config.connection.password' as const;
    export const orderConfigConnectionPasswordRequired = 'modules:order.config.connection.passwordRequired' as const;
    export const orderConfigConnectionPort = 'modules:order.config.connection.port' as const;
    export const orderConfigConnectionPortRequired = 'modules:order.config.connection.portRequired' as const;
    export const orderConfigConnectionTitle = 'modules:order.config.connection.title' as const;
    export const orderConfigConnectionUsername = 'modules:order.config.connection.username' as const;
    export const orderConfigConnectionUsernameRequired = 'modules:order.config.connection.usernameRequired' as const;
    export const orderConfigDataSourceTitle = 'modules:order.config.dataSource.title' as const;
    export const orderConfigDataSourceType = 'modules:order.config.dataSource.type' as const;
    export const orderConfigDataSourceTypeRequired = 'modules:order.config.dataSource.typeRequired' as const;
    export const orderConfigSaveSuccess = 'modules:order.config.save.success' as const;
    export const orderConfigSaveConfig = 'modules:order.config.saveConfig' as const;
    export const orderConfigSubtitle = 'modules:order.config.subtitle' as const;
    export const orderConfigSyncDaily = 'modules:order.config.sync.daily' as const;
    export const orderConfigSyncFrequency = 'modules:order.config.sync.frequency' as const;
    export const orderConfigSyncFrequencyRequired = 'modules:order.config.sync.frequencyRequired' as const;
    export const orderConfigSyncHourly = 'modules:order.config.sync.hourly' as const;
    export const orderConfigSyncManual = 'modules:order.config.sync.manual' as const;
    export const orderConfigSyncRealtime = 'modules:order.config.sync.realtime' as const;
    export const orderConfigSyncRetryCount = 'modules:order.config.sync.retryCount' as const;
    export const orderConfigSyncTitle = 'modules:order.config.sync.title' as const;
    export const orderConfigTestSuccess = 'modules:order.config.test.success' as const;
    export const orderConfigTestUnhealthy = 'modules:order.config.test.unhealthy' as const;
    export const orderConfigTestConnection = 'modules:order.config.testConnection' as const;
    export const orderConfigTitle = 'modules:order.config.title' as const;
    export const orderDetailCreatedAt = 'modules:order.detail.createdAt' as const;
    export const orderDetailEdit = 'modules:order.detail.edit' as const;
    export const orderDetailEditOrder = 'modules:order.detail.editOrder' as const;
    export const orderDetailInfoAvgPrice = 'modules:order.detail.info.avgPrice' as const;
    export const orderDetailInfoBasicTitle = 'modules:order.detail.info.basicTitle' as const;
    export const orderDetailInfoCreatedAt = 'modules:order.detail.info.createdAt' as const;
    export const orderDetailInfoCurrency = 'modules:order.detail.info.currency' as const;
    export const orderDetailInfoCustomerAddress = 'modules:order.detail.info.customerAddress' as const;
    export const orderDetailInfoCustomerEmail = 'modules:order.detail.info.customerEmail' as const;
    export const orderDetailInfoCustomerId = 'modules:order.detail.info.customerId' as const;
    export const orderDetailInfoCustomerName = 'modules:order.detail.info.customerName' as const;
    export const orderDetailInfoCustomerPhone = 'modules:order.detail.info.customerPhone' as const;
    export const orderDetailInfoCustomerTitle = 'modules:order.detail.info.customerTitle' as const;
    export const orderDetailInfoDeliveredAt = 'modules:order.detail.info.deliveredAt' as const;
    export const orderDetailInfoDeliveryTitle = 'modules:order.detail.info.deliveryTitle' as const;
    export const orderDetailInfoEstimatedDelivery = 'modules:order.detail.info.estimatedDelivery' as const;
    export const orderDetailInfoOrderDate = 'modules:order.detail.info.orderDate' as const;
    export const orderDetailInfoOrderId = 'modules:order.detail.info.orderId' as const;
    export const orderDetailInfoOrderValue = 'modules:order.detail.info.orderValue' as const;
    export const orderDetailInfoOtherTitle = 'modules:order.detail.info.otherTitle' as const;
    export const orderDetailInfoPlatform = 'modules:order.detail.info.platform' as const;
    export const orderDetailInfoShippedAt = 'modules:order.detail.info.shippedAt' as const;
    export const orderDetailInfoShippingAddress = 'modules:order.detail.info.shippingAddress' as const;
    export const orderDetailInfoShippingCarrier = 'modules:order.detail.info.shippingCarrier' as const;
    export const orderDetailInfoShippingCost = 'modules:order.detail.info.shippingCost' as const;
    export const orderDetailInfoShippingMethod = 'modules:order.detail.info.shippingMethod' as const;
    export const orderDetailInfoShippingStatus = 'modules:order.detail.info.shippingStatus' as const;
    export const orderDetailInfoStatus = 'modules:order.detail.info.status' as const;
    export const orderDetailInfoTitle = 'modules:order.detail.info.title' as const;
    export const orderDetailInfoTotalAmount = 'modules:order.detail.info.totalAmount' as const;
    export const orderDetailInfoTotalItems = 'modules:order.detail.info.totalItems' as const;
    export const orderDetailInfoTotalQuantity = 'modules:order.detail.info.totalQuantity' as const;
    export const orderDetailInfoTrackingNumber = 'modules:order.detail.info.trackingNumber' as const;
    export const orderDetailInfoUpdatedAt = 'modules:order.detail.info.updatedAt' as const;
    export const orderDetailItemsActions = 'modules:order.detail.items.actions' as const;
    export const orderDetailItemsAvgPrice = 'modules:order.detail.items.avgPrice' as const;
    export const orderDetailItemsCurrency = 'modules:order.detail.items.currency' as const;
    export const orderDetailItemsEdit = 'modules:order.detail.items.edit' as const;
    export const orderDetailItemsProductId = 'modules:order.detail.items.productId' as const;
    export const orderDetailItemsProductName = 'modules:order.detail.items.productName' as const;
    export const orderDetailItemsQuantity = 'modules:order.detail.items.quantity' as const;
    export const orderDetailItemsSubtotal = 'modules:order.detail.items.subtotal' as const;
    export const orderDetailItemsSummary = 'modules:order.detail.items.summary' as const;
    export const orderDetailItemsTotal = 'modules:order.detail.items.total' as const;
    export const orderDetailItemsTotalAmount = 'modules:order.detail.items.totalAmount' as const;
    export const orderDetailItemsTotalItems = 'modules:order.detail.items.totalItems' as const;
    export const orderDetailItemsTotalQuantity = 'modules:order.detail.items.totalQuantity' as const;
    export const orderDetailItemsUnitPrice = 'modules:order.detail.items.unitPrice' as const;
    export const orderDetailItemsTitle = 'modules:order.detail.itemsTitle' as const;
    export const orderDetailLoadError = 'modules:order.detail.loadError' as const;
    export const orderDetailNotFound = 'modules:order.detail.notFound' as const;
    export const orderDetailNotFoundDesc = 'modules:order.detail.notFoundDesc' as const;
    export const orderDetailNotes = 'modules:order.detail.notes' as const;
    export const orderDetailPrint = 'modules:order.detail.print' as const;
    export const orderDetailRefresh = 'modules:order.detail.refresh' as const;
    export const orderDetailRefreshSuccess = 'modules:order.detail.refreshSuccess' as const;
    export const orderDetailShare = 'modules:order.detail.share' as const;
    export const orderDetailShareMessage = 'modules:order.detail.shareMessage' as const;
    export const orderDetailShippingStatusCancelled = 'modules:order.detail.shipping.statusCancelled' as const;
    export const orderDetailShippingStatusDelivered = 'modules:order.detail.shipping.statusDelivered' as const;
    export const orderDetailShippingStatusInTransit = 'modules:order.detail.shipping.statusInTransit' as const;
    export const orderDetailShippingStatusPending = 'modules:order.detail.shipping.statusPending' as const;
    export const orderDetailShippingStatusProcessing = 'modules:order.detail.shipping.statusProcessing' as const;
    export const orderDetailShippingStatusReturned = 'modules:order.detail.shipping.statusReturned' as const;
    export const orderDetailShippingStatusShipped = 'modules:order.detail.shipping.statusShipped' as const;
    export const orderDetailShippingAddress = 'modules:order.detail.shippingAddress' as const;
    export const orderDetailStatusAt = 'modules:order.detail.status.at' as const;
    export const orderDetailStatusBy = 'modules:order.detail.status.by' as const;
    export const orderDetailStatusChanged = 'modules:order.detail.status.changed' as const;
    export const orderDetailStatusCreated = 'modules:order.detail.status.created' as const;
    export const orderDetailStatusCurrent = 'modules:order.detail.status.current' as const;
    export const orderDetailStatusFirstChange = 'modules:order.detail.status.firstChange' as const;
    export const orderDetailStatusLastChange = 'modules:order.detail.status.lastChange' as const;
    export const orderDetailStatusLatest = 'modules:order.detail.status.latest' as const;
    export const orderDetailStatusMoreItems = 'modules:order.detail.status.moreItems' as const;
    export const orderDetailStatusNoHistory = 'modules:order.detail.status.noHistory' as const;
    export const orderDetailStatusNotes = 'modules:order.detail.status.notes' as const;
    export const orderDetailStatusTitle = 'modules:order.detail.status.title' as const;
    export const orderDetailStatusTotalChanges = 'modules:order.detail.status.totalChanges' as const;
    export const orderDetailTitle = 'modules:order.detail.title' as const;
    export const orderNoCompanyError = 'modules:order.noCompanyError' as const;
    export const orderNoCompanyErrorDesc = 'modules:order.noCompanyErrorDesc' as const;
    export const orderPermissionConfigAdminOnly = 'modules:order.permission.configAdminOnly' as const;
    export const orderPermissionDenied = 'modules:order.permission.denied' as const;
    export const orderQueryCustomerDisplayPrefix = 'modules:order.query.customer.displayPrefix' as const;
    export const orderQueryCustomerUnknown = 'modules:order.query.customer.unknown' as const;
    export const orderQueryExport = 'modules:order.query.export' as const;
    export const orderQueryExportNoSelection = 'modules:order.query.exportNoSelection' as const;
    export const orderQueryExportSelected = 'modules:order.query.exportSelected' as const;
    export const orderQueryFeaturesAddNotes = 'modules:order.query.features.addNotes' as const;
    export const orderQueryFeaturesExport = 'modules:order.query.features.export' as const;
    export const orderQueryFeaturesFilter = 'modules:order.query.features.filter' as const;
    export const orderQueryFeaturesSearch = 'modules:order.query.features.search' as const;
    export const orderQueryFeaturesStatus = 'modules:order.query.features.status' as const;
    export const orderQueryFeaturesTitle = 'modules:order.query.features.title' as const;
    export const orderQueryFeaturesUpdateStatus = 'modules:order.query.features.updateStatus' as const;
    export const orderQueryFiltersActiveCount = 'modules:order.query.filters.activeCount' as const;
    export const orderQueryFiltersActiveFilters = 'modules:order.query.filters.activeFilters' as const;
    export const orderQueryFiltersCancelled = 'modules:order.query.filters.cancelled' as const;
    export const orderQueryFiltersCancelledDesc = 'modules:order.query.filters.cancelledDesc' as const;
    export const orderQueryFiltersClearAll = 'modules:order.query.filters.clearAll' as const;
    export const orderQueryFiltersCompanyId = 'modules:order.query.filters.companyId' as const;
    export const orderQueryFiltersCustomerEmail = 'modules:order.query.filters.customerEmail' as const;
    export const orderQueryFiltersCustomerId = 'modules:order.query.filters.customerId' as const;
    export const orderQueryFiltersCustomerName = 'modules:order.query.filters.customerName' as const;
    export const orderQueryFiltersCustomerPhone = 'modules:order.query.filters.customerPhone' as const;
    export const orderQueryFiltersDelivered = 'modules:order.query.filters.delivered' as const;
    export const orderQueryFiltersDeliveredDesc = 'modules:order.query.filters.deliveredDesc' as const;
    export const orderQueryFiltersEndDate = 'modules:order.query.filters.endDate' as const;
    export const orderQueryFiltersFilters = 'modules:order.query.filters.filters' as const;
    export const orderQueryFiltersHighValue = 'modules:order.query.filters.highValue' as const;
    export const orderQueryFiltersHighValueDesc = 'modules:order.query.filters.highValueDesc' as const;
    export const orderQueryFiltersLimit = 'modules:order.query.filters.limit' as const;
    export const orderQueryFiltersManagePresets = 'modules:order.query.filters.managePresets' as const;
    export const orderQueryFiltersMaxAmount = 'modules:order.query.filters.maxAmount' as const;
    export const orderQueryFiltersMinAmount = 'modules:order.query.filters.minAmount' as const;
    export const orderQueryFiltersNeedAttention = 'modules:order.query.filters.needAttention' as const;
    export const orderQueryFiltersNeedAttentionDesc = 'modules:order.query.filters.needAttentionDesc' as const;
    export const orderQueryFiltersOffset = 'modules:order.query.filters.offset' as const;
    export const orderQueryFiltersOrderId = 'modules:order.query.filters.orderId' as const;
    export const orderQueryFiltersPending = 'modules:order.query.filters.pending' as const;
    export const orderQueryFiltersPendingDesc = 'modules:order.query.filters.pendingDesc' as const;
    export const orderQueryFiltersPlatform = 'modules:order.query.filters.platform' as const;
    export const orderQueryFiltersPresetGroup = 'modules:order.query.filters.presetGroup' as const;
    export const orderQueryFiltersPresets = 'modules:order.query.filters.presets' as const;
    export const orderQueryFiltersProcessing = 'modules:order.query.filters.processing' as const;
    export const orderQueryFiltersProcessingDesc = 'modules:order.query.filters.processingDesc' as const;
    export const orderQueryFiltersQuickFilters = 'modules:order.query.filters.quickFilters' as const;
    export const orderQueryFiltersRecent = 'modules:order.query.filters.recent' as const;
    export const orderQueryFiltersRecentDesc = 'modules:order.query.filters.recentDesc' as const;
    export const orderQueryFiltersSavePreset = 'modules:order.query.filters.savePreset' as const;
    export const orderQueryFiltersSortBy = 'modules:order.query.filters.sortBy' as const;
    export const orderQueryFiltersSortOrder = 'modules:order.query.filters.sortOrder' as const;
    export const orderQueryFiltersStartDate = 'modules:order.query.filters.startDate' as const;
    export const orderQueryFiltersStatus = 'modules:order.query.filters.status' as const;
    export const orderQueryFiltersStatusCancelled = 'modules:order.query.filters.statusCancelled' as const;
    export const orderQueryFiltersStatusCompleted = 'modules:order.query.filters.statusCompleted' as const;
    export const orderQueryFiltersStatusDelivered = 'modules:order.query.filters.statusDelivered' as const;
    export const orderQueryFiltersStatusOnHold = 'modules:order.query.filters.statusOnHold' as const;
    export const orderQueryFiltersStatusPending = 'modules:order.query.filters.statusPending' as const;
    export const orderQueryFiltersStatusProcessing = 'modules:order.query.filters.statusProcessing' as const;
    export const orderQueryFiltersStatusRefunded = 'modules:order.query.filters.statusRefunded' as const;
    export const orderQueryFiltersStatusShipped = 'modules:order.query.filters.statusShipped' as const;
    export const orderQueryFiltersToday = 'modules:order.query.filters.today' as const;
    export const orderQueryFiltersTodayDesc = 'modules:order.query.filters.todayDesc' as const;
    export const orderQueryListActionsDelete = 'modules:order.query.list.actions.delete' as const;
    export const orderQueryListActionsDeleteConfirm = 'modules:order.query.list.actions.deleteConfirm' as const;
    export const orderQueryListActionsEdit = 'modules:order.query.list.actions.edit' as const;
    export const orderQueryListActionsMarkCancelled = 'modules:order.query.list.actions.markCancelled' as const;
    export const orderQueryListActionsMarkDelivered = 'modules:order.query.list.actions.markDelivered' as const;
    export const orderQueryListActionsMarkProcessing = 'modules:order.query.list.actions.markProcessing' as const;
    export const orderQueryListActionsMarkShipped = 'modules:order.query.list.actions.markShipped' as const;
    export const orderQueryListActionsMore = 'modules:order.query.list.actions.more' as const;
    export const orderQueryListActionsUpdateStatus = 'modules:order.query.list.actions.updateStatus' as const;
    export const orderQueryListActionsView = 'modules:order.query.list.actions.view' as const;
    export const orderQueryListColumnsActions = 'modules:order.query.list.columns.actions' as const;
    export const orderQueryListColumnsCustomer = 'modules:order.query.list.columns.customer' as const;
    export const orderQueryListColumnsEstimatedDelivery = 'modules:order.query.list.columns.estimatedDelivery' as const;
    export const orderQueryListColumnsItems = 'modules:order.query.list.columns.items' as const;
    export const orderQueryListColumnsOrderDate = 'modules:order.query.list.columns.orderDate' as const;
    export const orderQueryListColumnsOrderId = 'modules:order.query.list.columns.orderId' as const;
    export const orderQueryListColumnsPlatform = 'modules:order.query.list.columns.platform' as const;
    export const orderQueryListColumnsStatus = 'modules:order.query.list.columns.status' as const;
    export const orderQueryListColumnsTotalAmount = 'modules:order.query.list.columns.totalAmount' as const;
    export const orderQueryListDeleteError = 'modules:order.query.list.deleteError' as const;
    export const orderQueryListDeleteMessage = 'modules:order.query.list.deleteMessage' as const;
    export const orderQueryListDeleteSuccess = 'modules:order.query.list.deleteSuccess' as const;
    export const orderQueryListOrders = 'modules:order.query.list.orders' as const;
    export const orderQueryListPlaceholder = 'modules:order.query.list.placeholder' as const;
    export const orderQueryListSelected = 'modules:order.query.list.selected' as const;
    export const orderQueryListStatusUpdateError = 'modules:order.query.list.statusUpdateError' as const;
    export const orderQueryListStatusUpdateMessage = 'modules:order.query.list.statusUpdateMessage' as const;
    export const orderQueryListStatusUpdateSuccess = 'modules:order.query.list.statusUpdateSuccess' as const;
    export const orderQueryListTotal = 'modules:order.query.list.total' as const;
    export const orderQueryLoadError = 'modules:order.query.loadError' as const;
    export const orderQueryPaginationCurrent = 'modules:order.query.pagination.current' as const;
    export const orderQueryPaginationItems = 'modules:order.query.pagination.items' as const;
    export const orderQueryPaginationJumpTo = 'modules:order.query.pagination.jumpTo' as const;
    export const orderQueryPaginationPage = 'modules:order.query.pagination.page' as const;
    export const orderQueryPaginationPageSize = 'modules:order.query.pagination.pageSize' as const;
    export const orderQueryPaginationShowTotal = 'modules:order.query.pagination.showTotal' as const;
    export const orderQueryPaginationTotal = 'modules:order.query.pagination.total' as const;
    export const orderQueryPlatformsEmail = 'modules:order.query.platforms.email' as const;
    export const orderQueryPlatformsMobile = 'modules:order.query.platforms.mobile' as const;
    export const orderQueryPlatformsPhone = 'modules:order.query.platforms.phone' as const;
    export const orderQueryPlatformsStore = 'modules:order.query.platforms.store' as const;
    export const orderQueryPlatformsWeb = 'modules:order.query.platforms.web' as const;
    export const orderQueryPlatformsWechat = 'modules:order.query.platforms.wechat' as const;
    export const orderQueryPlatformsWhatsapp = 'modules:order.query.platforms.whatsapp' as const;
    export const orderQueryPresetsAllOrdersDescription = 'modules:order.query.presets.allOrders.description' as const;
    export const orderQueryPresetsAllOrdersName = 'modules:order.query.presets.allOrders.name' as const;
    export const orderQueryPresetsPendingOrdersDescription = 'modules:order.query.presets.pendingOrders.description' as const;
    export const orderQueryPresetsPendingOrdersName = 'modules:order.query.presets.pendingOrders.name' as const;
    export const orderQueryPresetsTodayOrdersDescription = 'modules:order.query.presets.todayOrders.description' as const;
    export const orderQueryPresetsTodayOrdersName = 'modules:order.query.presets.todayOrders.name' as const;
    export const orderQueryReadOnly = 'modules:order.query.readOnly' as const;
    export const orderQueryRefresh = 'modules:order.query.refresh' as const;
    export const orderQuerySearchButton = 'modules:order.query.search.button' as const;
    export const orderQuerySearchCustomerEmail = 'modules:order.query.search.customerEmail' as const;
    export const orderQuerySearchCustomerEmailPlaceholder = 'modules:order.query.search.customerEmailPlaceholder' as const;
    export const orderQuerySearchCustomerId = 'modules:order.query.search.customerId' as const;
    export const orderQuerySearchCustomerIdPlaceholder = 'modules:order.query.search.customerIdPlaceholder' as const;
    export const orderQuerySearchCustomerName = 'modules:order.query.search.customerName' as const;
    export const orderQuerySearchCustomerNamePlaceholder = 'modules:order.query.search.customerNamePlaceholder' as const;
    export const orderQuerySearchCustomerPhone = 'modules:order.query.search.customerPhone' as const;
    export const orderQuerySearchCustomerPhonePlaceholder = 'modules:order.query.search.customerPhonePlaceholder' as const;
    export const orderQuerySearchDateRange = 'modules:order.query.search.dateRange' as const;
    export const orderQuerySearchMaxAmount = 'modules:order.query.search.maxAmount' as const;
    export const orderQuerySearchMaxAmountPlaceholder = 'modules:order.query.search.maxAmountPlaceholder' as const;
    export const orderQuerySearchMinAmount = 'modules:order.query.search.minAmount' as const;
    export const orderQuerySearchMinAmountPlaceholder = 'modules:order.query.search.minAmountPlaceholder' as const;
    export const orderQuerySearchOrderId = 'modules:order.query.search.orderId' as const;
    export const orderQuerySearchOrderIdPlaceholder = 'modules:order.query.search.orderIdPlaceholder' as const;
    export const orderQuerySearchPlaceholder = 'modules:order.query.search.placeholder' as const;
    export const orderQuerySearchPlatform = 'modules:order.query.search.platform' as const;
    export const orderQuerySearchPlatformPlaceholder = 'modules:order.query.search.platformPlaceholder' as const;
    export const orderQuerySearchReset = 'modules:order.query.search.reset' as const;
    export const orderQuerySearchSortBy = 'modules:order.query.search.sortBy' as const;
    export const orderQuerySearchSortByAmount = 'modules:order.query.search.sortByAmount' as const;
    export const orderQuerySearchSortByOrderDate = 'modules:order.query.search.sortByOrderDate' as const;
    export const orderQuerySearchSortByOrderNumber = 'modules:order.query.search.sortByOrderNumber' as const;
    export const orderQuerySearchSortByStatus = 'modules:order.query.search.sortByStatus' as const;
    export const orderQuerySearchSortOrder = 'modules:order.query.search.sortOrder' as const;
    export const orderQuerySearchSortOrderAsc = 'modules:order.query.search.sortOrderAsc' as const;
    export const orderQuerySearchSortOrderDesc = 'modules:order.query.search.sortOrderDesc' as const;
    export const orderQuerySearchStatus = 'modules:order.query.search.status' as const;
    export const orderQuerySearchStatusPlaceholder = 'modules:order.query.search.statusPlaceholder' as const;
    export const orderQuerySearchSuccess = 'modules:order.query.search.success' as const;
    export const orderQuerySearchTitle = 'modules:order.query.search.title' as const;
    export const orderQuerySearchToggleAdvanced = 'modules:order.query.search.toggleAdvanced' as const;
    export const orderQueryStatsActiveFilters = 'modules:order.query.stats.activeFilters' as const;
    export const orderQueryStatsCurrentPage = 'modules:order.query.stats.currentPage' as const;
    export const orderQueryStatsTitle = 'modules:order.query.stats.title' as const;
    export const orderQueryStatsTotal = 'modules:order.query.stats.total' as const;
    export const orderQuerySubtitle = 'modules:order.query.subtitle' as const;
    export const orderQueryTitle = 'modules:order.query.title' as const;
    export const orderQueryUnitsItem = 'modules:order.query.units.item' as const;
    export const orderQueryUnitsItems = 'modules:order.query.units.items' as const;
    export const orderTabsConfig = 'modules:order.tabs.config' as const;
    export const orderTabsQuery = 'modules:order.tabs.query' as const;
    export const sceneInfoConversationId = 'modules:sceneInfo.conversationId' as const;
    export const sceneInfoEmotion = 'modules:sceneInfo.emotion' as const;
    export const sceneInfoEmotionAngry = 'modules:sceneInfo.emotionAngry' as const;
    export const sceneInfoEmotionCalm = 'modules:sceneInfo.emotionCalm' as const;
    export const sceneInfoEmotionDispleased = 'modules:sceneInfo.emotionDispleased' as const;
    export const sceneInfoEmotionNeedHelp = 'modules:sceneInfo.emotionNeedHelp' as const;
    export const sceneInfoReason = 'modules:sceneInfo.reason' as const;
    export const settingsAlertsSystemSettings = 'modules:settings.alerts.systemSettings' as const;
    export const settingsAlertsSystemSettingsDescription = 'modules:settings.alerts.systemSettingsDescription' as const;
    export const settingsButtonsReset = 'modules:settings.buttons.reset' as const;
    export const settingsButtonsSaveSettings = 'modules:settings.buttons.saveSettings' as const;
    export const settingsChannelsAliyunComingSoon = 'modules:settings.channels.aliyun.comingSoon' as const;
    export const settingsChannelsAliyunDesc = 'modules:settings.channels.aliyun.desc' as const;
    export const settingsChannelsAliyunName = 'modules:settings.channels.aliyun.name' as const;
    export const settingsChannelsConfigure = 'modules:settings.channels.configure' as const;
    export const settingsChannelsConfigured = 'modules:settings.channels.configured' as const;
    export const settingsChannelsInactive = 'modules:settings.channels.inactive' as const;
    export const settingsChannelsMetaAccessToken = 'modules:settings.channels.meta.accessToken' as const;
    export const settingsChannelsMetaAccessTokenPlaceholder = 'modules:settings.channels.meta.accessTokenPlaceholder' as const;
    export const settingsChannelsMetaDesc = 'modules:settings.channels.meta.desc' as const;
    export const settingsChannelsMetaName = 'modules:settings.channels.meta.name' as const;
    export const settingsChannelsMetaPhoneNumberId = 'modules:settings.channels.meta.phoneNumberId' as const;
    export const settingsChannelsNoRecord = 'modules:settings.channels.noRecord' as const;
    export const settingsChannelsNotConfigured = 'modules:settings.channels.notConfigured' as const;
    export const settingsChannelsTitle = 'modules:settings.channels.title' as const;
    export const settingsChannelsTwilioDesc = 'modules:settings.channels.twilio.desc' as const;
    export const settingsChannelsTwilioName = 'modules:settings.channels.twilio.name' as const;
    export const settingsChannelsWhatsappAccountSid = 'modules:settings.channels.whatsapp.accountSid' as const;
    export const settingsChannelsWhatsappActive = 'modules:settings.channels.whatsapp.active' as const;
    export const settingsChannelsWhatsappAddChannel = 'modules:settings.channels.whatsapp.addChannel' as const;
    export const settingsChannelsWhatsappAuthToken = 'modules:settings.channels.whatsapp.authToken' as const;
    export const settingsChannelsWhatsappAuthTokenPlaceholder = 'modules:settings.channels.whatsapp.authTokenPlaceholder' as const;
    export const settingsChannelsWhatsappConnected = 'modules:settings.channels.whatsapp.connected' as const;
    export const settingsChannelsWhatsappDeleteConfirm = 'modules:settings.channels.whatsapp.deleteConfirm' as const;
    export const settingsChannelsWhatsappDeleteError = 'modules:settings.channels.whatsapp.deleteError' as const;
    export const settingsChannelsWhatsappDeleteSuccess = 'modules:settings.channels.whatsapp.deleteSuccess' as const;
    export const settingsChannelsWhatsappEditChannel = 'modules:settings.channels.whatsapp.editChannel' as const;
    export const settingsChannelsWhatsappEmpty = 'modules:settings.channels.whatsapp.empty' as const;
    export const settingsChannelsWhatsappFetchError = 'modules:settings.channels.whatsapp.fetchError' as const;
    export const settingsChannelsWhatsappInactive = 'modules:settings.channels.whatsapp.inactive' as const;
    export const settingsChannelsWhatsappNotConfigured = 'modules:settings.channels.whatsapp.notConfigured' as const;
    export const settingsChannelsWhatsappProviderType = 'modules:settings.channels.whatsapp.providerType' as const;
    export const settingsChannelsWhatsappRequiredFields = 'modules:settings.channels.whatsapp.requiredFields' as const;
    export const settingsChannelsWhatsappSaveError = 'modules:settings.channels.whatsapp.saveError' as const;
    export const settingsChannelsWhatsappSaveSuccess = 'modules:settings.channels.whatsapp.saveSuccess' as const;
    export const settingsChannelsWhatsappTestConnection = 'modules:settings.channels.whatsapp.testConnection' as const;
    export const settingsChannelsWhatsappTestError = 'modules:settings.channels.whatsapp.testError' as const;
    export const settingsChannelsWhatsappTitle = 'modules:settings.channels.whatsapp.title' as const;
    export const settingsChannelsWhatsappWhatsappNumber = 'modules:settings.channels.whatsapp.whatsappNumber' as const;
    export const settingsDescriptionsTenantLanguage = 'modules:settings.descriptions.tenantLanguage' as const;
    export const settingsHelpContextWindow = 'modules:settings.help.contextWindow' as const;
    export const settingsHelpEmbeddingApiKey = 'modules:settings.help.embeddingApiKey' as const;
    export const settingsHelpEmbeddingEndpointUrl = 'modules:settings.help.embeddingEndpointUrl' as const;
    export const settingsHelpEmbeddingModelGeneral = 'modules:settings.help.embeddingModel.general' as const;
    export const settingsHelpEmbeddingModelHasDocuments = 'modules:settings.help.embeddingModel.hasDocuments' as const;
    export const settingsHelpEmojiPolicy = 'modules:settings.help.emojiPolicy' as const;
    export const settingsHelpEnthusiasmLevel = 'modules:settings.help.enthusiasmLevel' as const;
    export const settingsHelpFormalityLevel = 'modules:settings.help.formalityLevel' as const;
    export const settingsHelpMaxResponseChars = 'modules:settings.help.maxResponseChars' as const;
    export const settingsHelpPersona = 'modules:settings.help.persona' as const;
    export const settingsHelpPolitenessLevel = 'modules:settings.help.politenessLevel' as const;
    export const settingsHelpResponsePreferences = 'modules:settings.help.responsePreferences' as const;
    export const settingsHelpTenantLanguage = 'modules:settings.help.tenantLanguage' as const;
    export const settingsHelpUseEmphasis = 'modules:settings.help.useEmphasis' as const;
    export const settingsHelpUseLineBreaks = 'modules:settings.help.useLineBreaks' as const;
    export const settingsLabelsAiModel = 'modules:settings.labels.aiModel' as const;
    export const settingsLabelsAllowedOrigins = 'modules:settings.labels.allowedOrigins' as const;
    export const settingsLabelsApiKey = 'modules:settings.labels.apiKey' as const;
    export const settingsLabelsApiRateLimit = 'modules:settings.labels.apiRateLimit' as const;
    export const settingsLabelsContextWindow = 'modules:settings.labels.contextWindow' as const;
    export const settingsLabelsEmailRecipients = 'modules:settings.labels.emailRecipients' as const;
    export const settingsLabelsEmbeddingApiKey = 'modules:settings.labels.embeddingApiKey' as const;
    export const settingsLabelsEmbeddingEndpointUrl = 'modules:settings.labels.embeddingEndpointUrl' as const;
    export const settingsLabelsEmbeddingModel = 'modules:settings.labels.embeddingModel' as const;
    export const settingsLabelsEmojiPolicy = 'modules:settings.labels.emojiPolicy' as const;
    export const settingsLabelsEnableContextWindow = 'modules:settings.labels.enableContextWindow' as const;
    export const settingsLabelsEnableEmailNotifications = 'modules:settings.labels.enableEmailNotifications' as const;
    export const settingsLabelsEnableErrorAlerts = 'modules:settings.labels.enableErrorAlerts' as const;
    export const settingsLabelsEnableExternalApi = 'modules:settings.labels.enableExternalApi' as const;
    export const settingsLabelsEnableSlackNotifications = 'modules:settings.labels.enableSlackNotifications' as const;
    export const settingsLabelsEnableStreaming = 'modules:settings.labels.enableStreaming' as const;
    export const settingsLabelsEnableWebhook = 'modules:settings.labels.enableWebhook' as const;
    export const settingsLabelsEnthusiasmLevel = 'modules:settings.labels.enthusiasmLevel' as const;
    export const settingsLabelsFormalityLevel = 'modules:settings.labels.formalityLevel' as const;
    export const settingsLabelsLineBreaks = 'modules:settings.labels.lineBreaks' as const;
    export const settingsLabelsMaxResponseChars = 'modules:settings.labels.maxResponseChars' as const;
    export const settingsLabelsMaxTokens = 'modules:settings.labels.maxTokens' as const;
    export const settingsLabelsPersona = 'modules:settings.labels.persona' as const;
    export const settingsLabelsPolitenessLevel = 'modules:settings.labels.politenessLevel' as const;
    export const settingsLabelsSlackWebhook = 'modules:settings.labels.slackWebhook' as const;
    export const settingsLabelsSystemLanguage = 'modules:settings.labels.systemLanguage' as const;
    export const settingsLabelsTemperature = 'modules:settings.labels.temperature' as const;
    export const settingsLabelsTenantUILanguage = 'modules:settings.labels.tenantUILanguage' as const;
    export const settingsLabelsTimezone = 'modules:settings.labels.timezone' as const;
    export const settingsLabelsUseEmphasis = 'modules:settings.labels.useEmphasis' as const;
    export const settingsLabelsWebhookUrl = 'modules:settings.labels.webhookUrl' as const;
    export const settingsMessagesApiKeyAdminDescription = 'modules:settings.messages.apiKeyAdminDescription' as const;
    export const settingsMessagesApiKeyNotSet = 'modules:settings.messages.apiKeyNotSet' as const;
    export const settingsMessagesApiKeyPlaceholder = 'modules:settings.messages.apiKeyPlaceholder' as const;
    export const settingsMessagesApiKeySet = 'modules:settings.messages.apiKeySet' as const;
    export const settingsMessagesApiKeyUserDescription = 'modules:settings.messages.apiKeyUserDescription' as const;
    export const settingsMessagesContactAdminToSet = 'modules:settings.messages.contactAdminToSet' as const;
    export const settingsMessagesEmbeddingApiKeyRequired = 'modules:settings.messages.embeddingApiKeyRequired' as const;
    export const settingsMessagesEmbeddingEndpointUrlInvalid = 'modules:settings.messages.embeddingEndpointUrlInvalid' as const;
    export const settingsMessagesEmbeddingEndpointUrlRequired = 'modules:settings.messages.embeddingEndpointUrlRequired' as const;
    export const settingsMessagesEnterFieldToEnable = 'modules:settings.messages.enterFieldToEnable' as const;
    export const settingsMessagesPasswordAdminDescription = 'modules:settings.messages.passwordAdminDescription' as const;
    export const settingsMessagesPasswordNotSet = 'modules:settings.messages.passwordNotSet' as const;
    export const settingsMessagesPasswordPlaceholder = 'modules:settings.messages.passwordPlaceholder' as const;
    export const settingsMessagesPasswordSet = 'modules:settings.messages.passwordSet' as const;
    export const settingsMessagesPasswordUserDescription = 'modules:settings.messages.passwordUserDescription' as const;
    export const settingsMessagesResetToDefaults = 'modules:settings.messages.resetToDefaults' as const;
    export const settingsMessagesSaveFailed = 'modules:settings.messages.saveFailed' as const;
    export const settingsMessagesSaveSuccess = 'modules:settings.messages.saveSuccess' as const;
    export const settingsMessagesTenantLanguageUpdateFailed = 'modules:settings.messages.tenantLanguageUpdateFailed' as const;
    export const settingsMessagesTenantLanguageUpdated = 'modules:settings.messages.tenantLanguageUpdated' as const;
    export const settingsMessagesUrlAdminDescription = 'modules:settings.messages.urlAdminDescription' as const;
    export const settingsMessagesUrlNotSet = 'modules:settings.messages.urlNotSet' as const;
    export const settingsMessagesUrlPlaceholder = 'modules:settings.messages.urlPlaceholder' as const;
    export const settingsMessagesUrlSet = 'modules:settings.messages.urlSet' as const;
    export const settingsMessagesUrlUserDescription = 'modules:settings.messages.urlUserDescription' as const;
    export const settingsMessagesWebhookAdminDescription = 'modules:settings.messages.webhookAdminDescription' as const;
    export const settingsMessagesWebhookNotSet = 'modules:settings.messages.webhookNotSet' as const;
    export const settingsMessagesWebhookPlaceholder = 'modules:settings.messages.webhookPlaceholder' as const;
    export const settingsMessagesWebhookSet = 'modules:settings.messages.webhookSet' as const;
    export const settingsMessagesWebhookUserDescription = 'modules:settings.messages.webhookUserDescription' as const;
    export const settingsOptionsEmbeddingModelsDashscope = 'modules:settings.options.embeddingModels.dashscope' as const;
    export const settingsOptionsEmbeddingModelsLocal = 'modules:settings.options.embeddingModels.local' as const;
    export const settingsOptionsModelsClaude3 = 'modules:settings.options.models.claude3' as const;
    export const settingsOptionsModelsDeepseekChat = 'modules:settings.options.models.deepseekChat' as const;
    export const settingsOptionsModelsDeepseekReasoner = 'modules:settings.options.models.deepseekReasoner' as const;
    export const settingsOptionsModelsGpt35Turbo = 'modules:settings.options.models.gpt35Turbo' as const;
    export const settingsOptionsModelsGpt4 = 'modules:settings.options.models.gpt4' as const;
    export const settingsOptionsModelsLocalModel = 'modules:settings.options.models.localModel' as const;
    export const settingsOptionsStyleEmojiPolicyFriendly = 'modules:settings.options.style.emojiPolicyFriendly' as const;
    export const settingsOptionsStyleEmojiPolicyMinimal = 'modules:settings.options.style.emojiPolicyMinimal' as const;
    export const settingsOptionsStyleEmojiPolicyModerate = 'modules:settings.options.style.emojiPolicyModerate' as const;
    export const settingsOptionsStyleEmojiPolicyNone = 'modules:settings.options.style.emojiPolicyNone' as const;
    export const settingsOptionsStyleEnthusiasmLevel1 = 'modules:settings.options.style.enthusiasmLevel1' as const;
    export const settingsOptionsStyleEnthusiasmLevel2 = 'modules:settings.options.style.enthusiasmLevel2' as const;
    export const settingsOptionsStyleEnthusiasmLevel3 = 'modules:settings.options.style.enthusiasmLevel3' as const;
    export const settingsOptionsStyleEnthusiasmLevel4 = 'modules:settings.options.style.enthusiasmLevel4' as const;
    export const settingsOptionsStyleEnthusiasmLevel5 = 'modules:settings.options.style.enthusiasmLevel5' as const;
    export const settingsOptionsStyleFormalityLevel1 = 'modules:settings.options.style.formalityLevel1' as const;
    export const settingsOptionsStyleFormalityLevel2 = 'modules:settings.options.style.formalityLevel2' as const;
    export const settingsOptionsStyleFormalityLevel3 = 'modules:settings.options.style.formalityLevel3' as const;
    export const settingsOptionsStyleFormalityLevel4 = 'modules:settings.options.style.formalityLevel4' as const;
    export const settingsOptionsStyleFormalityLevel5 = 'modules:settings.options.style.formalityLevel5' as const;
    export const settingsOptionsStylePolitenessLevel1 = 'modules:settings.options.style.politenessLevel1' as const;
    export const settingsOptionsStylePolitenessLevel2 = 'modules:settings.options.style.politenessLevel2' as const;
    export const settingsOptionsStylePolitenessLevel3 = 'modules:settings.options.style.politenessLevel3' as const;
    export const settingsOptionsStylePolitenessLevel4 = 'modules:settings.options.style.politenessLevel4' as const;
    export const settingsOptionsStylePolitenessLevel5 = 'modules:settings.options.style.politenessLevel5' as const;
    export const settingsOptionsTemperatureMarksBalanced = 'modules:settings.options.temperatureMarks.balanced' as const;
    export const settingsOptionsTemperatureMarksCreative = 'modules:settings.options.temperatureMarks.creative' as const;
    export const settingsOptionsTemperatureMarksPrecise = 'modules:settings.options.temperatureMarks.precise' as const;
    export const settingsOptionsTimezonesAmericaNewYork = 'modules:settings.options.timezones.americaNewYork' as const;
    export const settingsOptionsTimezonesAsiaShanghai = 'modules:settings.options.timezones.asiaShanghai' as const;
    export const settingsOptionsTimezonesEuropeLondon = 'modules:settings.options.timezones.europeLondon' as const;
    export const settingsPlaceholdersEnterAllowedOrigins = 'modules:settings.placeholders.enterAllowedOrigins' as const;
    export const settingsPlaceholdersEnterApiKey = 'modules:settings.placeholders.enterApiKey' as const;
    export const settingsPlaceholdersEnterEmail = 'modules:settings.placeholders.enterEmail' as const;
    export const settingsPlaceholdersEnterEmbeddingApiKey = 'modules:settings.placeholders.enterEmbeddingApiKey' as const;
    export const settingsPlaceholdersEnterEmbeddingEndpointUrl = 'modules:settings.placeholders.enterEmbeddingEndpointUrl' as const;
    export const settingsPlaceholdersEnterSlackWebhook = 'modules:settings.placeholders.enterSlackWebhook' as const;
    export const settingsPlaceholdersEnterWebhookUrl = 'modules:settings.placeholders.enterWebhookUrl' as const;
    export const settingsPlaceholdersPersona = 'modules:settings.placeholders.persona' as const;
    export const settingsSectionsAdvancedConfiguration = 'modules:settings.sections.advancedConfiguration' as const;
    export const settingsSectionsAlertConfiguration = 'modules:settings.sections.alertConfiguration' as const;
    export const settingsSectionsApiConfiguration = 'modules:settings.sections.apiConfiguration' as const;
    export const settingsSectionsBasicConfiguration = 'modules:settings.sections.basicConfiguration' as const;
    export const settingsSectionsBrandPersona = 'modules:settings.sections.brandPersona' as const;
    export const settingsSectionsEmailNotifications = 'modules:settings.sections.emailNotifications' as const;
    export const settingsSectionsEmbeddingConfiguration = 'modules:settings.sections.embeddingConfiguration' as const;
    export const settingsSectionsModelConfiguration = 'modules:settings.sections.modelConfiguration' as const;
    export const settingsSectionsResponsePreferences = 'modules:settings.sections.responsePreferences' as const;
    export const settingsSectionsSlackNotifications = 'modules:settings.sections.slackNotifications' as const;
    export const settingsSectionsTenantLanguage = 'modules:settings.sections.tenantLanguage' as const;
    export const settingsSectionsToneLevels = 'modules:settings.sections.toneLevels' as const;
    export const settingsSectionsWebhookConfiguration = 'modules:settings.sections.webhookConfiguration' as const;
    export const settingsTabsAi = 'modules:settings.tabs.ai' as const;
    export const settingsTabsGeneral = 'modules:settings.tabs.general' as const;
    export const settingsTabsIntegrations = 'modules:settings.tabs.integrations' as const;
    export const settingsTabsNotifications = 'modules:settings.tabs.notifications' as const;
    export const settingsTabsStyle = 'modules:settings.tabs.style' as const;
    export const settingsTabsTenantExport = 'modules:settings.tabs.tenantExport' as const;
    export const settingsTenantExportConfirm = 'modules:settings.tenantExport.confirm' as const;
    export const settingsTenantExportExportButton = 'modules:settings.tenantExport.exportButton' as const;
    export const settingsTenantExportExportFailed = 'modules:settings.tenantExport.exportFailed' as const;
    export const settingsTenantExportExportSuccess = 'modules:settings.tenantExport.exportSuccess' as const;
    export const settingsTenantExportImportButton = 'modules:settings.tenantExport.importButton' as const;
    export const settingsTenantExportImportFailed = 'modules:settings.tenantExport.importFailed' as const;
    export const settingsTenantExportImportSuccess = 'modules:settings.tenantExport.importSuccess' as const;
    export const settingsTenantExportImportSummaryTitle = 'modules:settings.tenantExport.importSummaryTitle' as const;
    export const settingsTenantExportIncludeKb = 'modules:settings.tenantExport.includeKb' as const;
    export const settingsTenantExportNoCompany = 'modules:settings.tenantExport.noCompany' as const;
    export const settingsTenantExportSummaryCompany = 'modules:settings.tenantExport.summary.company' as const;
    export const settingsTenantExportSummaryConnectors = 'modules:settings.tenantExport.summary.connectors' as const;
    export const settingsTenantExportSummaryCreated = 'modules:settings.tenantExport.summary.created' as const;
    export const settingsTenantExportSummaryDataSources = 'modules:settings.tenantExport.summary.dataSources' as const;
    export const settingsTenantExportSummaryImported = 'modules:settings.tenantExport.summary.imported' as const;
    export const settingsTenantExportSummaryKnowledgeBase = 'modules:settings.tenantExport.summary.knowledgeBase' as const;
    export const settingsTenantExportSummaryPlatformIntegrations = 'modules:settings.tenantExport.summary.platformIntegrations' as const;
    export const settingsTenantExportSummarySettings = 'modules:settings.tenantExport.summary.settings' as const;
    export const settingsTenantExportSummarySkipped = 'modules:settings.tenantExport.summary.skipped' as const;
    export const settingsTenantExportSummaryUpdated = 'modules:settings.tenantExport.summary.updated' as const;
    export const settingsTenantExportSummaryUsers = 'modules:settings.tenantExport.summary.users' as const;
    export const settingsTenantExportTitle = 'modules:settings.tenantExport.title' as const;
    export const settingsTitle = 'modules:settings.title' as const;
    export const userManagementCreate = 'modules:userManagement.create' as const;
    export const userManagementCreateFailed = 'modules:userManagement.createFailed' as const;
    export const userManagementCreateModalCancel = 'modules:userManagement.createModal.cancel' as const;
    export const userManagementCreateModalOk = 'modules:userManagement.createModal.ok' as const;
    export const userManagementCreateModalTitle = 'modules:userManagement.createModal.title' as const;
    export const userManagementCreateSuccess = 'modules:userManagement.createSuccess' as const;
    export const userManagementFetchFailed = 'modules:userManagement.fetchFailed' as const;
    export const userManagementFormDisplayName = 'modules:userManagement.form.displayName' as const;
    export const userManagementFormMaxSessions = 'modules:userManagement.form.maxSessions' as const;
    export const userManagementFormPassword = 'modules:userManagement.form.password' as const;
    export const userManagementFormUsername = 'modules:userManagement.form.username' as const;
    export const userManagementNoPermission = 'modules:userManagement.noPermission' as const;
    export const userManagementRefresh = 'modules:userManagement.refresh' as const;
    export const userManagementTitle = 'modules:userManagement.title' as const;
    export const userManagementUsernameExists = 'modules:userManagement.usernameExists' as const;
  }

  export namespace Components {
    export const navigationAgentConfig = 'components:navigation.agentConfig' as const;
    export const navigationChatbot = 'components:navigation.chatbot' as const;
    export const navigationCompanies = 'components:navigation.companies' as const;
    export const navigationConnectors = 'components:navigation.connectors' as const;
    export const navigationDashboard = 'components:navigation.dashboard' as const;
    export const navigationHistory = 'components:navigation.history' as const;
    export const navigationKnowledge = 'components:navigation.knowledge' as const;
    export const navigationOrders = 'components:navigation.orders' as const;
    export const navigationProfile = 'components:navigation.profile' as const;
    export const navigationSettings = 'components:navigation.settings' as const;
    export const navigationUsermanagement = 'components:navigation.user_management' as const;
    export const sidebarCollapse = 'components:sidebar.collapse' as const;
    export const sidebarExpand = 'components:sidebar.expand' as const;
  }

  export namespace Errors {
    export const apiBadRequest = 'errors:api.badRequest' as const;
    export const apiConfigError = 'errors:api.configError' as const;
    export const apiForbidden = 'errors:api.forbidden' as const;
    export const apiNetworkDisconnected = 'errors:api.networkDisconnected' as const;
    export const apiNetworkError = 'errors:api.networkError' as const;
    export const apiNotFound = 'errors:api.notFound' as const;
    export const apiRequestFailed = 'errors:api.requestFailed' as const;
    export const apiRequestFailedWithStatus = 'errors:api.requestFailedWithStatus' as const;
    export const apiServerError = 'errors:api.serverError' as const;
    export const apiServiceUnavailable = 'errors:api.serviceUnavailable' as const;
    export const apiUnauthorized = 'errors:api.unauthorized' as const;
    export const forbidden = 'errors:forbidden' as const;
    export const network = 'errors:network' as const;
    export const notFound = 'errors:notFound' as const;
    export const server = 'errors:server' as const;
    export const timeout = 'errors:timeout' as const;
    export const unauthorized = 'errors:unauthorized' as const;
    export const unknown = 'errors:unknown' as const;
    export const validation = 'errors:validation' as const;
  }

  export namespace Validation {
    // 无键
  }
}